import RoleHub from "./RoleHub.jsx";
import { supabase } from "./supabaseClient.js";
import { toast } from "./toast.js";
import React, { useState, useRef, useEffect } from "react";
const TeamsHubPage = React.lazy(() => import("./TeamsHub.jsx"));
const PlatformPage = React.lazy(() => import("./PlatformPanel.jsx"));
const AppManagePage = React.lazy(() => import("./AppManage.jsx"));
import UIDebugPanel from "./UIDebugPanel.jsx";
import UIControl from "./UIControl.jsx";
import Settings2 from "./Settings2.jsx";
import { useAuth } from "./auth.jsx";
let XLSX = null;
const ensureXLSX = async () => { if (!XLSX) { XLSX = await import("xlsx"); } };
import ToolsLauncher from "./ToolsLauncher.jsx";
const ContractScanner = __lazy(() => import("./ContractScanner.jsx"));
const WordCounter = __lazy(() => import("./WordCounter.jsx"));
const VersionDiff = __lazy(() => import("./VersionDiff.jsx"));
import {
  Feather, BookOpen, Library, BookMarked, Building2,
  Stamp, ScrollText, PenTool, Globe, Sparkles,
  Languages, Calendar, Plus, X, Check, Pencil, Search,
  FileText, NotebookPen, Type, FileCheck,
  Archive, Trash2, RotateCcw,
  Upload, Download, Paperclip, Image as ImageIcon, FileSpreadsheet, Megaphone, BarChart3, ClipboardCheck, Settings, Wallet, Truck, Printer, Banknote, Users, ChevronRight, CalendarDays, CalendarClock, Save, Database,
} from "lucide-react";

const DEFAULT_VERSE = "إِذا غامَرْتَ في شَرَفٍ مَرومٍ\u00A0\u00A0◆\u00A0\u00A0فَلا تَقنَعْ بما دونَ النّجومِ";

import TmSelect from "./TmSelect.jsx";
import { orgDesktopBackup, uploadBookFile, bookFileUrl, downloadStoredFile, saveStoredFile } from "./desktopBackup.js";
import { lazy as __lazy, Suspense as __Suspense } from "react";

export const TITLE_THEMES = {
  rainbow:{ name: "قوس قزح", grad: "linear-gradient(90deg,#e23d3d,#f59e0b,#e8ff00,#16a34a,#14b8a6,#0ea5e9,#7c3aed)", text: "#0b3b36", rainbow: true, accent: "#14b8a6" },
  neon:   { name: "فسفوري", grad: "linear-gradient(90deg,#14b8a6 0%,#e8ff00 50%,#14b8a6 100%)", text: "#0b3b36", accent: "#14b8a6" },
  crimson:{ name: "أحمر",   grad: "linear-gradient(90deg,#9a1b3a 0%,#ff8585 50%,#9a1b3a 100%)", text: "#4a0a18", accent: "#e23d3d" },
  gold:   { name: "ذهبي",   grad: "linear-gradient(90deg,#ffa751 0%,#ffe259 50%,#ffa751 100%)", text: "#5a3b00", accent: "#f59e0b" },
  violet: { name: "بنفسجي", grad: "linear-gradient(90deg,#7c3aed 0%,#c084fc 50%,#7c3aed 100%)", text: "#2e1065", accent: "#7c3aed" },
  ocean:  { name: "فيروزي", grad: "linear-gradient(90deg,#0ea5e9 0%,#5eead4 50%,#0ea5e9 100%)", text: "#06323b", accent: "#0ea5e9" },
  sky:    { name: "سماوي",  grad: "linear-gradient(90deg,#2563eb 0%,#93c5fd 50%,#2563eb 100%)", text: "#0c2a5e", accent: "#2563eb" },
  emerald:{ name: "زمرّدي", grad: "linear-gradient(90deg,#059669 0%,#6ee7b7 50%,#059669 100%)", text: "#04331f", accent: "#059669" },
  rose:   { name: "وردي",   grad: "linear-gradient(90deg,#be185d 0%,#fda4d4 50%,#be185d 100%)", text: "#5e0b31", accent: "#be185d" },
  sunset: { name: "غروب",   grad: "linear-gradient(90deg,#f6416c 0%,#fda085 50%,#f6416c 100%)", text: "#5c1a0b", accent: "#f6416c" },
  night:  { name: "ليلي",   grad: "linear-gradient(90deg,#0b3b36 0%,#14b8a6 50%,#0b3b36 100%)", text: "#e8fff7", accent: "#14b8a6" },
  slate:  { name: "رماديّ", grad: "linear-gradient(90deg,#334155 0%,#94a3b8 50%,#334155 100%)", text: "#16202e", accent: "#475569" },
  kuwait: { name: "ليل الكويت", grad: "linear-gradient(90deg,#0f2027 0%,#2c5364 50%,#0f2027 100%)", text: "#e6f4ff", accent: "#22d3ee" },
  gulf:   { name: "فجر الخليج", grad: "linear-gradient(90deg,#355c7d 0%,#f67280 50%,#355c7d 100%)", text: "#3b1220", accent: "#f67280" },
  dusk:   { name: "غسق نيلي", grad: "linear-gradient(90deg,#2b5876 0%,#7a4b8f 50%,#2b5876 100%)", text: "#f3eaff", accent: "#a78bfa" },
  desert: { name: "صحراء تغرب", grad: "linear-gradient(90deg,#904e95 0%,#e96443 50%,#904e95 100%)", text: "#3a0f14", accent: "#fb923c" },
  wave:   { name: "موجة البيت", grad: "linear-gradient(90deg,#0f766e 0%,#5eead4 50%,#0f766e 100%)", text: "#04251f", accent: "#14b8a6" },
  ink:    { name: "أسود سادة", grad: "linear-gradient(90deg,#111318 0%,#111318 100%)", text: "#f5f8ff", accent: "#14b8a6" },
  paper:  { name: "أبيض سادة", grad: "linear-gradient(90deg,#ffffff 0%,#ffffff 100%)", text: "#0c1330", accent: "#14b8a6" }
};
let _activeTheme = { rainbow: true, accent: "#14b8a6" };
let _showCardBorder = true;
const onAccent = (hex) => { try { const h = String(hex).replace("#", ""); const r = parseInt(h.slice(0,2),16), g = parseInt(h.slice(2,4),16), b = parseInt(h.slice(4,6),16); return (0.299*r + 0.587*g + 0.114*b) > 150 ? "#0b1020" : "#ffffff"; } catch { return "#0b1020"; } };

/* ============================================================
   نظام مدير المشاريع - دلال نصرالله / ترجمتك
   هوية غلاف «دفتر تداول دلال»: خلفية داكنة · Instrument Serif · Shimmer وردي/فوشي · توهّج نابض
   التنقّل: الغلاف ← الوكالات ودور النشر ← مشاريع كل جهة
   ============================================================ */

const C = {
  bg: "#f5f8ff", bg2: "#eef3fd", surface: "#ffffff", surfaceHi: "#eef3fd",
  line: "#d8e2f5", lineHi: "#b7caee",
  paper: "#f5f8ff", grid: "#cdd9f2",
  pinkSoft: "#b794f6", pink: "#7c3aed", fuchsia: "#8a1c3b",
  teal: "#14b8a6",
  text: "#1b2440", muted: "rgba(27,36,64,0.82)", faint: "rgba(27,36,64,0.55)",
};
const arab = "'Tajawal', sans-serif";
const mono = "'IBM Plex Mono', monospace";

const ICON_MAP = { Feather, BookOpen, Library, BookMarked, Building2, Stamp, ScrollText, PenTool, Globe, Sparkles, Languages, FileText, NotebookPen, Type, FileCheck };
const ICON_KEYS = ["Feather", "BookOpen", "Library", "BookMarked", "Building2", "Stamp", "ScrollText", "PenTool", "Globe", "Sparkles"];
const PROJECT_ICONS = ["Languages", "FileText", "ScrollText", "BookOpen", "PenTool", "NotebookPen", "Type", "FileCheck", "Feather", "Stamp"];
const SWATCHES = [C.pink, C.fuchsia, "#a855f7", "#9a1b3a", "#f59e0b", "#22d3ee"];
const DOT_SWATCHES = ["rainbow", "#e23d3d", "#f59e0b", "#e8ff00", "#16a34a", "#14b8a6", "#0ea5e9", "#7c3aed"];
const RAINBOW_CSS = "linear-gradient(90deg,#e23d3d,#f59e0b,#e8ff00,#16a34a,#14b8a6,#0ea5e9,#7c3aed)";

// تصدير متوافق مع سطح المكتب: في Tauri يكتب الملف عبر نافذة حفظ ماك؛ في المتصفّح تنزيل عادي
async function pmExportWorkbook(wb, filename) { await ensureXLSX();
  const name = filename.endsWith(".xlsx") ? filename : filename + ".xlsx";
  if (typeof window !== "undefined" && window.pmSaveBytes) {
    try {
      const data = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      window.pmSaveBytes(name, new Uint8Array(data));
    } catch (e) { console.error("export", e); }
  } else {
    XLSX.writeFile(wb, name);
  }
}

// ====== تخزين الملفّات كملفّات حقيقية على القرص (سطح المكتب) ======
const FILE_FIELDS = ["coverAr", "coverFr", "contractAuthor", "contractTrans1", "contractPublisher", "printOfferFile"];
const FILE_LABELS = { coverAr: "غلاف الكتاب العربي", coverFr: "غلاف الكتاب الأجنبي", contractAuthor: "عقد المؤلف", contractTrans1: "عقد الترجمة", contractPublisher: "عقد الناشر", printOfferFile: "ملف عرض الطباعة" };
const fileSan = (x) => String(x || "").replace(/[\/\\:*?"<>|]/g, "_").replace(/\s+/g, " ").trim().slice(0, 80) || "_";
const fileExt = (n) => (n && n.includes(".")) ? n.slice(n.lastIndexOf(".")) : "";
const fileFp = (d) => d ? (d.length + ":" + d.slice(0, 40) + d.slice(-20)) : "";
const fileDiskFp = new Map();

async function externalizeForSave(pubs) {
  const canDisk = typeof window !== "undefined" && window.pmWriteFileB64;
  const clone = JSON.parse(JSON.stringify(pubs));
  if (!canDisk) return clone;
  const handle = async (holder, fkey, rel) => {
    const f = holder[fkey];
    if (f && typeof f === "object" && f.data) {
      const fp = fileFp(f.data);
      if (fileDiskFp.get(rel) !== fp) { const ok = await window.pmWriteFileB64(rel, f.data); if (ok) fileDiskFp.set(rel, fp); }
      holder[fkey] = { name: f.name, type: f.type, path: rel };
    }
  };
  for (const pub of clone) for (const proj of (pub.projects || [])) for (const book of (proj.works || [])) {
    const base = "ملفات/" + fileSan(proj.name) + "/" + fileSan(book.name);
    for (const key of FILE_FIELDS) {
      const f = book[key];
      if (f && typeof f === "object" && f.data) await handle(book, key, base + "/" + fileSan(FILE_LABELS[key] || key) + fileExt(f.name));
    }
    if (Array.isArray(book.filesTrash)) for (const item of book.filesTrash) {
      const f = item.file;
      if (f && typeof f === "object" && f.data) await handle(item, "file", base + "/سلة/" + fileSan((item.label || item.slot || "ملف") + "-" + (item.id || "")) + fileExt(f.name));
    }
  }
  return clone;
}

async function hydrateAfterLoad(pubs) {
  const canDisk = typeof window !== "undefined" && window.pmReadFileB64;
  if (!canDisk) return pubs;
  const load = async (f) => {
    if (f && typeof f === "object" && f.path && !f.data) {
      const b64 = await window.pmReadFileB64(f.path);
      if (b64 != null) { f.data = "data:" + (f.type || "application/octet-stream") + ";base64," + b64; fileDiskFp.set(f.path, fileFp(f.data)); }
    }
  };
  for (const pub of pubs) for (const proj of (pub.projects || [])) for (const book of (proj.works || [])) {
    for (const key of FILE_FIELDS) await load(book[key]);
    if (Array.isArray(book.filesTrash)) for (const item of book.filesTrash) await load(item.file);
  }
  return pubs;
}
const LANGS = ["إنجليزية", "صينية", "ألبانية", "فارسية", "كورية", "إسبانية", "تركية", "كردية", "بلغارية", "صربية"];

// ملفات الكتاب: أغلفة + عقود
const FILE_SLOTS = [
  { key: "coverAr", label: "غلاف الكتاب العربي", image: true },
  { key: "coverFr", label: "غلاف الكتاب الأجنبي", image: true },
  { key: "contractAuthor", label: "عقد المؤلف" },
  { key: "contractTrans1", label: "عقد الترجمة" },
  { key: "contractPublisher", label: "عقد الناشر" },
  { key: "printOfferFile", label: "ملف عرض الطباعة" },
];

// أعمدة التصدير إلى Excel
const EXPORT_COLUMNS = [
  { key: "agency", group: "الكتاب", label: "الوكالة", get: (r) => r.agency },
  { key: "project", group: "الكتاب", label: "المشروع", get: (r) => r.project },
  { key: "name", group: "الكتاب", label: "اسم الكتاب بالعربية", get: (r) => r.name },
  { key: "nameFr", group: "الكتاب", label: "اسم الكتاب المترجَم", get: (r) => r.nameFr },
  { key: "lang", group: "الكتاب", label: "اللغة المترجَم إليها", get: (r) => r.lang },
  { key: "date", group: "الكتاب", label: "التاريخ", get: (r) => fmtDate(r.date) },
  { key: "authorName", group: "جهات الاتصال", label: "اسم الكاتب", get: (r) => r.authorName },
  { key: "authorEmail", group: "جهات الاتصال", label: "إيميل الكاتب", get: (r) => r.authorEmail },
  { key: "authorPhone", group: "جهات الاتصال", label: "هاتف الكاتب", get: (r) => r.authorPhone },
  { key: "transName", group: "جهات الاتصال", label: "اسم المترجم", get: (r) => r.transName },
  { key: "transNat", group: "جهات الاتصال", label: "جنسية المترجم", get: (r) => r.transNat },
  { key: "transEmail", group: "جهات الاتصال", label: "إيميل المترجم", get: (r) => r.transEmail },
  { key: "transPhone", group: "جهات الاتصال", label: "هاتف المترجم", get: (r) => r.transPhone },
  { key: "fee2", group: "النشر والأجور", label: "أجر المترجم", get: (r) => r.fee2 },
  { key: "isbnAr", group: "النشر والأجور", label: "الردمك العربي", get: (r) => r.isbnAr },
  { key: "isbnFr", group: "النشر والأجور", label: "الردمك الأجنبي", get: (r) => r.isbnFr },
  { key: "pubAr", group: "النشر والأجور", label: "دار النشر العربية", get: (r) => r.pubAr },
  { key: "pubFrHouse", group: "النشر والأجور", label: "دار النشر الأجنبية", get: (r) => r.pubFrHouse },
  { key: "pubFrName", group: "النشر والأجور", label: "اسم الناشر", get: (r) => r.pubFrName },
  { key: "pubFrEmail", group: "النشر والأجور", label: "إيميل الناشر", get: (r) => r.pubFrEmail },
  { key: "printOffer", group: "النشر والأجور", label: "قيمة عرض الطباعة", get: (r) => r.printOffer },
];
const DEFAULT_COLS = ["project", "name", "lang", "authorName", "transName"];

// أقسام تقرير متابعة التوزيع والتسويق
const MK = [
  { key: "basic", n: "القسم الأول: معلومات الكتاب الأساسية", type: "book",
    derived: [{ label: "اسم الكاتب", get: (b) => b.authorName }, { label: "العنوان المترجَم", get: (b) => b.nameFr }, { label: "اللغة", get: (b) => b.lang }],
    cols: [{ k: "category", label: "التصنيف" }, { k: "year", label: "سنة النشر" }, { k: "isbn", label: "ISBN" }] },
  { key: "stores", n: "القسم الثاني: متاجر البيع الإلكترونية وروابطها", type: "book",
    cols: [{ k: "publisher", label: "موقع الناشر" }, { k: "amazon", label: "أمازون" }, { k: "abjad", label: "أبجد" }, { k: "neel", label: "نيل وفرات" }, { k: "store1", label: "متجر إضافي 1" }, { k: "store2", label: "متجر إضافي 2" }] },
  { key: "libraries", n: "القسم الثالث: المكتبات الحقيقية", type: "book",
    cols: [{ k: "lib1", label: "مكتبة 1" }, { k: "addr1", label: "عنوان 1" }, { k: "lib2", label: "مكتبة 2" }, { k: "addr2", label: "عنوان 2" }, { k: "lib3", label: "مكتبة 3" }, { k: "notes", label: "ملاحظات" }] },
  { key: "reviews", n: "القسم الرابع: المراجعات", type: "book",
    cols: [{ k: "link1", label: "رابط مراجعة 1" }, { k: "author1", label: "الكاتب" }, { k: "link2", label: "رابط مراجعة 2" }, { k: "author2", label: "الكاتب" }, { k: "printed", label: "مراجعات ورقية؟" }, { k: "printDetails", label: "تفاصيل المطبوعة" }] },
  { key: "academic", n: "القسم الخامس: التوزيع الأكاديمي والنسخ المهداة", type: "book",
    cols: [{ k: "distributed", label: "وُزّع على جامعات؟" }, { k: "universities", label: "الجامعات/الأقسام" }, { k: "gifted", label: "عدد النسخ المهداة" }, { k: "links", label: "روابط مراجعات أكاديمية" }, { k: "notes", label: "ملاحظات" }] },
  { key: "digital", n: "القسم السادس: منصات التسويق الرقمي", type: "book",
    cols: [{ k: "facebook", label: "فيسبوك" }, { k: "twitter", label: "تويتر/X" }, { k: "tiktok", label: "تيكتوك" }, { k: "instagram", label: "إنستغرام" }, { k: "youtube", label: "يوتيوب" }, { k: "notes", label: "ملاحظات" }] },
  { key: "fairs", n: "القسم السابع: المشاركة في المعارض", type: "fairs",
    cols: [{ k: "name", label: "اسم المعرض" }, { k: "date", label: "التاريخ" }, { k: "location", label: "الموقع" }, { k: "booth", label: "رقم الجناح" }, { k: "books", label: "الكتب المعروضة" }, { k: "signings", label: "حفلات التوقيع" }, { k: "photos", label: "صور (رابط)" }] },
  { key: "sales", n: "القسم الثامن: تقدير المبيعات وحالة التوزيع", type: "book",
    cols: [{ k: "estimate", label: "المبيعات المقدّرة" }, { k: "source", label: "مصدر التقدير" }, { k: "coverLink", label: "رابط الغلاف" }, { k: "fairPhotos", label: "صور المعارض" }, { k: "status", label: "حالة التوزيع" }, { k: "notes", label: "ملاحظات" }] },
  { key: "awards", n: "القسم التاسع: التقديم لجوائز الترجمة", type: "book",
    cols: [{ k: "award", label: "اسم الجائزة" }, { k: "date", label: "تاريخ التقديم" }, { k: "status", label: "الحالة" }, { k: "notes", label: "ملاحظات" }] },
];
const MK_CONTACT = [
  { k: "email", label: "البريد الإلكتروني" }, { k: "website", label: "الموقع الإلكتروني" },
  { k: "facebook", label: "فيسبوك" }, { k: "twitter", label: "تويتر/X" },
  { k: "hq", label: "المقر" }, { k: "gm", label: "المدير العام" }, { k: "languages", label: "اللغات" },
];

// نظام التسليمات (مرتبط بكل كتاب) - ثلاثة أطراف
const DELIV = [
  { key: "translator", title: "المترجم", items: [
    { k: "contractSigned", label: "تسليم العقد بعد التوقيع", file: true },
    { k: "contractResent", label: "إعادة إرساله للمترجم بعد التوقيع", file: true },
    { k: "draft1", label: "استلام المسودة الأولى", file: true },
    { k: "feeTransfer", label: "تحويل الأجر للمترجم", amount: true },
    { k: "feeReceipt", label: "وصل التحويل", file: true },
    { k: "draftRevised", label: "استلام المسودة بعد التعديل", file: true },
  ] },
  { key: "publisher", title: "الناشر", items: [
    { k: "cover", label: "استلام الغلاف", file: true },
    { k: "bookAfterLayout", label: "استلام الكتاب بعد الإخراج", file: true },
    { k: "isbn", label: "استلام الردمك" },
    { k: "copies50", label: "استلام 50 نسخة" },
    { k: "marketingPlan", label: "استلام خطة التسويق", file: true },
    { k: "print50Before", label: "تسليم 50٪ من مبلغ الطباعة (إن لزم)", amount: true },
    { k: "print50After", label: "تسليم 50٪ من مبلغ الطباعة بعد استلام الكتب", amount: true },
    { k: "printReceipt", label: "رفع الوصل", file: true },
    { k: "settlement", label: "مخالصة مع الناشر", file: true },
  ] },
  { key: "authority", title: "الهيئة", items: [
    { k: "coverDeliver", label: "تسليم الغلاف", file: true },
    { k: "draftBefore", label: "تسليم المسودة قبل التعديل", file: true },
    { k: "draftAfter", label: "تسليم المسودة بعد التعديل", file: true },
    { k: "coverFinal", label: "تسليم الغلاف النهائي", file: true },
    { k: "settlementTrans", label: "المخالصة مع المترجم", file: true },
    { k: "isbnDeliver", label: "تسليم الردمك" },
    { k: "copies50Deliver", label: "تسليم 50 نسخة" },
  ] },
];
const delivItem = (book, sec, k) => (((book.deliveries || {})[sec] || {})[k]) || {};
const sectionDone = (book, sec) => { const s = DELIV.find((x) => x.key === sec); return s.items.length > 0 && s.items.every((it) => delivItem(book, sec, it.k).done); };
const delivCounts = (book) => {
  let done = 0, total = 0;
  DELIV.forEach((sec) => sec.items.forEach((it) => { total++; if (delivItem(book, sec.key, it.k).done) done++; }));
  return { done, total };
};
const partyCounts = (book, key) => {
  const sec = DELIV.find((s) => s.key === key);
  const done = sec.items.filter((it) => delivItem(book, key, it.k).done).length;
  return { done, total: sec.items.length };
};
const toNum = (v) => { if (!v) return 0; const n = parseFloat(String(v).replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[^\d.]/g, "")); return isNaN(n) ? 0 : n; };
const delivAmount = (book) => toNum(delivItem(book, "translator", "feeTransfer").amount) + toNum(delivItem(book, "publisher", "print50Before").amount) + toNum(delivItem(book, "publisher", "print50After").amount);

// إضافة أعمدة التسليمات والاستلامات إلى مجموعة أعمدة التصدير العامة
EXPORT_COLUMNS.push(
  { key: "d_trans", group: "ملخص التسليمات", label: "تسليمات المترجم", get: (r) => `${partyCounts(r, "translator").done}/6` },
  { key: "d_pub", group: "ملخص التسليمات", label: "تسليمات الناشر", get: (r) => `${partyCounts(r, "publisher").done}/9` },
  { key: "d_auth", group: "ملخص التسليمات", label: "تسليمات الهيئة", get: (r) => `${partyCounts(r, "authority").done}/7` },
  { key: "d_total", group: "ملخص التسليمات", label: "إجمالي الإنجاز", get: (r) => { const c = delivCounts(r); return `${c.done}/${c.total}`; } },
  { key: "d_pct", group: "ملخص التسليمات", label: "النسبة %", get: (r) => { const c = delivCounts(r); return (c.total ? Math.round((c.done / c.total) * 100) : 0) + "%"; } },
  { key: "d_remain", group: "ملخص التسليمات", label: "المتبقّي", get: (r) => { const c = delivCounts(r); return c.total - c.done; } },
  { key: "d_complete", group: "ملخص التسليمات", label: "مكتمل؟", get: (r) => { const c = delivCounts(r); return (c.total > 0 && c.done === c.total) ? "نعم" : "لا"; } },
  { key: "d_amount", group: "ملخص التسليمات", label: "إجمالي المبالغ المسجّلة", get: (r) => delivAmount(r) || "" },
  { key: "ar_contract", group: "استلامات الهيئة", label: "عقد المستفيد", get: (r) => { const a = (r.deliveries || {}).authorityReceipts || {}; return (a.beneficiaryContract && a.beneficiaryContract.done) ? "نعم" : "لا"; } },
  { key: "ar_receipts", group: "استلامات الهيئة", label: "عدد إيصالات الهيئة", get: (r) => (((r.deliveries || {}).authorityReceipts || {}).receipts || []).length },
  { key: "ar_details", group: "استلامات الهيئة", label: "عدد ملفات التحويلات", get: (r) => (((r.deliveries || {}).authorityReceipts || {}).transferDetails || []).length },
);
DELIV.forEach((sec) => sec.items.forEach((it) => {
  EXPORT_COLUMNS.push({
    key: `d_${sec.key}_${it.k}`, group: `تسليمات ${sec.title} (تفصيلي)`, label: it.label,
    get: (r) => { const d = delivItem(r, sec.key, it.k); return it.amount && d.amount ? d.amount : (d.done ? "نعم" : "لا"); },
  });
}));

async function mkExportExcel(project, books, filename, opts) { await ensureXLSX();
  opts = opts || {};
  const secKeys = opts.sections || MK.map((s) => s.key);
  const m = project.marketing || {};
  const aoa = [];
  const pubName = (books.find((b) => b.pubFrHouse) || {}).pubFrHouse || "";
  aoa.push([`تقرير متابعة توزيع وتسويق وبيع كتب - ${pubName || "الناشر"} / ${project.name}`]);
  aoa.push([]);
  aoa.push(["", "تاريخ التقرير:", m.reportDate || "", "اسم المسؤول:", m.manager || ""]);
  MK.filter((s) => secKeys.includes(s.key)).forEach((sec) => {
    aoa.push([]);
    aoa.push([sec.n]);
    if (sec.type === "book") {
      const derived = sec.derived || [];
      aoa.push(["م", "اسم الكتاب", ...derived.map((d) => d.label), ...sec.cols.map((c) => c.label)]);
      books.forEach((b, i) => {
        const cell = ((m[sec.key] || {})[b.id]) || {};
        aoa.push([i + 1, b.name, ...derived.map((d) => d.get(b) || ""), ...sec.cols.map((c) => cell[c.k] || "")]);
      });
    } else {
      aoa.push(["م", ...sec.cols.map((c) => c.label)]);
      (m.fairs || []).forEach((f, i) => aoa.push([i + 1, ...sec.cols.map((c) => f[c.k] || "")]));
    }
  });
  if (opts.includeNotes !== false) {
    aoa.push([]);
    aoa.push(["ملاحظات وجهود تسويقية إضافية:", m.extraNotes || ""]);
  }

  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = new Array(9).fill({ wch: 22 });
  const wb = XLSX.utils.book_new();
  wb.Workbook = { Views: [{ RTL: true }] };
  XLSX.utils.book_append_sheet(wb, ws, "تقرير متابعة التوزيع");

  if (opts.includeContact !== false) {
    const c = m.contact || {};
    const caoa = [["بيانات التواصل مع الناشر"], []];
    MK_CONTACT.forEach((f) => caoa.push([f.label, c[f.k] || ""]));
    const cws = XLSX.utils.aoa_to_sheet(caoa);
    cws["!cols"] = [{ wch: 18 }, { wch: 40 }];
    XLSX.utils.book_append_sheet(wb, cws, "بيانات التواصل");
  }

  pmExportWorkbook(wb, filename);
}

// مساعدات الإحصائيات
function tally(rows, getKey) {
  const m = {};
  rows.forEach((r) => { const k = (getKey(r) || "").toString().trim() || "غير محدد"; m[k] = (m[k] || 0) + 1; });
  return Object.entries(m).sort((a, b) => b[1] - a[1]);
}
function hasAny(o) { return !!o && Object.values(o).some((v) => String(v == null ? "" : v).trim() !== ""); }
function monthKey(iso) { const p = String(iso || "").split("-"); return p.length >= 2 ? p[0] + "-" + p[1] : "غير محدد"; }
function bookMissing(r) {
  const miss = [];
  if (!r.coverFr) miss.push("غلاف مترجم");
  if (!(r.contractAuthor || r.contractTrans1 || r.contractPublisher)) miss.push("عقد");
  if (!(((r.isbnAr || "").trim()) || ((r.isbnFr || "").trim()))) miss.push("ردمك");
  return miss;
}
const mkCell = (r, sec) => (r._marketing && r._marketing[sec] && r._marketing[sec][r.id]);

// تصدير لوحة الإحصائيات (متعدّد الأوراق)
const STAT_SHEETS = [
  { k: "summary", label: "الملخص" },
  { k: "byLang", label: "حسب اللغة" },
  { k: "byAuthor", label: "حسب المؤلف" },
  { k: "byTranslator", label: "حسب المترجم" },
  { k: "publishers", label: "دور النشر" },
  { k: "completeness", label: "اكتمال البيانات" },
  { k: "marketing", label: "حالة التسويق" },
  { k: "timeline", label: "الخط الزمني" },
  { k: "deliveries", label: "التسليمات" },
];

function exportStats(rows, scopedProjects, title, opts) {
  opts = opts || {};
  const sheets = opts.sheets || STAT_SHEETS.map((s) => s.k);
  const want = (k) => sheets.includes(k);
  const wb = XLSX.utils.book_new();
  wb.Workbook = { Views: [{ RTL: true }] };
  const add = (name, aoa, cols) => { const ws = XLSX.utils.aoa_to_sheet(aoa); ws["!cols"] = cols; XLSX.utils.book_append_sheet(wb, ws, name); };
  const langT = tally(rows, (r) => r.lang), authT = tally(rows, (r) => r.authorName), transT = tally(rows, (r) => r.transName);
  const arT = tally(rows, (r) => r.pubAr), frT = tally(rows, (r) => r.pubFrHouse);
  const authors = new Set(rows.map((r) => r.authorName).filter(Boolean));
  const translators = new Set(rows.map((r) => r.transName).filter(Boolean));

  if (want("summary")) {
    const s1 = [[`إحصائيات: ${title}`], [],
      ["إجمالي الكتب", rows.length], ["عدد اللغات", langT.length], ["عدد المشاريع", scopedProjects.length],
      ["عدد المؤلفين", authors.size], ["عدد المترجمين", translators.size], [], ["اللغة", "عدد الكتب"]];
    langT.forEach((e) => s1.push(e));
    const dRows = rows.map((r) => delivCounts(r));
    const oDone = dRows.reduce((s, x) => s + x.done, 0), oTotal = dRows.reduce((s, x) => s + x.total, 0);
    const completed = dRows.filter((x) => x.total > 0 && x.done === x.total).length;
    const notStarted = dRows.filter((x) => x.done === 0).length;
    const amt = rows.reduce((s, r) => s + delivAmount(r), 0);
    s1.push([], ["متابعة التسليمات", ""]);
    s1.push(["نسبة الإنجاز الكلّية", (oTotal ? Math.round((oDone / oTotal) * 100) : 0) + "%"]);
    s1.push(["اكتملت بالكامل", completed]);
    s1.push(["قيد العمل", dRows.length - completed - notStarted]);
    s1.push(["لم تبدأ", notStarted]);
    s1.push(["إجمالي المبالغ المسجّلة", amt]);
    add("الملخص", s1, [{ wch: 26 }, { wch: 14 }]);
  }

  if (want("byLang")) {
    const s2 = [["اللغة", "اسم الكتاب", "اسم المؤلف", "المشروع"]];
    langT.forEach(([l]) => rows.filter((r) => ((r.lang || "غير محدد").trim() || "غير محدد") === l).forEach((r) => s2.push([l, r.name, r.authorName || "", r.project])));
    add("حسب اللغة", s2, [{ wch: 14 }, { wch: 32 }, { wch: 24 }, { wch: 14 }]);
  }
  if (want("byAuthor")) add("حسب المؤلف", [["المؤلف", "عدد الكتب"], ...authT], [{ wch: 28 }, { wch: 12 }]);
  if (want("byTranslator")) add("حسب المترجم", [["المترجم", "عدد الكتب"], ...transT], [{ wch: 28 }, { wch: 12 }]);
  if (want("publishers")) add("دور النشر", [["دار النشر العربية", "عدد الكتب"], ...arT, [], ["دار النشر الأجنبية", "عدد الكتب"], ...frT], [{ wch: 28 }, { wch: 12 }]);

  if (want("completeness")) {
    const incomplete = rows.map((r) => ({ r, m: bookMissing(r) })).filter((x) => x.m.length);
    const s6 = [
      ["ناقص غلاف مترجم", rows.filter((r) => !r.coverFr).length],
      ["ناقص عقد", rows.filter((r) => !(r.contractAuthor || r.contractTrans1 || r.contractPublisher)).length],
      ["ناقص ردمك", rows.filter((r) => bookMissing(r).includes("ردمك")).length],
      [], ["اسم الكتاب", "المشروع", "الناقص"],
    ];
    incomplete.forEach((x) => s6.push([x.r.name, x.r.project, x.m.join("، ")]));
    add("اكتمال البيانات", s6, [{ wch: 32 }, { wch: 14 }, { wch: 30 }]);
  }

  if (want("marketing")) {
    const s7 = [["المؤشر", "عدد الكتب"],
      ["في منصّات رقمية", rows.filter((r) => hasAny(mkCell(r, "digital"))).length],
      ["في متاجر إلكترونية", rows.filter((r) => hasAny(mkCell(r, "stores"))).length],
      ["مُرشّح لجوائز", rows.filter((r) => hasAny(mkCell(r, "awards"))).length],
      ["عدد المعارض (مجموع)", scopedProjects.reduce((s, j) => s + ((j.marketing && j.marketing.fairs) ? j.marketing.fairs.length : 0), 0)]];
    add("حالة التسويق", s7, [{ wch: 22 }, { wch: 12 }]);
  }

  if (want("timeline")) {
    const monthT = Object.entries(rows.reduce((m, r) => { const k = monthKey(r.date); m[k] = (m[k] || 0) + 1; return m; }, {})).sort((a, b) => a[0].localeCompare(b[0]));
    add("الخط الزمني", [["الشهر", "عدد الكتب"], ...monthT], [{ wch: 14 }, { wch: 12 }]);
  }

  if (want("deliveries")) {
    const sd = [["اسم الكتاب", "المشروع", "المترجم", "الناشر", "الهيئة", "الإجمالي", "النسبة", "المتبقّي", "مكتمل؟", "عقد المستفيد", "إيصالات الهيئة", "ملفات التحويلات"]];
    rows.forEach((r) => {
      const c = delivCounts(r);
      const t = partyCounts(r, "translator").done, p = partyCounts(r, "publisher").done, a = partyCounts(r, "authority").done;
      const pct = c.total ? Math.round((c.done / c.total) * 100) + "%" : "0%";
      const arr = (r.deliveries || {}).authorityReceipts || {};
      const contract = arr.beneficiaryContract && arr.beneficiaryContract.done ? "نعم" : "لا";
      sd.push([r.name, r.project, `${t}/6`, `${p}/9`, `${a}/7`, `${c.done}/${c.total}`, pct, c.total - c.done, c.done === c.total ? "نعم" : "لا", contract, (arr.receipts || []).length, (arr.transferDetails || []).length]);
    });
    add("التسليمات", sd, [{ wch: 30 }, { wch: 14 }, { wch: 9 }, { wch: 9 }, { wch: 9 }, { wch: 9 }, { wch: 8 }, { wch: 8 }, { wch: 8 }, { wch: 12 }, { wch: 12 }, { wch: 14 }]);
  }

  if (!wb.SheetNames.length) add("الملخص", [["لا فئات مختارة"]], [{ wch: 20 }]);
  const fn = (opts.filename || `إحصائيات_${title}`).replace(/\.xlsx$/i, "");
  pmExportWorkbook(wb, fn);
}

// تجميع صفوف الكتب من الوكالات/المشاريع
function collectRows(publishers) {
  const rows = [];
  (publishers || []).forEach((p) =>
    (p.projects || []).forEach((j) =>
      (j.works || []).forEach((w) => rows.push({ ...w, agency: p.name, project: j.name }))
    )
  );
  return rows;
}

// كتابة ملف Excel فعلي
async function exportToExcel(rows, colKeys, filename) { await ensureXLSX();
  const cols = EXPORT_COLUMNS.filter((c) => colKeys.includes(c.key));
  const aoa = [cols.map((c) => c.label)];
  rows.forEach((r) => aoa.push(cols.map((c) => { const v = c.get(r); return v == null ? "" : v; })));
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = cols.map(() => ({ wch: 22 }));
  const wb = XLSX.utils.book_new();
  wb.Workbook = { Views: [{ RTL: true }] };
  XLSX.utils.book_append_sheet(wb, ws, "الكتب");
  pmExportWorkbook(wb, filename);
}

function downloadFile(file) {
  if (file && file.path && !file.data) { downloadStoredFile(file); return; }
  if (file && file.path && !file.data) { downloadStoredFile(file); return; }
  if (!file || !file.data) return;
  const a = document.createElement("a");
  a.href = file.data; a.download = file.name || "ملف";
  document.body.appendChild(a); a.click(); a.remove();
}

// عارض صور الكتب الموحد: يفهم الصيغة المضمنة (data) والمخزنية (path)
const _bimgCache = (typeof window !== "undefined") ? (window.__bimgCache = window.__bimgCache || {}) : {};
function BookImg({ file, ...rest }) {
  const [u, setU] = useState((file && file.data) || (file && file.path && _bimgCache[file.path]) || null);
  useEffect(() => {
    let live = true;
    if (file && file.data) { setU(file.data); return; }
    if (file && file.path) {
      if (_bimgCache[file.path]) { setU(_bimgCache[file.path]); return; }
      bookFileUrl(file.path).then((url) => { if (url) { _bimgCache[file.path] = url; if (live) setU(url); } });
      return () => { live = false; };
    }
    setU(null);
  }, [file]);
  if (!u) return null;
  return <img src={u} {...rest} />;
}

function askSaveThemed(f) {
  const ov = document.createElement("div");
  ov.style.cssText = "position:fixed;inset:0;z-index:99999;background:rgba(10,14,20,.45);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;";
  const card = document.createElement("div");
  card.style.cssText = "background:var(--panel,#fff);color:var(--ink,#222);border:1.5px solid var(--line,#ddd);border-radius:16px;padding:22px 20px;width:min(92vw,420px);box-shadow:0 18px 60px rgba(0,0,0,.28);font-family:'Cairo','Tajawal',sans-serif;direction:rtl;";
  card.innerHTML = '<div style="font-weight:800;font-size:15.5px;margin-bottom:12px;">تنزيل الملف على جهازك</div>'
    + '<div style="font-size:13px;color:var(--faint,#888);margin-bottom:6px;">اسم الملف</div>'
    + '<input id="pmSaveName" style="width:100%;box-sizing:border-box;padding:10px 12px;border-radius:10px;border:1.5px solid var(--line,#ddd);background:transparent;color:var(--ink,#222);font-family:inherit;font-size:14px;margin-bottom:16px;" />'
    + '<div style="display:flex;gap:10px;">'
    + '<button id="pmSaveGo" style="padding:10px 22px;border-radius:10px;border:none;background:var(--accent,#14b8a6);color:#fff;font-weight:800;font-family:inherit;font-size:14px;cursor:pointer;">تنزيل</button>'
    + '<button id="pmSaveNo" style="padding:10px 18px;border-radius:10px;border:1.5px solid var(--line,#ddd);background:transparent;color:var(--ink,#222);font-family:inherit;font-size:14px;cursor:pointer;">إلغاء</button>'
    + '</div>';
  ov.appendChild(card); document.body.appendChild(ov);
  const inp = card.querySelector("#pmSaveName");
  inp.value = f.name || "ملف";
  const close = () => ov.remove();
  ov.addEventListener("click", (e) => { if (e.target === ov) close(); });
  card.querySelector("#pmSaveNo").onclick = close;
  card.querySelector("#pmSaveGo").onclick = async () => { const nm = inp.value.trim() || f.name || "ملف"; close(); await saveStoredFile(f, nm); };
  inp.focus(); inp.select();
}
const dlAny = (f) => {
  if (!f) return;
  if (f.path && !f.data) { askSaveThemed(f); return; }
  downloadFile(f);
};

// عنصر رفع/معاينة/تنزيل ملف (يُستخدم في نموذج الإضافة والتفاصيل)
function FileSlot({ label, file, onSet, onDelete, image, accent = "#14b8a6" }) {
  const inputRef = useRef(null);
  const pick = (e) => {
    const f = e.target.files[0]; if (!f) return;
    const r = new FileReader();
    r.onload = async () => {
      const raw = { name: f.name, type: f.type, data: r.result };
      try { onSet(await uploadBookFile(raw)); }
      catch (upErr) { alert("فشل رفع الملف للمخزن السحابي:\n" + (upErr && upErr.message ? upErr.message : upErr) + "\nسيحفظ مؤقتا داخل البيانات."); onSet(raw); }
    };
    r.readAsDataURL(f); e.target.value = "";
  };
  const isImg = file && (file.type || "").startsWith("image");
  const [fsUrl, setFsUrl] = useState(null);
  useEffect(() => {
    let live = true;
    if (file && file.path && !file.data) { bookFileUrl(file.path).then((u) => { if (live) setFsUrl(u); }); }
    else setFsUrl(null);
    return () => { live = false; };
  }, [file]);
  return (
    <div style={SF.slot}>
      <span style={SF.slotLabel}>{label}</span>
      {file ? (
        <div style={SF.chip}>
          {image && isImg
            ? <img src={file.data || fsUrl} alt="" style={SF.thumb} />
            : <span style={{ ...SF.fileIco, color: accent }}><Paperclip size={16} /></span>}
          <span style={SF.fileName}>{file.name}</span>
          <button className="ghost" style={SF.fbtn} onClick={() => dlAny(file)}><Download size={14} /></button>
          {onDelete
            ? <button className="ghost" style={{ ...SF.fbtn, color: "#e23d3d" }} onClick={onDelete}><Trash2 size={14} /></button>
            : <button className="ghost" style={SF.fbtn} onClick={() => onSet(null)}><X size={14} /></button>}
        </div>
      ) : (
        <>
          <button className="ghost" style={{ ...SF.upBtn, color: accent, borderColor: accent }} onClick={() => inputRef.current && inputRef.current.click()}>
            <Upload size={16} /> رفع ملف
          </button>
          <input ref={inputRef} type="file" onChange={pick} style={{ display: "none" }} />
        </>
      )}
    </div>
  );
}

const AR_DIGITS = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
const AR_MONTHS = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
const VIEWS = [
  { key: null, label: "الكل" },
  { key: "cover", label: "الغلاف المترجم" },
  { key: "author", label: "الكاتب", field: "authorName" },
  { key: "lang", label: "اللغة", field: "lang" },
  { key: "pub", label: "دار النشر", field: "pubAr" },
  { key: "trans", label: "المترجم", field: "transName" },
];
// أرقام إنجليزية في كل التطبيق
const toAr = (s) => String(s);
const fmtDate = (iso) => {
  if (!iso) return "-";
  const [y, m, d] = iso.split("-");
  return `${toAr(d)} ${AR_MONTHS[+m - 1]} ${toAr(y)}`;
};
const today = () => new Date().toISOString().slice(0, 10);

function Icon({ name, size = 28, color }) {
  const Cmp = ICON_MAP[name] || BookOpen;
  return <Cmp size={size} color={"var(--accent)"} />;
}
function ProjIcon({ img, name, size = 28, color }) {
  if (img) return <img src={img} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit", display: "block" }} />;
  return <Icon name={name} size={size} color={"var(--accent)"} />;
}
// أيقونة الكتاب = الصورة المختارة، وإلا صورة الغلاف الأجنبي إن كانت صورة
const bookIcon = (b) => { if (!b) return null; if (b.iconImg) return b.iconImg; const c = b.coverFr; if (!c) return null; if (c.data && String(c.data).startsWith("data:")) return c.data; if (c.path) { if (_bimgCache[c.path]) return _bimgCache[c.path]; try { bookFileUrl(c.path).then((url) => { if (url) { _bimgCache[c.path] = url; try { window.dispatchEvent(new CustomEvent("tpms:bimg-ready")); } catch {} } }); } catch {} return null; } return null; };
function CardBorder({ dot, radius = 12 }) {
  const stroke = _activeTheme.rainbow ? "url(#pmRainbow)" : _activeTheme.accent;
  return (
    <svg aria-hidden="true" className="pm-cardborder" width="100%" height="100%" style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "visible", zIndex: 0 }}>
      <rect fill="none" rx={radius} ry={radius} stroke={stroke} strokeWidth="3" strokeDasharray="1.5 6.5" strokeLinecap="round"
        style={{ x: "1.5px", y: "1.5px", width: "calc(100% - 3px)", height: "calc(100% - 3px)" }} />
    </svg>
  );
}

export default function ProjectManager() {
  const { readOnly, me, role, users, setAssignment, isManager, signOut } = useAuth();
  const [page, setPage] = useState(() => { try { const p = sessionStorage.getItem("tpms_page") || "cover"; return ["works", "marketing", "deliveries", "finance"].includes(p) ? "projects" : (p === "projects" ? "publishers" : p); } catch { return "cover"; } });
  useEffect(() => {
    const h = (e) => { if (e.detail === "teams" || e.detail === "platform" || e.detail === "appmanage" || e.detail === "writers" || e.detail === "pubs") setPage(e.detail); };
    window.addEventListener("tpms:goto-page", h);
    return () => window.removeEventListener("tpms:goto-page", h);
  }, []);
  useEffect(() => { try { sessionStorage.setItem("tpms_page", page); } catch {} }, [page]);        // cover | publishers | projects | works | marketing | deliveries | stats
  const [curPub, setCurPub] = useState(null);       // id الوكالة المفتوحة
  const [curProj, setCurProj] = useState(null);     // id المشروع المفتوح
  const [editMode, setEditMode] = useState(false);
  const [groupBy, setGroupBy] = useState(null); // null | cover | author | lang | pub | trans
  const [showSettings, setShowSettings] = useState(false);
  const [showSettings2, setShowSettings2] = useState(false);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [settings, setSettings] = useState({ text: DEFAULT_VERSE, size: 19, theme: "neon", rotate: false });
  const [appTitle, setAppTitle] = useState("مشاريع ترجمة");
  useEffect(() => { (async () => { try { if (typeof window !== "undefined" && window.storage) { const r = await window.storage.get("pm:appTitle"); if (r && r.value) setAppTitle(r.value); } } catch {} })(); }, []);
  useEffect(() => { (async () => { try { const { supabase } = await import("./supabaseClient.js"); const { data } = await supabase.from("organizations").select("app_title").limit(1).maybeSingle(); if (data && data.app_title) { setAppTitle(data.app_title); setTimeout(() => { try { window.storage && window.storage.set("pm:appTitle", data.app_title); } catch {} }, 1500); } } catch {} })(); }, []);
  const saveAppTitle = (name) => { const v = (name || "").trim() || "مشاريع ترجمة"; setAppTitle(v); try { if (typeof window !== "undefined" && window.storage) window.storage.set("pm:appTitle", v); } catch {} (async () => { try { const { supabase } = await import("./supabaseClient.js"); await supabase.rpc("set_app_title", { p_title: v }); } catch {} })(); };
  const [coverTitle, setCoverTitle] = useState("نظام إدارة مشاريع الترجمة");
  const [isAppOwner, setIsAppOwner] = useState(false);
  useEffect(() => { (async () => { try { const { supabase } = await import("./supabaseClient.js"); const { data: ct } = await supabase.rpc("get_cover_title"); if (ct) setCoverTitle(ct); const { data: ud } = await supabase.auth.getUser(); const uid = ud && ud.user && ud.user.id; if (uid) { const { data: p } = await supabase.from("profiles").select("is_owner").eq("id", uid).maybeSingle(); setIsAppOwner(!!(p && p.is_owner)); } } catch {} })(); }, []);
  const saveCoverTitle = (name) => { const v = (name || "").trim() || "نظام إدارة مشاريع الترجمة"; setCoverTitle(v); (async () => { try { const { supabase } = await import("./supabaseClient.js"); await supabase.rpc("set_cover_title", { p_title: v }); } catch {} })(); };
  useEffect(() => { const t = (appTitle && appTitle.trim()) || (coverTitle && coverTitle.trim()) || "نظام إدارة مشاريع الترجمة"; document.title = t; }, [appTitle, coverTitle]);

  // ═══ قراءة إعدادات الواجهة من platform_ui_settings + Realtime ═══
  useEffect(() => {
    const applyUISettings = (v) => {
      if (!v) return;
      const r = document.documentElement;
      const isDark = r.getAttribute("data-theme") === "dark";
      const _eff = v.paper;
      if (_eff) {
        r.style.setProperty("--paper", _eff);
        r.style.setProperty("--bg", _eff);
        r.style.setProperty("--bg2", _eff);
        r.style.setProperty("--surface", _eff);
        r.style.setProperty("--surfaceHi", _eff);
        document.body.style.background = _eff;
        try {
          const h0 = String(_eff).replace("#", "");
          const h6 = h0.length === 3 ? h0.split("").map((x) => x + x).join("") : h0;
          const R = parseInt(h6.slice(0, 2), 16) / 255, G = parseInt(h6.slice(2, 4), 16) / 255, B = parseInt(h6.slice(4, 6), 16) / 255;
          const lum = 0.2126 * R + 0.7152 * G + 0.0722 * B;
          if (v.glassMode === "manual" && v.glassAlpha) {
            r.style.setProperty("--modal-alpha", v.glassAlpha + "%");
          } else {
            r.style.setProperty("--modal-alpha", (lum < 0.35 || lum > 0.85) ? "93%" : "84%");
          }
          if (lum < 0.5) {
            r.style.setProperty("--text", v.textDark || "#f5f8ff");
            r.style.setProperty("--muted", "rgba(245,248,255,0.88)");
            r.style.setProperty("--faint", "rgba(245,248,255,0.68)");
            r.style.setProperty("--line", "rgba(255,255,255,0.26)");
            r.style.setProperty("--lineHi", "rgba(255,255,255,0.4)");
            r.style.setProperty("--bg2", "color-mix(in srgb, " + _eff + " 88%, #ffffff)");
            r.style.setProperty("--surfaceHi", "color-mix(in srgb, " + _eff + " 82%, #ffffff)");
            r.style.setProperty("--surface", "color-mix(in srgb, " + _eff + " 90%, #ffffff)");
          } else {
            r.style.setProperty("--text", v.textLight || "#0c1330");
            r.style.setProperty("--muted", "rgba(12,19,48,0.88)");
            r.style.setProperty("--faint", "rgba(12,19,48,0.6)");
            r.style.setProperty("--line", "rgba(12,19,48,0.2)");
            r.style.setProperty("--lineHi", "rgba(12,19,48,0.34)");
            r.style.setProperty("--bg2", "color-mix(in srgb, " + _eff + " 92%, #000000)");
            r.style.setProperty("--surfaceHi", "color-mix(in srgb, " + _eff + " 78%, #000000)");
            r.style.setProperty("--surface", "color-mix(in srgb, " + _eff + " 86%, #000000)");
          }
        } catch {}
      }
      if (v.gridColor) { r.style.setProperty("--grid-color", v.gridColor); r.style.setProperty("--grid", v.gridColor); }
      if (v.gridStrong) { r.style.setProperty("--grid-strong", v.gridStrong); r.style.setProperty("--lineHi", v.gridStrong); }
      if (v.gridSize) r.style.setProperty("--grid-size", v.gridSize + "px");
      if (v.accent) r.style.setProperty("--accent", v.accent);
      if (v.iconColor) r.style.setProperty("--icon-color", v.iconColor); else r.style.setProperty("--icon-color", v.accent || "#d63a7a");
      if (v.accentHover) r.style.setProperty("--accent-hover", v.accentHover);
      // ═══ تطبيق --accent-hover على عناصر التفاعل ═══
      let hoverStyle = document.getElementById("ui-hover-style");
      if (!hoverStyle) {
        hoverStyle = document.createElement("style");
        hoverStyle.id = "ui-hover-style";
        document.head.appendChild(hoverStyle);
      }
      const ah = v.accentHover || v.accent || "#b02962";
      hoverStyle.textContent = `
        button:hover, .pm-act:hover, .btn:hover, .save-btn:hover, .opt-btn:hover, .add-card:hover, .pm-card:hover, .pp-card:hover, .ag-btn:hover, .ag-menu-item:hover { background: color-mix(in srgb, ${ah} 15%, transparent) !important; }
        button:active, .pm-act:active { background: ${ah} !important; color: white !important; }
        a:hover, .link:hover { color: ${ah} !important; }
      `;
      if (v.border) r.style.setProperty("--border", v.border);
      if (v.fontFamily) r.style.setProperty("--font-family", "'" + v.fontFamily + "', sans-serif");
      if (v.fontSize) r.style.setProperty("--font-size", v.fontSize + "px");
      if (v.fontWeight) r.style.setProperty("--font-weight", v.fontWeight);
      if (v.letterSpacing !== undefined) r.style.setProperty("--letter-spacing", v.letterSpacing + "px");
      // ═══ تطبيق الخطوط والبطاقة عبر <style> tag ═══
      let typeStyle = document.getElementById("ui-type-style");
      if (!typeStyle) {
        typeStyle = document.createElement("style");
        typeStyle.id = "ui-type-style";
        document.head.appendChild(typeStyle);
      }
      try { document.body.style.zoom = (v.siteScale || 100) / 100; } catch {}
      const fs = v.fontSize || 14;
      const fw = v.fontWeight || 600;
      const ls = v.letterSpacing !== undefined ? v.letterSpacing : 0;
      const ff = v.fontFamily || "Cairo";
      const co = (v.cardOpacity !== undefined ? v.cardOpacity : 88) / 100;
        try { document.documentElement.style.setProperty("--card-alpha", Math.round(co * 100) + "%"); } catch {}
      typeStyle.textContent = `
        body, .ag-modal, .ag-card, .pp-card, .add-card, [class*="card"], [class*="Card"] { font-family: '${ff}', sans-serif !important; font-size: ${fs}px !important; letter-spacing: ${ls}px !important; }
        body :is(span, div, p, label, button, input, td, th, a) { font-family: '${ff}', sans-serif !important; letter-spacing: ${ls}px !important; }
        body h1, body h2, body h3, body h4, body [class*="title"], body [class*="Title"] { font-weight: ${fw} !important; }
        .ag-card, .pp-card, .add-card, .pm-card, .am-panel, [class*="card"]:not([class*="cardborder"]):not([class*="cardicon"]):not([class*="card-icon"]), [class*="Card"]:not([class*="CardBorder"]), [class*="glass"], [class*="Glass"] { background: color-mix(in srgb, var(--surface, #ffffff) ${Math.round(co * 100)}%, transparent) !important; }
      `;
      // ═══ تطبيق مؤثرات الشعار ═══
      let logoStyle = document.getElementById("ui-logo-style");
      if (!logoStyle) {
        logoStyle = document.createElement("style");
        logoStyle.id = "ui-logo-style";
        document.head.appendChild(logoStyle);
      }
      const lSize = v.logoSize || 68;
      const lShadow = (v.logoShadow || 35) / 100;
      const lBright = (v.logoBrightness || 100) / 100;
      const lSat = (v.logoSaturation || 100) / 100;
      const lHue = v.logoHue || 0;
      const lFx = v.logoFx || "none";
      const lFrame = v.logoFrame || "none";
      let fxCss = "";
      if (lFx === "glow") fxCss = "filter: drop-shadow(0 0 20px var(--accent, #d63a7a)) brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      else if (lFx === "pulse") fxCss = "animation: uiLogoPulse 2s ease-in-out infinite; filter: brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      else if (lFx === "float") fxCss = "animation: uiLogoFloat 3s ease-in-out infinite; filter: brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      else if (lFx === "rotate") fxCss = "animation: uiLogoRotate 8s linear infinite; filter: brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      else if (lFx === "bounce") fxCss = "animation: uiLogoBounce 1.5s ease-in-out infinite; filter: brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      else if (lFx === "shake") fxCss = "animation: uiLogoShake 0.5s ease-in-out infinite; filter: brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      else if (lFx === "flip") fxCss = "animation: uiLogoFlip 3s ease-in-out infinite; filter: brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      else fxCss = "filter: drop-shadow(0 6px 16px rgba(0,0,0," + lShadow + ")) brightness(" + lBright + ") saturate(" + lSat + ") hue-rotate(" + lHue + "deg);";
      let frameCss = "";
      if (lFrame === "circle") frameCss = "border-radius: 50% !important; padding: 6px; background: color-mix(in srgb, var(--accent) 15%, transparent);";
      else if (lFrame === "rounded") frameCss = "border-radius: 14px !important; padding: 6px; background: color-mix(in srgb, var(--accent) 15%, transparent);";
      else if (lFrame === "glow-ring") frameCss = "border-radius: 50% !important; padding: 6px; box-shadow: 0 0 0 3px var(--accent), 0 0 20px var(--accent);";
      logoStyle.textContent = `
        .cover-pro, [class*="logo"] img, [class*="Logo"] img, .app-logo, .brand-logo { width: ${lSize}px !important; height: ${lSize}px !important; ${fxCss} ${frameCss} }
        @keyframes uiLogoPulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.08); } }
        @keyframes uiLogoFloat { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
        @keyframes uiLogoRotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes uiLogoBounce { 0%, 100% { transform: translateY(0); } 40% { transform: translateY(-12px); } 60% { transform: translateY(-6px); } }
        @keyframes uiLogoShake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-3px); } 75% { transform: translateX(3px); } }
        @keyframes uiLogoFlip { 0%, 100% { transform: rotateY(0deg); } 50% { transform: rotateY(180deg); } }
      `;
      // تطبيق شبكة ورقة الدفتر بحركة الدخول (من ملف تسجيل الدخول)
      let styleTag = document.getElementById("ui-dynamic-grid");
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = "ui-dynamic-grid";
        document.head.appendChild(styleTag);
      }
      if (v.gridOn) {
        const th = v.gridThickness || 1;
        const op = (v.gridOpacity || 100) / 100;
        const sp = v.animationSpeed || 0.8;
        const sz = v.gridSize || 24;
        const gc = v.gridColor || "#d4e4f0";
        // بناء background-image حسب شكل الشبكة
        let bgImage = "";
        const shape = v.gridShape || "grid";
        if (shape === "grid") {
          bgImage = `repeating-linear-gradient(${gc} 0 ${th}px, transparent ${th}px ${sz}px), repeating-linear-gradient(90deg, ${gc} 0 ${th}px, transparent ${th}px ${sz}px)`;
        } else if (shape === "lined") {
          bgImage = `repeating-linear-gradient(${gc} 0 ${th}px, transparent ${th}px ${sz}px)`;
        } else if (shape === "dots") {
          bgImage = `radial-gradient(circle, ${gc} ${th}px, transparent ${th}px)`;
        } else if (shape === "dots-lines") {
          bgImage = `radial-gradient(circle, ${gc} ${th}px, transparent ${th}px), repeating-linear-gradient(${gc} 0 ${th}px, transparent ${th}px ${sz}px)`;
        } else if (shape === "diamond") {
          bgImage = `repeating-linear-gradient(45deg, ${gc} 0 ${th}px, transparent ${th}px ${sz}px), repeating-linear-gradient(-45deg, ${gc} 0 ${th}px, transparent ${th}px ${sz}px)`;
        } else if (shape === "double") {
          bgImage = `repeating-linear-gradient(${gc} 0 ${th}px, transparent ${th}px ${sz}px, ${gc} ${sz}px ${sz + th}px, transparent ${sz + th}px ${sz * 2}px), repeating-linear-gradient(90deg, ${gc} 0 ${th}px, transparent ${th}px ${sz}px)`;
        } else if (shape === "cross") {
          bgImage = `linear-gradient(${gc} ${th}px, transparent ${th}px), linear-gradient(90deg, ${gc} ${th}px, transparent ${th}px)`;
        } else if (shape === "notebook") {
          bgImage = `repeating-linear-gradient(${gc} 0 ${th}px, transparent ${th}px ${sz}px), linear-gradient(90deg, transparent 0 ${sz - th * 3}px, ${gc} ${sz - th * 3}px ${sz - th * 2}px, transparent ${sz - th * 2}px)`;
        } else if (shape === "slant") {
          bgImage = `repeating-linear-gradient(45deg, ${gc} 0 ${th}px, transparent ${th}px ${sz}px)`;
        } else if (shape === "blueprint") {
          bgImage = `repeating-linear-gradient(${gc} 0 ${th}px, transparent ${th}px ${sz / 5}px), repeating-linear-gradient(90deg, ${gc} 0 ${th}px, transparent ${th}px ${sz / 5}px), linear-gradient(${gc} ${th}px, transparent ${th}px), linear-gradient(90deg, ${gc} ${th}px, transparent ${th}px)`;
        } else if (shape === "weave") {
          bgImage = `repeating-linear-gradient(45deg, ${gc} 0 ${th}px, transparent ${th}px ${sz / 3}px), repeating-linear-gradient(-45deg, ${gc} 0 ${th}px, transparent ${th}px ${sz / 3}px)`;
        } else if (shape === "rings") {
          bgImage = `radial-gradient(circle at center, transparent 0 ${sz / 5}px, ${gc} ${sz / 5}px ${sz / 5 + th}px, transparent ${sz / 5 + th}px ${sz / 2.6}px, ${gc} ${sz / 2.6}px ${sz / 2.6 + th}px, transparent ${sz / 2.6 + th}px)`;
        } else if (shape === "arabesque") {
          bgImage = `repeating-linear-gradient(45deg, ${gc} 0 ${th}px, transparent ${th}px ${sz}px), repeating-linear-gradient(-45deg, ${gc} 0 ${th}px, transparent ${th}px ${sz}px), radial-gradient(circle at center, ${gc} ${th * 1.6}px, transparent ${th * 1.6}px)`;
        } else if (shape === "checker") {
          bgImage = `conic-gradient(${gc} 0 25%, transparent 0 50%, ${gc} 0 75%, transparent 0)`;
        } else if (shape === "none") {
          bgImage = "none";
        }
        // تحويل الشفافية إلى قيمة alpha في hex
        const gcAlpha = gc + Math.round(op * 255).toString(16).padStart(2, "0").toUpperCase();
        const bgImageAlpha = bgImage.split(gc).join(gcAlpha);
        styleTag.textContent = `
          [style*="repeating-linear-gradient"] { background-image: ${bgImageAlpha} !important; background-size: ${sz}px ${sz}px !important; animation: nbGridFadeIn ${sp * 2}s ease 0.4s; }
          @keyframes nbGridFadeIn { from { opacity: 0; } to { opacity: 1; } }
          @keyframes nbLineIn { from { opacity: 0; transform: scaleX(0); } to { opacity: 1; transform: scaleX(1); } }
          @keyframes nbVLineIn { from { opacity: 0; transform: scaleY(0); } to { opacity: 1; transform: scaleY(1); } }
        `;
        // إضافة الخطوط القوية (4 أفقية + 4 عمودية) بحركات lineIn / vLineIn
        let linesEl = document.getElementById("ui-bg-lines");
        if (linesEl) linesEl.remove();
        linesEl = document.createElement("div");
        linesEl.id = "ui-bg-lines";
        linesEl.style.cssText = "position: fixed; inset: 0; pointer-events: none; z-index: -1;";
        const hTops = v.hLinesOn === false ? [] : [20, 40, 60, 80];
        const vLefts = v.vLinesOn === false ? [] : [15, 35, 65, 85];
        hTops.forEach((t, i) => {
          const l = document.createElement("div");
          l.style.cssText = `position: absolute; left: 0; right: 0; top: ${t}%; height: 1px; background: ${v.gridStrong}; opacity: 0; animation: nbLineIn ${sp}s ease ${(i + 1) * 0.1}s forwards; transform-origin: right;`;
          linesEl.appendChild(l);
        });
        vLefts.forEach((l, i) => {
          const line = document.createElement("div");
          line.style.cssText = `position: absolute; top: 0; bottom: 0; left: ${l}%; width: 1px; background: ${v.gridStrong}; opacity: 0; animation: nbVLineIn ${sp}s ease ${(i + 1) * 0.1 + 0.05}s forwards; transform-origin: top;`;
          linesEl.appendChild(line);
        });
        document.body.appendChild(linesEl);
      } else {
        styleTag.textContent = `[style*="repeating-linear-gradient"] { background-image: none !important; }`;
        const linesEl = document.getElementById("ui-bg-lines");
        if (linesEl) linesEl.remove();
      }
    };
    window.__applyUISettings = applyUISettings;

    (async () => {
      try {
        const { supabase } = await import("./supabaseClient.js");
        const { data } = await supabase.from("platform_ui_settings").select("settings").eq("is_active", true).limit(1).maybeSingle();
        if (data && data.settings) applyUISettings(data.settings);

        // Realtime: أي تغيير من UIControl يظهر فورًا للجميع
        const ch = supabase.channel("rt:platform_ui_settings")
          .on("postgres_changes", { event: "*", schema: "public", table: "platform_ui_settings" }, (payload) => {
            if (payload.new && payload.new.settings) applyUISettings(payload.new.settings);
          }).subscribe();
        return () => { try { supabase.removeChannel(ch); } catch {} };
      } catch (e) { console.error("UI settings load failed:", e); }
    })();
  }, []);
  const settingsKey = "pm:settings:" + (me?.id || "anon");
  const [share, setShare] = useState({ stats: false, marketing: false });
  useEffect(() => { (async () => { try { if (typeof window !== "undefined" && window.storage) { const r = await window.storage.get("pm:share"); if (r && r.value) setShare({ stats: false, marketing: false, ...(JSON.parse(r.value) || {}) }); } } catch {} })(); }, []);
  const saveShare = (patch) => setShare((s) => { const nx = { ...s, ...patch }; try { if (typeof window !== "undefined" && window.storage) window.storage.set("pm:share", JSON.stringify(nx)); } catch {} return nx; });
  const [events, setEvents] = useState([]);
  const isAdminNow = () => { try { return !!window.__tpmsIsAdmin; } catch { return false; } };
  const prefRead = async (asKey, field, sub) => {
    if (isAdminNow()) { try { const r = await window.storage.get(asKey); return r && r.value ? JSON.parse(r.value) : null; } catch { return null; } }
    const loc = window.prefsStore ? window.prefsStore.local(field) : null;
    const fromLoc = loc && sub ? loc[sub] : loc;
    (async () => { try { await window.prefsStore.fetch(field); window.dispatchEvent(new CustomEvent("pm:prefs:" + field)); } catch {} })();
    return fromLoc != null ? fromLoc : null;
  };
  const prefWrite = (asKey, field, sub, value) => {
    if (isAdminNow()) { try { window.storage.set(asKey, JSON.stringify(value)); } catch {} return; }
    if (!window.prefsStore) return;
    if (sub) { const cur = window.prefsStore.local(field) || {}; cur[sub] = value; window.prefsStore.save(field, cur); }
    else window.prefsStore.save(field, value);
  };
  const agKey = (base) => {
    try {
      const admin = (typeof window !== "undefined" && window.__tpmsIsAdmin);
      const uid = (typeof window !== "undefined" && window.__tpmsUid) || "";
      if (admin) return base;
      if (!uid) return null; // الهوية لم تجهز بعد - لا حفظ لمفتاح يتيم
      return base + ":" + uid;
    } catch { return base; }
  };
  const loadAgenda = async () => {
    try {
      const { supabase } = await import("./supabaseClient.js");
      const au = (await supabase.auth.getUser()).data.user; if (!au) return;
      const { data: prof } = await supabase.from("profiles").select("id, role, org_id").eq("id", au.id).maybeSingle();
      if (!prof) return;
      window.__agMe = prof;
      let { data: evs } = await supabase.from("agenda_events").select("*").eq("owner_id", prof.id).order("date");
      evs = evs || [];
      if (evs.length === 0 && !localStorage.getItem("tpms_agenda_migrated")) {
        try {
          const v = await prefRead("pm:events", "agenda", "events");
          if (v && v.length) {
            const rows = v.map((e) => ({ org_id: prof.org_id, owner_id: prof.id, created_by: prof.id, title: e.title || "", date: e.date, type: e.type || "مهمة", note: e.note || "" })).filter((r) => r.date);
            if (rows.length) { await supabase.from("agenda_events").insert(rows); const r2 = await supabase.from("agenda_events").select("*").order("date"); evs = r2.data || []; }
          }
        } catch {}
        try { localStorage.setItem("tpms_agenda_migrated", "1"); } catch {}
      }
      const isAdm = prof.role === "admin";
      const otherIds = Array.from(new Set(evs.flatMap((e) => [e.created_by, e.owner_id]).filter((c) => c && c !== prof.id)));
      let names = {}; const roleOf = {};
      if (otherIds.length) {
        const { data: ps } = await supabase.from("profiles").select("id, full_name, role").in("id", otherIds);
        (ps || []).forEach((x) => { names[x.id] = x.full_name; roleOf[x.id] = x.role; });
      }
      setEvents(evs.map((e) => ({ ...e, __ce: isAdm || e.created_by === prof.id,
        __by: e.created_by === prof.id ? "" : (names[e.created_by] || "الإدارة"),
        __own: e.owner_id === prof.id ? "" : (names[e.owner_id] || ""),
        __src: e.created_by === prof.id ? "" : ((typeof roleOf !== "undefined" && roleOf[e.created_by]) === "admin" ? "owner" : (typeof roleOf !== "undefined" && roleOf[e.created_by]) === "project_manager" ? "pm" : "other") })));
    } catch {}
  };
  useEffect(() => { loadAgenda(); }, []);
  useEffect(() => { (async () => { try { const r = await fetch("https://api.ipify.org?format=json"); const d = await r.json(); if (d && d.ip) { const { supabase } = await import("./supabaseClient.js"); await supabase.rpc("set_session_ip", { p_ip: d.ip }); } } catch {} })(); }, []);
  useEffect(() => {
    let ch = null;
    (async () => {
      try {
        const { supabase } = await import("./supabaseClient.js");
        ch = supabase.channel("rt-agenda").on("postgres_changes", { event: "*", schema: "public", table: "agenda_events" }, () => loadAgenda()).subscribe();
      } catch {}
    })();
    return () => { try { ch && ch.unsubscribe(); } catch {} };
  }, []);
  const [topMsgs, setTopMsgs] = useState({});
  useEffect(() => {
    const load = async () => { try { if (typeof window !== "undefined" && window.storage) { const r = await window.storage.get("pm:topmsg"); setTopMsgs(r && r.value ? (JSON.parse(r.value) || {}) : {}); } } catch {} };
    load();
    const t1 = setTimeout(load, 2500); const t2 = setTimeout(load, 7000); const t3 = setInterval(load, 30000);
    window.addEventListener("pm:topmsg", load);
    return () => { clearTimeout(t1); clearTimeout(t2); clearInterval(t3); window.removeEventListener("pm:topmsg", load); };
  }, []);
  const persistEvents = (arr) => { try { prefWrite("pm:events", "agenda", "events", arr); } catch {} };
  const addEvent = (ev) => {
    const me = window.__agMe; if (!me) return;
    const row = { id: crypto.randomUUID(), org_id: me.org_id, owner_id: ev.owner_id || me.id, created_by: me.id, title: ev.title || "", date: ev.date, type: ev.type || "مهمة", note: ev.note || "" };
    setEvents((a) => [...a, { ...row, __ce: true, __by: "", __own: "" }]);
    (async () => { try { const { supabase } = await import("./supabaseClient.js"); await supabase.from("agenda_events").insert(row); } catch {} })();
  };
  const updateEvent = (id, patch) => {
    setEvents((a) => a.map((e) => (e.id === id ? { ...e, ...patch } : e)));
    (async () => { try { const { supabase } = await import("./supabaseClient.js"); const { title, date, type, note } = patch; await supabase.from("agenda_events").update({ title, date, type, note }).eq("id", id); } catch {} })();
  };
  const deleteEvent = (id) => {
    setEvents((a) => a.filter((e) => e.id !== id));
    (async () => { try { const { supabase } = await import("./supabaseClient.js"); await supabase.from("agenda_events").delete().eq("id", id); } catch {} })();
  };
  const [fairs, setFairs] = useState([]);
  useEffect(() => { (async () => {
    try { const v = await prefRead("pm:fairs", "agenda", "fairs"); if (v) { setFairs(v); return; } } catch {}
    const seed = BOOK_FAIRS.map((f, i) => ({ id: "fair-" + i, ...f }));
    setFairs(seed); try { prefWrite("pm:fairs", "agenda", "fairs", seed); } catch {}
  })(); }, []);
  const persistFairs = (arr) => { try { prefWrite("pm:fairs", "agenda", "fairs", arr); } catch {} };
  const saveFair = (id, patch) => setFairs((a) => { const nx = a.map((f) => (f.id === id ? { ...f, ...patch } : f)); persistFairs(nx); return nx; });
  const addFair = (f) => setFairs((a) => { const nx = [...a, { id: finGid(), approx: true, ...f }]; persistFairs(nx); return nx; });
  const removeFair = (id) => setFairs((a) => { const nx = a.filter((f) => f.id !== id); persistFairs(nx); return nx; });
  const fairToAgenda = (f) => { addEvent({ type: "معرض", title: f.name, date: f.date, note: f.city || "" }); flash("أُضيف «" + f.name + "» إلى الأجندة ✓"); };
  const [verseIdx, setVerseIdx] = useState(0);

  const [publishers, setPublishers] = useState([]);

  // التخزين الدائم: تحميل عند البدء، حفظ عند أي تغيير
  const [storeReady, setStoreReady] = useState(false);
  useEffect(() => {
    let alive = true;
    (async () => {
      let gotDb = false;
      // 1) المصدر الأساسي: SQLite
      try {
        if (window.pmdb && window.pmdb.appLoad) {
          const arr = await window.pmdb.appLoad();
          if (alive && Array.isArray(arr)) {
            const hydrated = await hydrateAfterLoad(arr);
            if (alive) { setPublishers(hydrated); gotDb = true; }
          }
        }
      } catch (e) { /* لا قاعدة بعد */ }
      // 2) رجوع آمن + مُهاجِر: localStorage -> SQLite
      if (!gotDb) {
        try {
          if (typeof window !== "undefined" && window.storage) {
            const res = await window.storage.get("pm:data");
            if (alive && res && res.value) {
              const parsed = JSON.parse(res.value);
              if (Array.isArray(parsed)) {
                const hydrated = await hydrateAfterLoad(parsed);
                if (alive) setPublishers(hydrated);
                try { if (window.pmdb && window.pmdb.appSave) window.pmdb.appSave(res.value); } catch {}
              }
            }
          }
        } catch (e) { /* أول تشغيل */ }
      }
      if (alive) setStoreReady(true);
    })();
    return () => { alive = false; };
  }, []);
  // مزامنة صامتة: تعديلات الزملاء تُدمج في الشاشة دون إعادة تحميل
  useEffect(() => {
    window.__tpmsRefresh = async () => {
      try {
        if (window.pmdb && window.pmdb.appLoad) {
          const arr = await window.pmdb.appLoad();
          if (Array.isArray(arr)) {
            const hydrated = await hydrateAfterLoad(arr);
            setPublishers(hydrated);
          }
        }
      } catch {}
    };
    return () => { try { delete window.__tpmsRefresh; } catch {} };
  }, []);
  useEffect(() => {
    let alive = true;
    setSettings({ text: DEFAULT_VERSE, size: 19, theme: "neon", rotate: false });
    (async () => {
      try {
        if (typeof window !== "undefined" && window.storage) {
          if (!isAdminNow() && window.prefsStore) {
            const v = await prefRead(settingsKey, "prefs", null);
            if (v) setSettings((prev) => ({ ...prev, ...v }));
            return;
          }
          const r = await window.storage.get(settingsKey);
          if (alive && r && r.value) { const o = JSON.parse(r.value) || {}; setSettings((s) => ({ ...s, ...o, text: o.text || o.titleText || s.text })); }
        }
      } catch {}
    })();
    return () => { alive = false; };
  }, [settingsKey]);
  const saveSettings = (patch) => {
    setSettings((s) => {
      const next = { ...s, ...patch };
      if (!next.text || !next.text.trim()) next.text = DEFAULT_VERSE;
      try { prefWrite(settingsKey, "prefs", null, next); } catch {}
      return next;
    });
  };
  const _baseVerses = (settings.text || "").split("\n").map((x) => x.trim()).filter(Boolean);
  const _myTopMsg = (topMsgs && me && topMsgs[me.id]) ? String(topMsgs[me.id]).trim() : "";
  const verses = _baseVerses; // الرسالة صارت صندوقًا مستقلًا في TopBar
  useEffect(() => {
    setVerseIdx(0);
    if (!settings.rotate || verses.length < 2) return;
    const id = setInterval(() => setVerseIdx((i) => (i + 1) % verses.length), 9000);
    return () => clearInterval(id);
  }, [settings.rotate, settings.text]);
  const displayedVerse = verses.length ? verses[Math.min(verseIdx, verses.length - 1)] : DEFAULT_VERSE;
  const titleTheme = TITLE_THEMES[settings.theme] || TITLE_THEMES.neon;
  _activeTheme = { rainbow: !!titleTheme.rainbow, accent: titleTheme.accent || "#14b8a6" };
  const titleColorVal = settings.titleColor === "white" ? "#ffffff" : settings.titleColor === "black" ? "#0b1020" : settings.titleColor === "theme" ? "var(--accent)" : "var(--text)";
  useEffect(() => {
    const st = document.documentElement.style;
    const acc = titleTheme.accent || "#14b8a6";
    const dark = !!settings.dark;
    // ═══ عزل: titleTheme يؤثر فقط على card-glow والشريط نفسه
    // --accent يبقى تحت تحكم Settings2 (لا يُلمس هنا)
    st.setProperty("--card-glow", titleTheme.grad);
    st.setProperty("--title-color", titleColorVal);
    document.documentElement.classList.toggle("no-card-border", settings.cardBorder === false);
    document.documentElement.classList.toggle("no-card-bg", settings.cardBg === false);

    if (settings.hideBorders) { st.setProperty("--line", "transparent"); st.setProperty("--lineHi", "transparent"); }
    // إعادة تطبيق إعدادات Settings2 لضمان عدم الكتابة فوقها
    setTimeout(() => {
      if (window.__applyUISettings) {
        (async () => {
          try {
            const { supabase } = await import("./supabaseClient.js");
            const { data } = await supabase.from("platform_ui_settings").select("settings").eq("is_active", true).limit(1).maybeSingle();
            if (data && data.settings) window.__applyUISettings(data.settings);
          } catch {}
        })();
      }
    }, 50);
  }, [titleTheme, settings.dark, settings.cardBorder, settings.cardBg, settings.titleColor, settings.hideBorders]);

  // ═══ إعادة تطبيق UISettings بعد أي تغيير في النمط ═══
  useEffect(() => {
    (async () => {
      try {
        const { supabase } = await import("./supabaseClient.js");
        const { data } = await supabase.from("platform_ui_settings").select("settings").eq("is_active", true).limit(1).maybeSingle();
        if (data && data.settings && window.__applyUISettings) {
          window.__applyUISettings(data.settings);
        }
      } catch (e) {}
    })();
  }, [settings.dark]);
  const [showAssign, setShowAssign] = useState(false);
  const [showDb, setShowDb] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showTrash, setShowTrash] = useState(false);
  const goToBook = (pubId, projId, bookId) => {
    setCurPub(pubId); setCurProj(projId); setEditMode(false); setPage("works"); setDetailId(bookId); setShowSearch(false);
  };
  const restoreFromDb = async (arr, jsonStr) => {
    try {
      const hydrated = await hydrateAfterLoad(Array.isArray(arr) ? arr : []);
      setPublishers(hydrated);
      try { if (window.storage && jsonStr) window.storage.set("pm:data", jsonStr); } catch {}
      flash("تمّت الاستعادة ✓");
    } catch (e) { flash("تعذّرت الاستعادة"); }
  };
  const [saveState, setSaveState] = useState("idle"); // idle | saving | saved | error
  const saveTimer = useRef(null);
  const [savePath, setSavePath] = useState(null);
  const savePathRef = useRef(null);
  const folderTimer = useRef(null);
  useEffect(() => { savePathRef.current = savePath; }, [savePath]);
  useEffect(() => { (async () => { try { if (window.storage) { const r = await window.storage.get("pm:savePath"); if (r && r.value) setSavePath(r.value); } } catch {} })(); }, []);
  useEffect(() => {
    if (!storeReady) return;
    setSaveState("saving");
    if (saveTimer.current) clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(async () => {
      try {
        if (typeof window !== "undefined" && window.storage) {
          const __slim = JSON.parse(JSON.stringify(publishers), (k, v) => {
            if (v && typeof v === "object" && v.path && typeof v.data === "string" && v.data.startsWith("data:")) { const { data, ...rest } = v; return rest; }
            return v;
          });
          const forSaveJson = JSON.stringify(__slim);
          if (forSaveJson.length > 800000) flash("⚠ حمولة الحفظ ضخمة (" + Math.round(forSaveJson.length / 1024) + "KB) - ملف لم يصعد للمخزن");
          const __sv = await window.storage.set("pm:data", forSaveJson);
          if (!__sv) flash("⚠ فشل الحفظ السحابي: " + (window.__tpmsLastErr || "سبب غير معروف"));
          // طبقة SQLite بالتوازي (لا تعطّل الحفظ الحالي إن غابت)
          
          if (false && savePathRef.current && window.pmWriteData) {
            const d = dataRef.current;
            window.pmWriteData(savePathRef.current, JSON.stringify({ app: "tpms", v: 1, when: new Date().toISOString(), data: d.publishers, events: d.events, share: d.share, appTitle: d.appTitle }));
            if (window.pmWriteTree) { if (folderTimer.current) clearTimeout(folderTimer.current); folderTimer.current = setTimeout(() => { try { window.pmWriteTree(savePathRef.current, dataRef.current.publishers); } catch {} }, 3000); }
          }
        }
        setSaveState("saved");
        setTimeout(() => setSaveState((s) => (s === "saved" ? "idle" : s)), 1800);
      } catch (e) {
        setSaveState("error");
        try { flash("⚠ انفجار الحفظ: " + (e && e.message ? e.message : String(e))); } catch {}
      }
    }, 500);
    return () => { if (saveTimer.current) clearTimeout(saveTimer.current); };
  }, [publishers, storeReady]);

  // نموذج إضافة دار نشر
  const [showAddPub, setShowAddPub] = useState(false);
  const [editPubId, setEditPubId] = useState(null);
  const [pName, setPName] = useState(""); const [pNote, setPNote] = useState("");
  const [pTag, setPTag] = useState("دار نشر"); const [pIcon, setPIcon] = useState("Library"); const [pIconImg, setPIconImg] = useState(null); const [pColor, setPColor] = useState(C.pink);
  const resetPub = () => { setPName(""); setPNote(""); setPTag("دار نشر"); setPIcon("Library"); setPIconImg(null); setPColor(C.pink); };

  // نموذج إضافة مشروع
  const [showAddProj, setShowAddProj] = useState(false);
  const [editProjId, setEditProjId] = useState(null);
  const [jName, setJName] = useState(""); const [jCat, setJCat] = useState(""); const [jDate, setJDate] = useState(today()); const [jIcon, setJIcon] = useState("Languages");
  const [jIconImg, setJIconImg] = useState(null);
  const [jDot, setJDot] = useState("rainbow");
  const resetProj = () => { setJName(""); setJDate(today()); setJIcon("Languages"); setJIconImg(null); setJDot("rainbow"); setJCat(""); };

  // نموذج إضافة كتاب (works = كتب)
  const [showAddWork, setShowAddWork] = useState(false);
  const emptyBook = () => ({
    name: "", nameFr: "", date: today(), icon: "BookOpen", iconImg: null, lang: "إنجليزية", category: "", dotColor: "rainbow", status: "active", visibility: "shared",
    opNumber: "", grantNumber: "", grantType: "", mediaPermit: "",
    authorName: "", authorEmail: "", authorPhone: "",
    transName: "", transNat: "", transEmail: "", transPhone: "", fee1: "", fee2: "", transDeliveryDate: "", transReceived: false,
    isbnAr: "", isbnFr: "", notes: "",
    pubAr: "", pubFrHouse: "", pubFrName: "", pubFrEmail: "", printOffer: "",
    coverAr: null, coverFr: null, contractAuthor: null, contractTrans1: null, contractPublisher: null, printOfferFile: null,
    deliveries: {},
    filesTrash: [],
  });
  const [bk, setBk] = useState(emptyBook());
  const setB = (k, v) => setBk((b) => ({ ...b, [k]: v }));
  const resetWork = () => setBk(emptyBook());

  // نافذة خيارات المشروع (نقرة مزدوجة) + رسالة عابرة
  const [menuProj, setMenuProj] = useState(null);   // المشروع المحدّد
  const [menuWork, setMenuWork] = useState(null);   // الكتاب المحدّد (نقرة مزدوجة)
  const [menuPub, setMenuPub] = useState(null);     // الجهة المحدّدة (ضغطة مطوّلة)
  const [toast, setToast] = useState(null);
  const [detailId, setDetailId] = useState(null);   // الكتاب المفتوح للتفاصيل
  const [exportData, setExportData] = useState(null); // {rows,title,name}
  const flash = (msg) => { setToast(msg); window.clearTimeout(flash._t); flash._t = window.setTimeout(() => setToast(null), 2800); };
  const restoreRef = useRef(null);
  const dataRef = useRef({});
  dataRef.current = { publishers, events, share, appTitle, settingsKey };
  const [dataStale, setDataStale] = useState(false);
  const [staleBy, setStaleBy] = useState("");
  const [draftMsg, setDraftMsg] = useState("");
  const [approvalMsg, setApprovalMsg] = useState(null);
  const [showNote, setShowNote] = useState(false);
  const ConfirmDialogLazy = React.useMemo(() => React.lazy(() => import("./ConfirmDialog.jsx")), []);
  const [agCtrl, setAgCtrl] = useState(false);
  const AgendaControlLazy = React.useMemo(() => React.lazy(() => import("./AgendaControl.jsx")), []);
  useEffect(() => { const h = () => setAgCtrl(true); window.addEventListener("tpms:agenda-control", h); return () => window.removeEventListener("tpms:agenda-control", h); }, []);
  useEffect(() => {
    // حارس الثيم: يستشعر الوضع الليلي من لون الخلفية الفعلي ويضبط قواعد النماذج
    if (!document.getElementById("tpms-modal-theme")) {
      const st = document.createElement("style");
      st.id = "tpms-modal-theme";
      st.textContent = `
        html[data-theme="dark"] :is(.add-card, .ag-acts, .ag-btn, .ag-btn-primary, .ag-bug-c, .ag-card, .ag-chat, .ag-chat-head, .ag-chat-input, .ag-chat-list, .ag-chat-main, .ag-empty, .ag-err, .ag-file, .ag-gear, .ag-hint, .ag-input, .ag-label, .ag-link, .ag-logbox, .ag-logmsg, .ag-logt, .ag-logtype, .ag-menu, .ag-menu-item, .ag-menu-label, .ag-mini, .ag-modal, .ag-modal-bg, .ag-modal-h, .ag-name, .ag-panel, .ag-pill, .ag-return, .ag-row, .ag-screen, .ag-shown, .ag-sub, .ag-sub-menu, .ag-table, .ag-thread, .ag-title, .agc-chip, .agc-dn, .agc-grid, .body, .btn-del, .cover-pro, .crown, .danger, .ghost, .icon-opt, .meta, .mini-btn, .modal-pop, .opt-btn, .opt-danger, .pm-act, .pm-act-lbl, .pm-card, .pm-cardborder, .pm-cover, .pm-enter, .pm-stripes, .pp-act, .pp-alert, .pp-back, .pp-bar2, .pp-cancel, .pp-card, .pp-cards, .pp-dot, .pp-drawer, .pp-dsec, .pp-filter, .pp-go, .pp-head, .pp-inner, .pp-input, .pp-mini, .pp-mlabel, .pp-modal, .pp-months, .pp-mtitle, .pp-nrow, .pp-ovl, .pp-page, .pp-pill, .pp-plans, .pp-search, .pp-sub, .pp-t, .pp-tablewrap, .pp-title, .pp-tix, .pp-urow, .rep, .save-btn, .seg-btn, .small, .stop, .swatch, .toast-pop, .tp-pulse, .tp-typing, .tp-zoom, .wide) { color: #ffffff; font-size: 14px; }
        html[data-theme="dark"] :is(.add-card, .ag-acts, .ag-btn, .ag-btn-primary, .ag-bug-c, .ag-card, .ag-chat, .ag-chat-head, .ag-chat-input, .ag-chat-list, .ag-chat-main, .ag-empty, .ag-err, .ag-file, .ag-gear, .ag-hint, .ag-input, .ag-label, .ag-link, .ag-logbox, .ag-logmsg, .ag-logt, .ag-logtype, .ag-menu, .ag-menu-item, .ag-menu-label, .ag-mini, .ag-modal, .ag-modal-bg, .ag-modal-h, .ag-name, .ag-panel, .ag-pill, .ag-return, .ag-row, .ag-screen, .ag-shown, .ag-sub, .ag-sub-menu, .ag-table, .ag-thread, .ag-title, .agc-chip, .agc-dn, .agc-grid, .body, .btn-del, .cover-pro, .crown, .danger, .ghost, .icon-opt, .meta, .mini-btn, .modal-pop, .opt-btn, .opt-danger, .pm-act, .pm-act-lbl, .pm-card, .pm-cardborder, .pm-cover, .pm-enter, .pm-stripes, .pp-act, .pp-alert, .pp-back, .pp-bar2, .pp-cancel, .pp-card, .pp-cards, .pp-dot, .pp-drawer, .pp-dsec, .pp-filter, .pp-go, .pp-head, .pp-inner, .pp-input, .pp-mini, .pp-mlabel, .pp-modal, .pp-months, .pp-mtitle, .pp-nrow, .pp-ovl, .pp-page, .pp-pill, .pp-plans, .pp-search, .pp-sub, .pp-t, .pp-tablewrap, .pp-title, .pp-tix, .pp-urow, .rep, .save-btn, .seg-btn, .small, .stop, .swatch, .toast-pop, .tp-pulse, .tp-typing, .tp-zoom, .wide) :is(td, th, span, div, label, b, p, li, a) { color: #ffffff; }
        html[data-theme="dark"] :is(.add-card, .ag-acts, .ag-btn, .ag-btn-primary, .ag-bug-c, .ag-card, .ag-chat, .ag-chat-head, .ag-chat-input, .ag-chat-list, .ag-chat-main, .ag-empty, .ag-err, .ag-file, .ag-gear, .ag-hint, .ag-input, .ag-label, .ag-link, .ag-logbox, .ag-logmsg, .ag-logt, .ag-logtype, .ag-menu, .ag-menu-item, .ag-menu-label, .ag-mini, .ag-modal, .ag-modal-bg, .ag-modal-h, .ag-name, .ag-panel, .ag-pill, .ag-return, .ag-row, .ag-screen, .ag-shown, .ag-sub, .ag-sub-menu, .ag-table, .ag-thread, .ag-title, .agc-chip, .agc-dn, .agc-grid, .body, .btn-del, .cover-pro, .crown, .danger, .ghost, .icon-opt, .meta, .mini-btn, .modal-pop, .opt-btn, .opt-danger, .pm-act, .pm-act-lbl, .pm-card, .pm-cardborder, .pm-cover, .pm-enter, .pm-stripes, .pp-act, .pp-alert, .pp-back, .pp-bar2, .pp-cancel, .pp-card, .pp-cards, .pp-dot, .pp-drawer, .pp-dsec, .pp-filter, .pp-go, .pp-head, .pp-inner, .pp-input, .pp-mini, .pp-mlabel, .pp-modal, .pp-months, .pp-mtitle, .pp-nrow, .pp-ovl, .pp-page, .pp-pill, .pp-plans, .pp-search, .pp-sub, .pp-t, .pp-tablewrap, .pp-title, .pp-tix, .pp-urow, .rep, .save-btn, .seg-btn, .small, .stop, .swatch, .toast-pop, .tp-pulse, .tp-typing, .tp-zoom, .wide) :is([style*="font-size: 11"], [style*="font-size: 12"], [style*="font-size: 13"]) { font-size: 14px !important; }
        html[data-theme="dark"] input::placeholder, html[data-theme="dark"] textarea::placeholder { color: #c7cfe6; }
              html[data-theme="dark"] select, html[data-theme="dark"] input, html[data-theme="dark"] textarea {
          color: #ffffff; background-color: #151c33; border-color: var(--line); font-size: 14px; }
        html[data-theme="dark"] select option { background-color: #151c33; color: #ffffff; }
        html[data-theme="light"] select option { background-color: #ffffff; color: #0c1330; }
        select, input, textarea, button { font-family: inherit; }
              select { -webkit-appearance: none !important; appearance: none !important;
          border: 1px solid var(--line) !important; border-radius: 10px !important;
          padding: 7px 12px 7px 28px !important; font-family: inherit !important; font-size: 14px !important;
          background-repeat: no-repeat !important; background-position: left 10px center !important; cursor: pointer; }
        html[data-theme="dark"] select { color: #ffffff !important; background-color: #151c33 !important; background-image: url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2210%22 height=%226%22><path d=%22M1 1l4 4 4-4%22 stroke=%22white%22 stroke-width=%221.6%22 fill=%22none%22 stroke-linecap=%22round%22/></svg>') !important; }
        html[data-theme="dark"] select option, html[data-theme="dark"] select optgroup { background-color: #151c33 !important; color: #ffffff !important; }
        html[data-theme="light"] select { color: #0c1330 !important; background-color: #ffffff !important; background-image: url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2210%22 height=%226%22><path d=%22M1 1l4 4 4-4%22 stroke=%22%230c1330%22 stroke-width=%221.6%22 fill=%22none%22 stroke-linecap=%22round%22/></svg>') !important; }
        html[data-theme="light"] select option { background-color: #ffffff !important; color: #0c1330 !important; }
              /* accent-contrast: خلفية فسفورية = نص وأيقونات داكنة */
        html[data-theme="dark"] :is(.ag-btn-primary, [class*="primary"],
          [style*="background: var(--accent)"], [style*="background-color: var(--accent)"],
          [style*="background:var(--accent)"]) { color: #0c1330 !important; }
        html[data-theme="dark"] :is(.ag-btn-primary, [style*="background: var(--accent)"]) svg { color: #0c1330 !important; stroke: #0c1330; }
              /* badge-shield: شارات فسفورية بنص داكن دائم */
        html[data-theme="dark"] .ag-btn, html[data-theme="dark"] .ag-btn *, html[data-theme="dark"] .xs, html[data-theme="dark"] .xs * { color: #0c1330 !important; }
      `;
      document.head.appendChild(st);
    }
    const judge = () => {
      try {
        const bg = getComputedStyle(document.documentElement).getPropertyValue("--bg").trim();
        let r = 245, g = 248, b = 255;
        if (bg.startsWith("#")) {
          const h = bg.length === 4 ? bg.replace(/([0-9a-f])/gi, "$1$1") : bg;
          r = parseInt(h.slice(1, 3), 16); g = parseInt(h.slice(3, 5), 16); b = parseInt(h.slice(5, 7), 16);
        } else if (bg.startsWith("rgb")) {
          const m = bg.match(/\d+/g) || [];
          r = +m[0] || r; g = +m[1] || g; b = +m[2] || b;
        }
        const dark = (0.299 * r + 0.587 * g + 0.114 * b) < 128;
        document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
      } catch {}
    };
    judge();
    const t = setInterval(judge, 1200);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const h = (e) => {
      const nm = (e.detail && e.detail.name) || "";
      setDraftMsg("تعديلك" + (nm ? " على «" + nm + "»" : "") + " أُرسل بنجاح - الكتاب بانتظار اعتماد المدير العام");
      setTimeout(() => setDraftMsg(""), 8000);
    };
    window.addEventListener("tpms:draft-sent", h);
    return () => window.removeEventListener("tpms:draft-sent", h);
  }, []);
  useEffect(() => {
    if (!me || !me.id) return;
    let ch = null; let dead = false;
    (async () => {
      try {
        const { supabase } = await import("./supabaseClient.js");
        if (dead) return;
        ch = supabase.channel("rt-approvals-" + me.id)
          .on("postgres_changes", { event: "UPDATE", schema: "public", table: "approval_requests" }, (p) => {
            try {
              const n = p.new || {};
              if (n.requested_by === me.id && (n.status === "approved" || n.status === "rejected")) {
                setApprovalMsg({ status: n.status, note: n.admin_note || "" });
              }
            } catch {}
          }).subscribe();
      } catch {}
    })();
    return () => { dead = true; try { ch && ch.unsubscribe(); } catch {} };
  }, [me && me.id]);
  useEffect(() => {
    if (!dataStale) { setStaleBy(""); return; }
    (async () => {
      try {
        const { supabase } = await import("./supabaseClient.js");
        const { data: b } = await supabase.from("rel_books").select("updated_by").not("updated_by", "is", null).order("updated_at", { ascending: false }).limit(1).maybeSingle();
        if (b && b.updated_by && (!me || b.updated_by !== me.id)) {
          const { data: pr } = await supabase.from("profiles").select("full_name").eq("id", b.updated_by).maybeSingle();
          if (pr && pr.full_name) setStaleBy(pr.full_name);
        } else if (b && b.updated_by && me && b.updated_by === me.id) {
          setDataStale(false);
          try {
            const { data: rq } = await supabase.from("approval_requests")
              .select("status, admin_note").eq("requested_by", me.id).in("status", ["approved", "rejected"])
              .order("created_at", { ascending: false }).limit(1).maybeSingle();
            if (rq) setApprovalMsg({ status: rq.status, note: rq.admin_note || "" });
          } catch {}
        }
      } catch {}
    })();
  }, [dataStale]);
  useEffect(() => {
    const chan = supabase.channel("rt:books")
      .on("postgres_changes", { event: "*", schema: "public", table: "rel_books" }, () => {
        try {
          const mine = Date.now() - (window.__tpmsLastSave || 0) < 5000;
          if (!mine) { const _pr = (typeof window !== "undefined" && window.__tpmsProfile) || null; const _deny = _pr && _pr.role && !(_pr.isOwner || _pr.is_owner || _pr.role === "admin" || _pr.role === "project_manager" || (_pr.role === "translator" && ((_pr.assigned_books || _pr.assignedBooks || []).length > 0))); if (!_deny) setDataStale(true); }
        } catch {}
      }).subscribe();
    return () => { try { supabase.removeChannel(chan); } catch {} };
  }, []);
  const [seatName, setSeatName] = useState("");
  const seatCh = React.useRef(null);
  useEffect(() => {
    if (!me || !me.id) return;
    const ch = supabase.channel("tpms:editing", { config: { presence: { key: me.id } } });
    const check = () => {
      try {
        const st = ch.presenceState();
        let other = "";
        for (const k of Object.keys(st)) {
          if (k === me.id) continue;
          const metas = st[k] || [];
          for (const m of metas) {
            if (m && m.bookId && detailId && m.bookId === detailId) other = m.name || "مستخدم آخر";
          }
        }
        setSeatName(other);
      } catch {}
    };
    ch.on("presence", { event: "sync" }, check).subscribe(async (st) => {
      if (st === "SUBSCRIBED") { try { await ch.track({ bookId: detailId || null, name: me.fullName || "" }); } catch {} }
    });
    seatCh.current = ch;
    return () => { try { supabase.removeChannel(ch); } catch {} seatCh.current = null; };
  }, [me && me.id]);
  useEffect(() => {
    (async () => { try { if (seatCh.current) await seatCh.current.track({ bookId: detailId || null, name: (me && me.fullName) || "" }); } catch {} })();
    setSeatName("");
  }, [detailId]);
  const storeReadyRef = useRef(false);
  storeReadyRef.current = storeReady;
  useEffect(() => {
    const flush = () => {
      try {
        if (storeReadyRef.current && typeof window !== "undefined" && window.storage) {
          const j = JSON.stringify(dataRef.current.publishers || []);
          window.storage.set("pm:data", j);
          try { if (window.pmdb && window.pmdb.appSave) window.pmdb.appSave(j); } catch {}
        }
      } catch {}
    };
    window.addEventListener("beforeunload", flush);
    window.addEventListener("pagehide", flush);
    const vis = () => { if (document.visibilityState === "hidden") flush(); };
    document.addEventListener("visibilitychange", vis);
    return () => { window.removeEventListener("beforeunload", flush); window.removeEventListener("pagehide", flush); document.removeEventListener("visibilitychange", vis); };
  }, []);
  const exportBackup = async () => {
    try {
      flash("انتظر دقائق لتجمع ملفاتك من النظام السحابي...");
      const d = dataRef.current;
      let setngs = {};
      try { const r = await window.storage.get(d.settingsKey); if (r && r.value) setngs = JSON.parse(r.value); } catch {}
      const cloud = {};
      try {
        const { supabase } = await import("./supabaseClient.js");
        const TABLES = ["app_state","publishers","projects","books","rel_publishers","rel_projects","rel_books","rel_book_finance","rel_book_deliveries","rel_book_files","book_files","book_stages","book_edit_drafts","file_chain","teams","team_members","team_projects","team_rules","tasks","task_comments","task_files","messages","message_reads","notifications","agenda_events","agenda_grants","events","auto_events","fairs","loc_files","loc_segments","approval_requests","subscriptions","subscription_requests","payments","plans","tickets","org_notes","nps_scores","member_access","vendors_grants","profiles","organizations","user_prefs","platform_settings","audit_log","cancel_reasons"];
        for (const t of TABLES) {
          try { const { data, error } = await supabase.from(t).select("*").limit(5000); if (!error && data && data.length) cloud[t] = data; } catch {}
        }
      } catch {}
      const backup = { app: "tpms", v: 2, kind: "cloud-full", when: new Date().toISOString(), data: d.publishers, events: d.events, share: d.share, appTitle: d.appTitle, settings: setngs, cloud };
      const bytes = new TextEncoder().encode(JSON.stringify(backup, null, 2));
      const stamp = new Date().toISOString().slice(0, 16).replace(/[:T]/g, "-");
      const name = "tpms-cloud-backup-" + stamp + ".json";
      if (window.pmSaveBytes) { window.pmSaveBytes(name, bytes); }
      else { const blob = new Blob([bytes], { type: "application/json" }); const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 4000); }
      flash("نُزّلت نسخة سحابية شاملة \u2713 (" + Object.keys(cloud).length + " جدولًا)");
    } catch (e) { flash("تعذّر إنشاء النسخة"); }
  };
  const doFolderSave = async () => {
    try {
      let base = savePathRef.current;
      if (!base) { base = await window.pmChooseFolder(); if (!base) { flash("لم يُختَر مجلّد"); return; } setSavePath(base); try { await window.storage.set("pm:savePath", base); } catch {} }
      flash("جارٍ الحفظ في المجلّد…");
      const d = dataRef.current;
      const wd = await window.pmWriteData(base, JSON.stringify({ app: "tpms", v: 1, when: new Date().toISOString(), data: d.publishers, events: d.events, share: d.share, appTitle: d.appTitle }));
      const r = await window.pmWriteTree(base, d.publishers, { explicit: true });
      if (r && r.ok) {
        const pr = (r.pruned && r.pruned.length) ? ("، حُذف " + r.pruned.length + " بقايا") : "";
        flash((base === "ZIP" ? "نُزّل ملف ZIP بالشجرة كاملة ✓ - " : "تم الحفظ ✓ - ") + (r.agencies || 0) + " جهة، " + (r.projects || 0) + " مشروع، " + (r.books || 0) + " كتاب، " + (r.files || 0) + " ملفّ" + pr);
      } else {
        const err = (r && r.errors && r.errors[0]) || (wd && wd.error) || "سبب غير معروف";
        flash("تعذّر الحفظ: " + err);
      }
    } catch (e) { flash("تعذّر الحفظ في المجلّد: " + String(e && e.message ? e.message : e)); }
  };
  const relinkFolder = async () => {
    try { const base = await window.pmChooseFolder(); if (base) { setSavePath(base); try { await window.storage.set("pm:savePath", base); } catch {} flash("تم تغيير مجلّد الحفظ ✓"); } } catch {}
  };
  const importBackup = (e) => {
    const f = e.target.files && e.target.files[0]; e.target.value = "";
    if (!f) return;
    const rd = new FileReader();
    rd.onload = () => {
      try {
        const o = JSON.parse(rd.result);
        const pubs = Array.isArray(o) ? o : (o && o.data);
        if (!Array.isArray(pubs)) { flash("ملف نسخة غير صالح"); return; }
        if (typeof window !== "undefined" && window.confirm && !window.confirm("استعادة النسخة ستستبدل كل البيانات الحالية. متابعة؟")) return;
        setPublishers(pubs);
        if (o && o.events) { setEvents(o.events); try { window.storage.set(agKey("pm:events"), JSON.stringify(o.events)); } catch {} }
        if (o && o.share) { setShare((x) => ({ ...x, ...o.share })); try { window.storage.set("pm:share", JSON.stringify(o.share)); } catch {} }
        if (o && o.appTitle) { setAppTitle(o.appTitle); try { window.storage.set("pm:appTitle", o.appTitle); } catch {} }
        if (o && o.settings && Object.keys(o.settings).length) { setSettings((x) => ({ ...x, ...o.settings })); try { window.storage.set(settingsKey, JSON.stringify(o.settings)); } catch {} }
        flash("تمت استعادة النسخة الاحتياطية \u2713");
      } catch (err) { flash("تعذّرت قراءة ملف النسخة"); }
    };
    rd.readAsText(f);
  };

  const publisher = publishers.find((p) => p.id === curPub);
  const project = publisher ? publisher.projects.find((j) => j.id === curProj) : null;
  const detailBook = project && detailId ? (project.works || []).find((w) => w.id === detailId) : null;
  const seenKey = me ? "pm:seen:" + me.id : null;
  const visibleIdsForSub = React.useMemo(() => {
    if (role !== "subuser") return [];
    const ids = [];
    publishers.forEach((p) => (p.projects || []).forEach((j) => {
      if ((j.status || "active") === "active") {
        ids.push("proj:" + j.id);
        (j.works || []).forEach((w) => { if ((w.status || "active") === "active" && (w.visibility ?? "shared") !== "private") ids.push("book:" + w.id); });
      }
    }));
    return ids;
  }, [publishers, role]);
  const [seen, setSeen] = useState([]);
  useEffect(() => {
    if (!storeReady || !seenKey || role !== "subuser") { setSeen([]); return; }
    let stored = null; try { stored = localStorage.getItem(seenKey); } catch {}
    if (stored == null) { try { localStorage.setItem(seenKey, JSON.stringify(visibleIdsForSub)); } catch {} setSeen(visibleIdsForSub); }
    else { try { setSeen(JSON.parse(stored)); } catch { setSeen([]); } }
  }, [storeReady, seenKey, role]);
  const _nvRole = ((typeof window !== "undefined" && window.__tpmsProfile) || {}).role || "";
  const newItems = (role === "subuser" && _nvRole !== "publisher" && _nvRole !== "أديب") ? visibleIdsForSub.filter((id) => !seen.includes(id)) : [];
  const ackNew = () => { try { if (seenKey) localStorage.setItem(seenKey, JSON.stringify(visibleIdsForSub)); } catch {} setSeen(visibleIdsForSub); };
  const [showTransAlerts, setShowTransAlerts] = useState(false);
  const today0v = (() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d.getTime(); })();
  const transAlerts = React.useMemo(() => {
    const out = [];
    publishers.forEach((p) => (p.projects || []).forEach((j) => {
      if ((j.status || "active") !== "active") return;
      (j.works || []).forEach((w) => {
        if ((w.status || "active") !== "active") return;
        if (w.transDeliveryDate && !w.transReceived) {
          const d = new Date(w.transDeliveryDate); if (isNaN(d.getTime())) return;
          d.setHours(0, 0, 0, 0);
          const diff = Math.round((d.getTime() - today0v) / 86400000);
          if (diff <= 7) out.push({ w, projId: j.id, pubName: p.name, projName: j.name, diff });
        }
      });
    }));
    out.sort((a, b) => a.diff - b.diff);
    return out;
  }, [publishers, today0v]);

  const openEditPub = (pub) => { setPName(pub.name || ""); setPNote(pub.note || ""); setPTag(pub.tag || "دار نشر"); setPIcon(pub.icon || "Library"); setPIconImg(pub.iconImg || null); setPColor(pub.color || C.pink); setEditPubId(pub.id); setShowAddPub(true); setMenuPub(null); };
  const addPublisher = () => {
    if (!pName.trim()) return;
    if (editPubId) {
      setPublishers((arr) => arr.map((x) => x.id === editPubId ? { ...x, name: pName.trim(), note: pNote.trim() || "", tag: (pTag || "").trim(), icon: pIcon, iconImg: pIconImg || null, color: pColor } : x));
    } else {
      setPublishers((arr) => [...arr, { id: crypto.randomUUID(), name: pName.trim(), note: pNote.trim() || "", tag: (pTag || "").trim(), icon: pIcon, iconImg: pIconImg || null, color: pColor, projects: [], status: "active" }]);
    }
    resetPub(); setEditPubId(null); setShowAddPub(false);
  };
  const removePublisher = (id) => setPublishers((arr) => arr.filter((x) => x.id !== id));
  // حالة الجهات (مثل المشاريع)
  const setPubStatus = (id, status) => setPublishers((arr) => arr.map((x) => x.id === id ? { ...x, status } : x));
  const purgePublisher = (id) => setPublishers((arr) => arr.filter((x) => x.id !== id));
  const archivePublisher = (x) => { setPubStatus(x.id, "archived"); setMenuPub(null); flash(`أُرشفت «${x.name}»`); };
  const trashPublisher = (x) => { setPubStatus(x.id, "trashed"); setMenuPub(null); flash(`نُقلت «${x.name}» إلى السلة`); };
  const restorePublisher = (x) => { setPubStatus(x.id, "active"); flash(`استُعيدت «${x.name}»`); };
  const deletePublisherForever = (x) => { purgePublisher(x.id); flash(`حُذفت «${x.name}» نهائيًا`); };
  const setPubIcon = (id, img) => setPublishers((arr) => arr.map((x) => x.id === id ? { ...x, iconImg: img } : x));

  const openEditProj = (proj) => { setJName(proj.name || ""); setJCat(proj.category || ""); setJDate(proj.date || today()); setJIcon(proj.icon || "Languages"); setJIconImg(proj.iconImg || null); setJDot(proj.dotColor || "rainbow"); setEditProjId(proj.id); setShowAddProj(true); setMenuProj(null); };
  const addProject = () => {
    if (!jName.trim()) return;
    if (editProjId) {
      setPublishers((arr) => arr.map((p) => ({ ...p, projects: (p.projects || []).map((j) => j.id === editProjId ? { ...j, name: jName.trim(), category: jCat.trim(), date: jDate, icon: jIcon, iconImg: jIconImg || null, dotColor: jDot } : j) })));
    } else {
      setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: [...p.projects, { id: crypto.randomUUID(), name: jName.trim(), category: jCat.trim(), date: jDate, icon: jIcon, iconImg: jIconImg || null, dotColor: jDot, status: "active", works: [] }] } : p));
    }
    resetProj(); setEditProjId(null); setShowAddProj(false);
  };
  const addWork = () => {
    if (!bk.name.trim()) return;
    const book = { ...bk, id: crypto.randomUUID(), name: bk.name.trim() };
    // ربط أيقونة الكتاب بالغلاف الأجنبي تلقائيًّا عند الإنشاء
    if (!book.iconImg && book.coverFr && (book.coverFr.type || "").startsWith("image")) book.iconImg = book.coverFr.data;
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === curProj ? { ...j, works: [...(j.works || []), book] } : j) } : p));
    resetWork(); setShowAddWork(false);
  };
  const removeWork = (wid) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === curProj ? { ...j, works: (j.works || []).filter((w) => w.id !== wid) } : j) } : p));
  const updateBook = (bid, updater) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === curProj ? { ...j, works: (j.works || []).map((w) => w.id === bid ? (typeof updater === "function" ? updater(w) : { ...w, ...updater }) : w) } : j) } : p));
  useEffect(() => {
    const h = (e) => { const a = e.detail; if (a === "settings") setShowSettings(true); else if (a === "settings2") setShowSettings2(true); else if (a === "assign") setShowAssign(true); else if (a === "agenda") { setPage("agenda"); setEditMode(false); } else if (a === "cover") { setPage("cover"); setEditMode(false); } };
    window.addEventListener("pm:menu", h);
    return () => window.removeEventListener("pm:menu", h);
  }, []);
  const updateBookFinance = (projId, bookId, updater) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === projId ? { ...j, works: (j.works || []).map((w) => w.id === bookId ? { ...w, finance: typeof updater === "function" ? updater(w.finance) : { ...(w.finance || {}), ...updater } } : w) } : j) } : p));
  const openProject = (j) => { setCurProj(j.id); setEditMode(false); setPage("works"); };
  const openMarketing = () => setPage("marketing");
  const updateProject = (pid, updater) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === pid ? (typeof updater === "function" ? updater(j) : { ...j, ...updater }) : j) } : p));
  const openExportAll = () => setExportData({
    rows: collectRows(publishers),
    title: isManager ? "كل الوكالات ودور النشر" : "الكتب في نطاق عملي",
    name: isManager ? "كتب_ترجمتك" : "بيانات الكتب",
  });
  const openExportProject = () => setExportData({ rows: collectRows([{ ...publisher, projects: [project] }]), title: `${publisher.name} › ${project.name}`, name: project ? project.name : "كتب" });
  // تغيير حالة مشروع داخل الوكالة الحالية
  const setProjStatus = (jid, status) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === jid ? { ...j, status } : j) } : p));
  // حذف نهائي يدوي من سلة المهملات فقط
  const purgeProject = (jid) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.filter((j) => j.id !== jid) } : p));

  const archiveProject = (j) => { setProjStatus(j.id, "archived"); setMenuProj(null); flash(`تمت أرشفة «${j.name}»`); };
  const trashProject = (j) => { setProjStatus(j.id, "trashed"); setMenuProj(null); flash(`نُقل «${j.name}» إلى سلة المهملات`); };
  const restoreProject = (j) => { setProjStatus(j.id, "active"); flash(`استُعيد «${j.name}»`); };
  const deleteForever = (j) => { purgeProject(j.id); flash(`حُذف «${j.name}» نهائيًا`); };

  // حالة الكتب (مثل المشاريع)
  const setWorkStatus = (wid, status) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === curProj ? { ...j, works: (j.works || []).map((w) => w.id === wid ? { ...w, status } : w) } : j) } : p));
  const purgeWork = (wid) =>
    setPublishers((arr) => arr.map((p) => p.id === curPub ? { ...p, projects: p.projects.map((j) => j.id === curProj ? { ...j, works: (j.works || []).filter((w) => w.id !== wid) } : j) } : p));
  const archiveWork = (w) => { setWorkStatus(w.id, "archived"); setMenuWork(null); flash(`أُرشف «${w.name}»`); };
  const trashWork = (w) => { setWorkStatus(w.id, "trashed"); setMenuWork(null); flash(`نُقل «${w.name}» إلى السلة`); };
  const restoreWork = (w) => { setWorkStatus(w.id, "active"); flash(`استُعيد «${w.name}»`); };
  const deleteWorkForever = (w) => { purgeWork(w.id); flash(`حُذف «${w.name}» نهائيًا`); };

  // دوال عامّة للسلّة الموحّدة (تعمل من أي مكان بلا اعتماد على السياق الحالي)
  const restoreProjectAt = (pubId, projId) =>
    setPublishers((arr) => arr.map((p) => p.id === pubId ? { ...p, projects: p.projects.map((j) => j.id === projId ? { ...j, status: "active" } : j) } : p));
  const purgeProjectAt = (pubId, projId) =>
    setPublishers((arr) => arr.map((p) => p.id === pubId ? { ...p, projects: p.projects.filter((j) => j.id !== projId) } : p));
  const restoreWorkAt = (pubId, projId, workId) =>
    setPublishers((arr) => arr.map((p) => p.id === pubId ? { ...p, projects: p.projects.map((j) => j.id === projId ? { ...j, works: (j.works || []).map((w) => w.id === workId ? { ...w, status: "active" } : w) } : j) } : p));
  const purgeWorkAt = (pubId, projId, workId) =>
    setPublishers((arr) => arr.map((p) => p.id === pubId ? { ...p, projects: p.projects.map((j) => j.id === projId ? { ...j, works: (j.works || []).filter((w) => w.id !== workId) } : j) } : p));
  const setBookReceived = (projId, bookId, val) =>
    setPublishers((arr) => arr.map((pp) => pp.id === curPub ? { ...pp, projects: pp.projects.map((j) => j.id === projId ? { ...j, works: (j.works || []).map((w) => w.id === bookId ? { ...w, transReceived: val } : w) } : j) } : pp));

  const openPublisher = (id) => { setCurPub(id); setEditMode(false); setPage("projects"); };

  return (
    <><UIDebugPanel isOwner={isAppOwner} />
    <div dir="rtl" className="pm-root" style={settings.bg ? { ...S.root, backgroundImage: ((settings.bgDim || 0) !== 0 ? `linear-gradient(${(settings.bgDim < 0 ? "rgba(0,0,0," + (Math.abs(settings.bgDim) / 100) + ")" : "rgba(255,255,255," + (settings.bgDim / 100) + ")")}, ${(settings.bgDim < 0 ? "rgba(0,0,0," + (Math.abs(settings.bgDim) / 100) + ")" : "rgba(255,255,255," + (settings.bgDim / 100) + ")")}), url(${settings.bg})` : `url(${settings.bg})`), backgroundSize: (settings.bgFit || "cover"), backgroundPosition: (settings.bgPos || "center"), backgroundRepeat: (settings.bgFit === "auto" ? "repeat" : "no-repeat")} : S.root}>
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true"><defs>
        <linearGradient id="pmRainbow" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#e23d3d" /><stop offset="0.17" stopColor="#f59e0b" /><stop offset="0.33" stopColor="#e8ff00" />
          <stop offset="0.5" stopColor="#16a34a" /><stop offset="0.66" stopColor="#14b8a6" /><stop offset="0.83" stopColor="#0ea5e9" /><stop offset="1" stopColor="#7c3aed" />
        </linearGradient>
      </defs></svg>
      {typeof window !== "undefined" && window.pmChooseFolder && page !== "cover" && (
        <div data-tauri-drag-region="" style={{ ...S.titlebar, background: titleTheme.grad }}>
          <span key={verseIdx} className="fade-in" data-tauri-drag-region="" style={{ ...S.titlebarBrand, color: titleTheme.text, fontSize: settings.size }}>{displayedVerse}</span>
        </div>
      )}
      {role === "subuser" && newItems.length > 0 && (
        <div style={{ position: "fixed", top: 8, left: "50%", transform: "translateX(-50%)", zIndex: 8000, background: "#14b8a6", color: "#fff", padding: "8px 16px", borderRadius: 0, fontWeight: 800, fontSize: 14, boxShadow: "0 6px 20px rgba(20,184,166,0.4)", display: "flex", gap: 12, alignItems: "center" }}>
           لديك {newItems.length} تحديثًا جديدًا (مشاريع/كتب أُضيفت لك)
          <button className="ghost" style={{ background: "var(--surface)", color: "#14b8a6", border: "none", borderRadius: 8, padding: "3px 10px", fontWeight: 800, cursor: "pointer" }} onClick={ackNew}>تمّ الاطّلاع</button>
        </div>
      )}
      {role === "manager" && transAlerts.length > 0 && (
        <button onClick={() => setShowTransAlerts(true)} style={{ position: "fixed", top: 8, left: "50%", transform: "translateX(-50%)", zIndex: 8000, background: transAlerts.some((a) => a.diff < 0) ? "#e23d3d" : "#f59e0b", color: "#fff", padding: "8px 16px", borderRadius: 999, fontWeight: 800, fontSize: 14, border: "none", cursor: "pointer", boxShadow: "0 6px 20px rgba(226,61,61,0.32)" }}>
           {transAlerts.length} تسليم مترجم {transAlerts.some((a) => a.diff < 0) ? "متأخّر/يقترب" : "يقترب"}
        </button>
      )}
      {page !== "cover" && (
        <div className="pm-homerow" style={S.homeRow}>
          <button style={S.homeBtn} className="ghost" aria-label="الرئيسية"
            onClick={() => { setPage("cover"); setEditMode(false); }}>
            <img src="/logo.png?v=2" alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit", display: "block" }} />
          </button>
          <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
          {page === "projects" && publisher && (
            <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-start" }}>
              {(!readOnly || share?.stats) && <button className="pm-act" onClick={() => setPage("stats")}><BarChart3 size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">إحصائيات</span></button>}
              <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 5, width: 66, padding: "4px 2px" }}>
                <span style={{ fontFamily: mono, fontSize: 23, fontWeight: 800, color: "var(--accent)", lineHeight: 1 }}>{toAr((publisher.projects || []).filter((j) => (j.status || "active") === "active").length)}</span>
                <span style={{ fontFamily: arab, fontSize: 11.5, color: "var(--faint)" }}>مشروع</span>
              </div>
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
            {page === "works" && project && <button className="pm-act" onClick={() => setPage("deliveries")}><ClipboardCheck size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">التسليمات</span></button>}
            {page === "works" && project && (!readOnly || share?.marketing) && <button className="pm-act" onClick={() => setPage("marketing")}><Megaphone size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">التوزيع والتسويق</span></button>}
            {page === "works" && project && <button className="pm-act" onClick={() => setPage("finance")}><Wallet size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">المحاسبة</span></button>}
            <button className="pm-act mob-hide" onClick={openExportAll}><FileSpreadsheet size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">تصدير Excel</span></button>
            <ToolsLauncher onOpen={(id) => { setPage("tool-" + id); setEditMode(false); }} />
            {isManager && <button className="pm-act mob-hide" onClick={async () => { try { const r = await orgDesktopBackup(dataRef.current, flash); flash("نزلت النسخة ✓ " + r.books + " كتابا و" + r.files + " ملفا حقيقيا"); } catch (e) { flash("تعذرت النسخة: " + e.message); } }} onContextMenu={(e) => { e.preventDefault(); if (restoreRef.current) restoreRef.current.click(); }}><Download size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">على سطح المكتب</span></button>}
            <button className="pm-act" onClick={() => { setPage("agenda"); setEditMode(false); }}><CalendarDays size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">الأجندة</span></button>
            <button className="pm-act mob-hide" onClick={() => setShowSearch(true)}><Search size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">بحث</span></button>
            {isManager && <button className="pm-act mob-hide" onClick={() => setShowTrash(true)}><Trash2 size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">المحذوفات</span></button>}
            {isManager && <button className="pm-act mob-hide" onClick={() => setShowDb(true)}><Database size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">قاعدة البيانات</span></button>}
            {isManager && <button className="pm-act mob-hide" onClick={doFolderSave} onContextMenu={(e) => { e.preventDefault(); relinkFolder(); }}><Save size={22} color={"var(--icon-color)"} /><span className="pm-act-lbl">حفظ</span></button>}
            <button className="pm-act" onClick={() => setConfirmLogout(true)}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--icon-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg><span className="pm-act-lbl">خروج</span></button>
            {confirmLogout && (
              <div style={{ position: "fixed", inset: 0, zIndex: 1200, background: "rgba(0,0,0,.55)", display: "flex", alignItems: "center", justifyContent: "center", direction: "rtl" }} onClick={() => setConfirmLogout(false)}>
                <div className="tp-zoom" style={{ width: "min(430px, 92vw)", background: "color-mix(in srgb, var(--surface) 78%, transparent)", backdropFilter: "blur(18px)", WebkitBackdropFilter: "blur(18px)", borderRadius: 0, padding: "20px", boxShadow: "4px 4px 0 color-mix(in srgb, var(--accent) 30%, transparent)" }} onClick={(e) => e.stopPropagation()}>
                  <div style={{ fontSize: 19, fontWeight: 900, color: "var(--text)", marginBottom: 14 }}>تسجيل الخروج</div>
                  <div style={{ fontSize: 14.5, lineHeight: 1.8, color: "var(--muted)", marginBottom: 18 }}>هل تحققت من حفظ ملفاتك قبل تسجيل الخروج؟</div>
                  <div style={{ display: "flex", gap: 10, justifyContent: "flex-start" }}>
                    <button onClick={() => { try { signOut(); } catch {} }} style={{ fontSize: 14, fontWeight: 800, padding: "9px 20px", borderRadius: 0, border: "none", background: "var(--accent)", color: "#fff", cursor: "pointer", fontFamily: "inherit" }}>خروج</button>
                    <button onClick={() => setConfirmLogout(false)} style={{ fontSize: 14, fontWeight: 700, padding: "9px 20px", borderRadius: 0, border: "1px solid var(--lineHi)", background: "transparent", color: "var(--text)", cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {page === "works" && project && (
            <div style={{ display: "flex", alignItems: "center", gap: 18, flexWrap: "wrap" }}>
              <span style={{ fontFamily: arab, fontSize: 12.5, color: "var(--muted)", marginLeft: 4 }}>عرض حسب:</span>
              {VIEWS.map((v) => (
                <button key={String(v.key)} className={"pm-vb" + (groupBy === v.key ? " on" : "")} onClick={() => setGroupBy(v.key)}>{v.label}</button>
              ))}
            </div>
          )}
          </div>
          </div>
        </div>
      )}
      <input ref={restoreRef} type="file" accept="application/json,.json" style={{ display: "none" }} onChange={importBackup} />
      <style>{CSS}</style>

      <div key={page} className="fade-in">
      {page === "cover" && <Cover onEnter={() => setPage("publishers")} userName={me?.fullName} coverTitle={coverTitle} />}
      {page === "agenda" && <Agenda events={events} publishers={publishers} onAdd={addEvent} onUpdate={updateEvent} onDelete={deleteEvent} onBack={() => { setPage("publishers"); setEditMode(false); }} fairs={fairs} onSaveFair={saveFair} onAddFair={addFair} onRemoveFair={removeFair} onFairToAgenda={fairToAgenda} />}
      {page === "tool-scanner" && (
        <div className="fade-in tool-page" style={{ maxWidth: 1200, margin: "0 auto", padding: "18px 22px 70px", direction: "rtl" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
            <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 21, fontWeight: 800, color: "var(--text)" }}>ماسح العقود</div>
            <button className="ghost" onClick={() => setPage("publishers")} style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13, fontWeight: 800, padding: "8px 18px", cursor: "pointer" }}>العودة</button>
          </div>
          <div className="pm-tile" style={{ padding: 24, cursor: "default" }}>
            <__Suspense fallback={null}><ContractScanner team={null} me={null} /></__Suspense>
          </div>
        </div>
      )}
      {page === "tool-counter" && (
        <div className="fade-in tool-page" style={{ maxWidth: 1200, margin: "0 auto", padding: "18px 22px 70px", direction: "rtl" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
            <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 21, fontWeight: 800, color: "var(--text)" }}>عداد الكلمات والتسعير</div>
            <button className="ghost" onClick={() => setPage("publishers")} style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13, fontWeight: 800, padding: "8px 18px", cursor: "pointer" }}>العودة</button>
          </div>
          <div className="pm-tile" style={{ padding: 24, cursor: "default" }}>
            <__Suspense fallback={null}><WordCounter /></__Suspense>
          </div>
        </div>
      )}
      {page === "tool-diff" && (
        <div className="fade-in tool-page" style={{ maxWidth: 1200, margin: "0 auto", padding: "18px 22px 70px", direction: "rtl" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
            <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 21, fontWeight: 800, color: "var(--text)" }}>مقارن النسخ</div>
            <button className="ghost" onClick={() => setPage("publishers")} style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13, fontWeight: 800, padding: "8px 18px", cursor: "pointer" }}>العودة</button>
          </div>
          <div className="pm-tile" style={{ padding: 24, cursor: "default" }}>
            <__Suspense fallback={null}><VersionDiff /></__Suspense>
          </div>
        </div>
      )}

      {page === "appmanage" && <React.Suspense fallback={null}><AppManagePage me={(typeof window !== "undefined" && window.__tpmsProfile) || {}} onClose={() => setPage("cover")} /></React.Suspense>}
      {page === "writers" && <RoleHub sub="قسم الأدباء" onClose={() => setPage("cover")} />}
      {page === "pubs" && <RoleHub sub="قسم الناشرين" onClose={() => setPage("cover")} />}
      {page === "teams" && <React.Suspense fallback={null}><TeamsHubPage isOwner={(typeof window !== "undefined" && window.__tpmsProfile && window.__tpmsProfile.isOwner) || false} onClose={() => setPage("cover")} /></React.Suspense>}
      {page === "platform" && <React.Suspense fallback={null}><PlatformPage onClose={() => setPage("cover")} /></React.Suspense>}
      {page === "publishers" && (
        <Publishers
          title={appTitle} share={share} titleColor={titleColorVal}
          publishers={publishers} editMode={readOnly ? false : editMode}
          onToggleEdit={() => setEditMode((v) => !v)} onSettings={() => setShowSettings(true)}
          onOpen={openPublisher} onOpenMenu={setMenuPub} onRestore={restorePublisher} onTrash={trashPublisher} onDeleteForever={deletePublisherForever} onExport={openExportAll} onAssign={() => setShowAssign(true)}
          onBack={() => { setPage("cover"); setEditMode(false); }}
          onAdd={() => setShowAddPub(true)}
        />
      )}

      {page === "projects" && publisher && (
        <Projects
          share={share}
          publisher={publisher} editMode={readOnly ? false : editMode}
          onToggleEdit={() => setEditMode((v) => !v)}
          onSettings={() => setShowSettings(true)} onToggleReceived={setBookReceived}
          onOpen={openProject} onOpenMenu={setMenuProj} onStats={() => setPage("stats")}
          onRestore={restoreProject} onTrash={trashProject} onDeleteForever={deleteForever}
          onBack={() => { setPage("publishers"); setEditMode(false); }}
          onAdd={() => setShowAddProj(true)}
        />
      )}

      {page === "stats" && publisher && (
        <Stats publishers={publishers} publisher={publisher} onBack={() => setPage("projects")} />
      )}

      {page === "works" && publisher && project && (
        <Works
          share={share}
          publisher={publisher} project={project} groupBy={groupBy} editMode={readOnly ? false : editMode}
          onToggleEdit={() => setEditMode((v) => !v)}
          onSettings={() => setShowSettings(true)}
          onTrash={trashWork} onRestore={restoreWork} onDeleteForever={deleteWorkForever} onOpenMenu={setMenuWork} onOpenBook={(w) => setDetailId(w.id)} onExport={openExportProject}
          onMarketing={openMarketing} onDeliveries={() => setPage("deliveries")} onFinance={() => setPage("finance")}
          onBack={() => { setPage("projects"); setEditMode(false); }}
          onAdd={() => setShowAddWork(true)}
        />
      )}

      {page === "deliveries" && publisher && project && (
        <Deliveries
          publisher={publisher} project={project}
          onUpdateBook={updateBook}
          onBack={() => setPage("works")}
        />
      )}

      {page === "marketing" && publisher && project && (
        <Marketing
          publisher={publisher} project={project}
          onUpdate={(updater) => updateProject(project.id, updater)}
          onBack={() => setPage("works")}
        />
      )}

      {page === "finance" && publisher && (
        <Finance
          publisher={publisher}
          onUpdateFinance={updateBookFinance}
          onBack={() => setPage("works")}
        />
      )}

      {menuProj && (
        <ProjectActionModal
          project={(publisher && publisher.projects.find((j) => j.id === menuProj.id)) || menuProj} color={publisher ? publisher.color : C.pink} onEdit={openEditProj}
          onArchive={archiveProject} onTrash={trashProject}
          onSetIcon={(img) => updateProject(menuProj.id, { iconImg: img })}
          onClose={() => setMenuProj(null)}
        />
      )}

      {menuWork && (
        <BookActionModal
          book={(project && (project.works || []).find((w) => w.id === menuWork.id)) || menuWork}
          color={publisher ? publisher.color : C.pink}
          onArchive={archiveWork} onTrash={trashWork}
          onClose={() => setMenuWork(null)}
        />
      )}

      </div>
      {menuPub && (
        <PublisherActionModal
          pub={publishers.find((x) => x.id === menuPub.id) || menuPub}
          onArchive={archivePublisher} onTrash={trashPublisher}
          onSetIcon={(img) => setPubIcon(menuPub.id, img)}
          onEdit={openEditPub}
          onClose={() => setMenuPub(null)}
        />
      )}

      {showAssign && (
        <AssignModal
          publishers={publishers} users={users}
          onSave={(id, patch) => setAssignment(id, patch)}
          onClose={() => setShowAssign(false)}
        />
      )}

      {showDb && (
        <DbModal publishers={publishers} onRestore={restoreFromDb} onClose={() => setShowDb(false)} />
      )}

      {showSearch && (
        <SearchModal publishers={publishers} onGo={goToBook} onClose={() => setShowSearch(false)} />
      )}

      {showTrash && (
        <TrashModal
          publishers={publishers}
          onRestorePub={(p) => restorePublisher(p)} onPurgePub={(p) => deletePublisherForever(p)}
          onRestoreProj={restoreProjectAt} onPurgeProj={purgeProjectAt}
          onRestoreWork={restoreWorkAt} onPurgeWork={purgeWorkAt}
          onClose={() => setShowTrash(false)}
        />
      )}

      {showSettings2 && <Settings2 onClose={() => setShowSettings2(false)} settings={settings} onSave={saveSettings} appName={appTitle} onSaveAppName={saveAppTitle} coverName={coverTitle} onSaveCoverName={saveCoverTitle} isAdminUser={isManager} isOwner={isAppOwner} />}
      {showSettings && (
        <SettingsModal
          isAdminUser={isManager}
          isOwner={isAppOwner} coverTitle={coverTitle} onSaveCoverTitle={saveCoverTitle}
          appTitle={appTitle} onSaveAppTitle={saveAppTitle}
          settings={settings} onSave={saveSettings}
          editMode={readOnly ? false : editMode} onToggleEdit={() => setEditMode((v) => !v)}
          share={share} onShare={saveShare}
          onClose={() => setShowSettings(false)}
        />
      )}

      {showTransAlerts && (
        <div style={S.overlay} className="fade-in" onClick={() => setShowTransAlerts(false)}>
          <div style={{ ...S.modal, maxWidth: 560 }} className="modal-pop" onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHead}>
              <h3 style={S.modalTitle}>تنبيهات تسليمات المترجمين</h3>
              <CloseBtn onClose={() => setShowTransAlerts(false)} />
            </div>
            {transAlerts.length === 0 ? (
              <div style={S.emptyHint}>لا تسليمات قريبة أو متأخّرة.</div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {transAlerts.map(({ w, projId, pubName, projName, diff }) => (
                  <div key={w.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, border: `1px solid ${"var(--lineHi)"}`, background: diff < 0 ? "rgba(226,61,61,0.07)" : "rgba(245,158,11,0.07)" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 800 }}>{w.name}</div>
                      <div style={{ fontSize: 14, color: "var(--faint)" }}>المترجم: {w.transName || "-"} · {pubName} / {projName}</div>
                      <div style={{ fontSize: 14, color: diff < 0 ? "#e23d3d" : "#b45309", fontWeight: 700 }}>
                        {diff < 0 ? `متأخّر ${Math.abs(diff)} يومًا` : diff === 0 ? "مستحقّ اليوم" : `خلال ${diff} يومًا`} · {fmtDate(w.transDeliveryDate)}
                      </div>
                    </div>
                    <button className="save-btn" style={{ ...S.saveBtn, padding: "7px 12px" }} onClick={() => setBookReceived(projId, w.id, true)}>تمّ الاستلام</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {detailBook && (
        <BookDetailModal
          book={detailBook} color={publisher ? publisher.color : C.pink}
          onUpdate={(updater) => updateBook(detailBook.id, updater)}
          onClose={() => setDetailId(null)}
        />
      )}

      {exportData && (
        <ExportModal
          rows={exportData.rows} defaultName={exportData.name}
          color={publisher ? publisher.color : C.pink} onClose={() => setExportData(null)}
        />
      )}

      {saveState !== "idle" && (
        <div style={{ ...S.savePill, ...(saveState === "error" ? S.savePillErr : (saveState === "saved" ? S.savePillOk : {})) }}>
          {saveState === "saving" ? "جارٍ الحفظ…" : saveState === "saved" ? "محفوظ ✓" : "تعذّر الحفظ - البيانات كبيرة"}
        </div>
      )}

      {toast && <div style={S.toast} className="toast-pop">{toast}</div>}

      {showAddPub && (
        <AddPubModal
          name={pName} setName={setPName} note={pNote} setNote={setPNote}
          tag={pTag} setTag={setPTag} icon={pIcon} setIcon={setPIcon} iconImg={pIconImg} setIconImg={setPIconImg} color={pColor} setColor={setPColor}
          editing={!!editPubId}
          onClose={() => { setShowAddPub(false); resetPub(); setEditPubId(null); }} onSave={addPublisher}
        />
      )}

      {showAddProj && publisher && (
        <AddProjModal
          color={publisher.color} name={jName} setName={setJName} date={jDate} setDate={setJDate} icon={jIcon} setIcon={setJIcon} iconImg={jIconImg} setIconImg={setJIconImg} dot={jDot} setDot={setJDot} cat={jCat} setCat={setJCat}
          title={editProjId ? "تعديل المشروع" : "إضافة مشروع جديد"} label={editProjId ? "حفظ التعديل" : "إضافة المشروع"}
          onClose={() => { setShowAddProj(false); resetProj(); setEditProjId(null); }} onSave={addProject}
        />
      )}

      {showAddWork && publisher && project && (
        <AddBookModal
          projectName={project.name} color={publisher.color} bk={bk} setB={setB}
          onClose={() => { setShowAddWork(false); resetWork(); }} onSave={addWork}
        />
      )}

      {approvalMsg && (
        <div className="fade-in" style={{ position: "fixed", top: 14, left: "50%", transform: "translateX(-50%)", zIndex: 952, direction: "rtl", background: "var(--surface)", border: "1.5px solid " + (approvalMsg.status === "approved" ? "#34d399" : "#e23d3d"), borderRadius: 12, padding: "9px 16px", boxShadow: "0 8px 26px rgba(0,0,0,.35)", maxWidth: "min(560px, 92vw)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 14, fontWeight: 700, color: "var(--text)" }}>
              تحديث بشأن طلب تعديل كتاب: {approvalMsg.status === "approved" ? "وافق المدير العام" : "رفض المدير العام"}
            </span>
            {approvalMsg.note && <button className="ag-btn xs" onClick={() => setShowNote(!showNote)}>{showNote ? "إخفاء الملاحظة" : "ملاحظة المدير"}</button>}
            <button className="ag-btn xs" onClick={() => { setApprovalMsg(null); setShowNote(false); }}>اطلعت ✓</button>
          </div>
          {showNote && approvalMsg.note && (
            <div style={{ marginTop: 8, fontSize: 13, lineHeight: 1.8, color: "var(--text)", borderTop: "1px dashed var(--line)", paddingTop: 8 }}>{approvalMsg.note}</div>
          )}
        </div>
      )}
      {agCtrl && <React.Suspense fallback={null}><AgendaControlLazy onClose={() => setAgCtrl(false)} /></React.Suspense>}
      <React.Suspense fallback={null}><ConfirmDialogLazy /></React.Suspense>
      {draftMsg && (
        <div className="fade-in" style={{ position: "fixed", top: 14, left: "50%", transform: "translateX(-50%)", zIndex: 951, display: "flex", alignItems: "center", gap: 10, background: "var(--surface)", border: "1.5px solid #34d399", borderRadius: 12, padding: "9px 16px", boxShadow: "0 8px 26px rgba(0,0,0,.35)", direction: "rtl" }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: "var(--text)" }}>{draftMsg}</span>
          <button className="ag-btn xs" onClick={() => setDraftMsg("")}>حسنًا</button>
        </div>
      )}
      {dataStale && (
        <div className="fade-in" style={{ position: "fixed", top: 14, left: "50%", transform: "translateX(-50%)", zIndex: 950, display: "flex", alignItems: "center", gap: 10, background: "var(--surface)", border: "1.5px solid #f59e0b", borderRadius: 12, padding: "9px 16px", boxShadow: "0 8px 26px rgba(0,0,0,.35)", direction: "rtl" }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: "var(--text)" }}> تحدّثت بيانات الكتب{staleBy ? " - عدّلها " + staleBy : " من مستخدم آخر"}</span>
          <button className="ag-btn xs" style={{ fontWeight: 800 }} onClick={() => { setDataStale(false); try { if (window.__tpmsRefresh) window.__tpmsRefresh(); else location.reload(); } catch { location.reload(); } }}>تحديث</button>
          <button className="ag-btn xs" onClick={() => setDataStale(false)}>اطلعت ✓</button>
        </div>
      )}
      {seatName && detailId && (
        <div className="fade-in" style={{ position: "fixed", top: 60, left: "50%", transform: "translateX(-50%)", zIndex: 949, background: "var(--surface)", border: "1.5px solid #eab308", borderRadius: 12, padding: "8px 16px", boxShadow: "0 8px 26px rgba(0,0,0,.3)", direction: "rtl", fontSize: 14, fontWeight: 800, color: "#a16207" }}>
           {seatName} يعمل على هذا الكتاب الآن
        </div>
      )}
    </div>
    </>
  );
}

/* ----------------------- الغلاف ----------------------- */
function Cover({ onEnter, userName, coverTitle }) {
  return (
    <div style={S.cover} className="pm-cover fade-in">
      <div className="pm-stripes" />
      <div style={S.coverInner}>
        <img src="/logo.png?v=2" alt="" style={S.coverLogo} />
        <h1 style={S.coverTitle}>{coverTitle}</h1>
        <div style={S.coverSubEn}>{userName || "Dalal NsrAllah"}</div>
        <button style={S.enter} className="pm-enter" onClick={onEnter}>بسم الله</button>
      </div>
    </div>
  );
}

/* ----------------- أزرار التنقّل المدمجة (بديل الشريط) ----------------- */
function NavBtns({ onBack, backLabel }) {
  return (
    <button style={S.exportBtn} className="ghost" onClick={onBack}><ChevronRight size={16} /> {backLabel}</button>
  );
}

/* ------------------- الوكالات ودور النشر ------------------- */
function AssignModal({ publishers, users, onSave, onClose }) {
  const subs = users.filter((u) => u.role !== "manager" && u.status !== "deleted");
  const activePubs = publishers.filter((p) => (p.status || "active") === "active");
  const [uid, setUid] = useState(subs[0]?.id || "");
  const cur = subs.find((u) => u.id === uid);
  const [pubs, setPubs] = useState(new Set());
  const [allBooks, setAllBooks] = useState(true);
  const [books, setBooks] = useState(new Set());
  useEffect(() => {
    if (!cur) { setPubs(new Set()); setAllBooks(true); setBooks(new Set()); return; }
    setPubs(new Set(cur.assignedPubs || []));
    const ab = cur.assignedBooks;
    setAllBooks(ab === "all" || ab == null);
    setBooks(new Set(Array.isArray(ab) ? ab : []));
  }, [uid]);

  const togglePub = (id) => setPubs((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const toggleBook = (id) => setBooks((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const save = () => { if (!cur) return; onSave(cur.id, { assignedPubs: [...pubs], assignedBooks: allBooks ? "all" : [...books] }); onClose(); };

  const selSt = { width: "100%", fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 10, padding: "9px 11px" };
  const listSt = { maxHeight: 168, overflowY: "auto", border: "1px solid var(--line)", borderRadius: 10, padding: 10, marginTop: 6, background: "var(--bg2)" };
  const rowSt = { display: "flex", alignItems: "center", gap: 8, fontFamily: arab, fontSize: 14, color: "var(--text)", padding: "4px 2px", cursor: "pointer" };

  return (
    <Overlay onClose={onClose}>
      <div style={{ ...S.modal, maxWidth: 540 }}>
        <h3 style={{ fontFamily: arab, fontWeight: 800, fontSize: 18, color: "var(--text)", margin: "0 0 14px" }}>تعيين الصلاحيات</h3>
        {subs.length === 0 ? (
          <div style={S.emptyHint}>لا يوجد مستخدمون فرعيّون بعد. أنشئهم أولًا من «المستخدمون وكلمات السرّ».</div>
        ) : (
          <>
            <label style={S.label}>الشخص</label>
            <TmSelect value={uid} onChange={setUid} options={subs.map((u) => [u.id, u.fullName + " - " + (u.role === "translator" ? "مترجم" : "فرعيّ")])} />

            <label style={{ ...S.label, marginTop: 14 }}>الجهات الظاهرة له</label>
            <div style={listSt}>
              {activePubs.length === 0 && <div style={S.emptyHint}>لا جهات بعد.</div>}
              {activePubs.map((p) => (
                <label key={p.id} style={rowSt}><input type="checkbox" checked={pubs.has(p.id)} onChange={() => togglePub(p.id)} /> {p.name}</label>
              ))}
            </div>

            <label style={{ ...rowSt, marginTop: 12, fontWeight: 700 }}>
              <input type="checkbox" checked={allBooks} onChange={(e) => setAllBooks(e.target.checked)} /> كل الكتب في الجهات المحدّدة
            </label>

            {!allBooks && (
              <div style={listSt}>
                {[...pubs].length === 0 && <div style={S.emptyHint}>اختر جهة أولًا لإظهار كتبها.</div>}
                {activePubs.filter((p) => pubs.has(p.id)).map((p) => (
                  <div key={p.id} style={{ marginBottom: 8 }}>
                    <div style={{ fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--accent)", margin: "4px 0" }}>{p.name}</div>
                    {(p.projects || []).flatMap((j) => (j.works || []).filter((w) => (w.status || "active") === "active").map((w) => (
                      <label key={w.id} style={{ ...rowSt, paddingRight: 14 }}>
                        <input type="checkbox" checked={books.has(w.id)} onChange={() => toggleBook(w.id)} /> {w.name}
                        <span style={{ color: "var(--faint)", fontSize: 14 }}>· {j.name}</span>
                      </label>
                    )))}
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: "flex", gap: 10, marginTop: 18 }}>
              <button style={S.saveBtn} className="save-btn" onClick={save}><Check size={16} /> حفظ الصلاحيات</button>
              <button className="ghost" style={{ fontFamily: arab, fontSize: 14, padding: "9px 16px", borderRadius: 10, border: "1px solid var(--line)", background: "var(--surface)", color: "var(--muted)", cursor: "pointer" }} onClick={onClose}>إلغاء</button>
            </div>
          </>
        )}
      </div>
    </Overlay>
  );
}


function Publishers({ title = "مشاريع ترجمة", share, titleColor, publishers, editMode, onToggleEdit, onSettings, onOpen, onOpenMenu, onRestore, onTrash, onDeleteForever, onExport, onAssign, onBack, onAdd }) {
  const { readOnly: ro, me , isManager } = useAuth();
  const _act = publishers.filter((p) => (p.status || "active") === "active");
  const active = ro ? _act.filter((p) => (me?.assignedPubs || []).includes(p.id)) : _act;
  const archived = publishers.filter((p) => p.status === "archived");
  const trashed = publishers.filter((p) => p.status === "trashed");
  const lp = useLongPress((p) => onOpen(p.id), onOpenMenu);
  return (
    <div style={S.page} className="fade-in">
      <div style={S.body}>
        <div className="pm-stripes" style={{ opacity: 0.5 }} />
        <div style={{ ...S.sectionHead, justifyContent: "center", position: "relative" }}>
          <h2 style={{ ...S.sectionTitle, color: titleColor || S.sectionTitle.color }}>{title}</h2>
          <div style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 10 }}>
            <NavBtns onBack={onBack} backLabel="الواجهة" />
          </div>
        </div>
        {ro && active.length === 0 && <div style={S.emptyHint}>لا توجد جهات مخصّصة لك بعد - تواصل مع المدير لتعيين صلاحياتك.</div>}
        <div style={S.grid}>
          {active.map((p, i) => (
            <div key={p.id} className="pm-card"
              style={{ ...S.card, animationDelay: `${i * 70}ms` }}
              onMouseDown={() => lp.start(p)} onMouseUp={lp.cancel} onMouseLeave={lp.cancel}
              onTouchStart={() => lp.start(p)} onTouchEnd={lp.cancel}
              onClick={() => lp.click(p)} onDoubleClick={() => onOpenMenu(p)}
              onContextMenu={(e) => { e.preventDefault(); onOpenMenu(p); }}
              >
              <CardBorder dot={p.dotColor} />
              {editMode && <button className="btn-del" style={S.del} onClick={(e) => { e.stopPropagation(); onTrash(p); }}></button>}
              <span className="pm-cardicon" style={{ ...S.cardIcon, color: _activeTheme.accent, boxShadow: `0 0 22px ${_activeTheme.accent}33` }}><ProjIcon img={p.iconImg} name={p.icon} size={40} color={_activeTheme.accent} /></span>
              <div style={S.cardName}>{p.name}</div>
              {p.note && <div style={S.cardNote}>{p.note}</div>}
            </div>
          ))}
          <div className="pm-card add-card" style={{ ...S.addCard, display: isManager ? undefined : "none" }} onClick={onAdd}>
            <span style={S.addCircle}><Plus size={22} color={"var(--accent)"} /></span>
            <div style={S.addText}>إضافة جهة جديدة</div>
          </div>
        </div>

        {archived.length > 0 && (
          <BinSection icon={<Archive size={18} color={"var(--muted)"} />} count={archived.length}
            items={archived} col={"var(--accent)"}
            actions={(p) => (
              <>
                <MiniBtn onClick={() => onRestore(p)} label="استعادة"><RotateCcw size={14} /></MiniBtn>
                <MiniBtn onClick={() => onTrash(p)} label="نقل للسلة"><Trash2 size={14} /></MiniBtn>
              </>
            )}
          />
        )}

        {trashed.length > 0 && (
          <BinSection icon={<Trash2 size={18} color={"var(--muted)"} />} count={trashed.length}
            note="لا يُحذف شيء تلقائيًا - الحذف النهائي يدويّ فقط."
            items={trashed} col={"var(--accent)"} danger
            actions={(p) => (
              <>
                <MiniBtn onClick={() => onRestore(p)} label="استعادة"><RotateCcw size={14} /></MiniBtn>
                <MiniBtn onClick={() => onDeleteForever(p)} label="حذف نهائي" danger><X size={14} /></MiniBtn>
              </>
            )}
          />
        )}
      </div>
    </div>
  );
}

/* ضغطة مطوّلة / نقر يمين لإظهار الخيارات، ونقرة عادية للفتح */
function useLongPress(onOpen, onMenu, ms = 450) {
  const timer = useRef(null);
  const longRef = useRef(false);
  const start = (item) => { longRef.current = false; clearTimeout(timer.current); timer.current = setTimeout(() => { longRef.current = true; onMenu(item); }, ms); };
  const cancel = () => { clearTimeout(timer.current); };
  const click = (item) => { if (longRef.current) { longRef.current = false; return; } onOpen(item); };
  return { start, cancel, click };
}

/* ------------------- مشاريع الوكالة ------------------- */
function Projects({ publisher, share, editMode, onToggleEdit, onSettings, onToggleReceived, onOpen, onOpenMenu, onStats, onRestore, onTrash, onDeleteForever, onBack, onAdd }) {
  const { readOnly: ro , isManager } = useAuth();
  const col = publisher.color;
  const lp = useLongPress(onOpen, onOpenMenu);
  const active = publisher.projects.filter((j) => (j.status || "active") === "active");
  const archived = publisher.projects.filter((j) => j.status === "archived");
  const trashed = publisher.projects.filter((j) => j.status === "trashed");
  const deliveryNotes = [];
  active.forEach((j) => (j.works || []).forEach((w) => {
    if ((w.status || "active") === "active" && w.transDeliveryDate) deliveryNotes.push({ projId: j.id, w });
  }));
  deliveryNotes.sort((a, b) => (a.w.transDeliveryDate < b.w.transDeliveryDate ? -1 : 1));
  return (
    <div style={S.page} className="fade-in">
      <div style={S.body}>
        <div className="pm-stripes" style={{ opacity: 0.5 }} />
        <div style={{ ...S.sectionHead, justifyContent: "center", position: "relative" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <h2 style={S.sectionTitle}>{publisher.name}</h2>
          </div>
          <div style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 10 }}>
            <NavBtns onBack={onBack} backLabel="الوكالات" onSettings={onSettings} />
          </div>
        </div>



        {deliveryNotes.length > 0 && (
          <div style={S.notesWrap} className="fade-in">
            <div style={S.notesHead}>
              <ClipboardCheck size={18} color={"var(--accent)"} />
              <span style={S.notesTitle}>ملاحظات: مواعيد استلام الترجمات من المترجمين</span>
              <span style={S.binCount}>{toAr(deliveryNotes.length)}</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {deliveryNotes.map(({ projId, w }) => (
                <label key={w.id} style={{ ...S.noteRow, ...(w.transReceived ? S.noteRowDone : {}) }}>
                  <input type="checkbox" style={S.checkbox} checked={!!w.transReceived} onChange={(e) => onToggleReceived(projId, w.id, e.target.checked)} />
                  <span style={{ flex: 1, textDecoration: w.transReceived ? "line-through" : "none", opacity: w.transReceived ? 0.62 : 1 }}>
                    موعد استلام ترجمة «{w.name}» من المترجم {w.transName || "-"}: <b style={{ color: "var(--accent)" }}>{fmtDate(w.transDeliveryDate)}</b>
                  </span>
                  {w.transReceived && <span style={S.noteDone}>مستلَمة ✓</span>}
                </label>
              ))}
            </div>
          </div>
        )}

        <div style={S.grid}>
          {active.map((j, i) => (
            <div key={j.id} className="pm-card"
              style={{ ...S.card, animationDelay: `${i * 70}ms` }}
              onMouseDown={() => lp.start(j)} onMouseUp={lp.cancel} onMouseLeave={lp.cancel}
              onTouchStart={() => lp.start(j)} onTouchEnd={lp.cancel}
              onClick={() => lp.click(j)} onDoubleClick={() => onOpenMenu(j)}
              onContextMenu={(e) => { e.preventDefault(); onOpenMenu(j); }}
              >
              <CardBorder dot={j.dotColor} />
              {editMode && <button className="btn-del" style={S.del} onClick={(e) => { e.stopPropagation(); onTrash(j); }}></button>}
              {j.category && <div style={S.cardMeta}><span style={{ ...S.tag, color: "var(--accent)", borderColor: "var(--accent)" }}>{j.category}</span></div>}
              <span className="pm-cardicon" style={{ ...S.cardIcon, color: _activeTheme.accent, boxShadow: `0 0 22px ${_activeTheme.accent}33` }}><ProjIcon img={j.iconImg} name={j.icon} size={40} color={_activeTheme.accent} /></span>
              <div style={S.cardName}>{j.name}</div>
              <div style={S.dateRow}><Calendar size={14} color={"var(--muted)"} /><span>{fmtDate(j.date)}</span></div>
            </div>
          ))}
          <div className="pm-card add-card" style={{ ...S.addCard, display: isManager ? undefined : "none" }} onClick={onAdd}>
            <span style={{ ...S.addCircle, borderColor: "var(--accent)" }}><Plus size={22} color={"var(--accent)"} /></span>
            <div style={{ ...S.addText, color: "var(--accent)" }}>إضافة مشروع جديد</div>
          </div>
        </div>

        {archived.length > 0 && (
          <BinSection icon={<Archive size={18} color={"var(--muted)"} />} count={archived.length}
            items={archived} col={col}
            actions={(j) => (
              <>
                <MiniBtn onClick={() => onRestore(j)} label="استعادة"><RotateCcw size={14} /></MiniBtn>
                <MiniBtn onClick={() => onTrash(j)} label="نقل للسلة"><Trash2 size={14} /></MiniBtn>
              </>
            )}
          />
        )}

        {trashed.length > 0 && (
          <BinSection icon={<Trash2 size={18} color={"var(--muted)"} />} count={trashed.length}
            note="لا يُحذف شيء تلقائيًا - الحذف النهائي يدويّ فقط."
            items={trashed} col={col} danger
            actions={(j) => (
              <>
                <MiniBtn onClick={() => onRestore(j)} label="استعادة"><RotateCcw size={14} /></MiniBtn>
                <MiniBtn onClick={() => onDeleteForever(j)} label="حذف نهائي" danger><X size={14} /></MiniBtn>
              </>
            )}
          />
        )}
      </div>
    </div>
  );
}

/* قسم الأرشيف / سلة المهملات */
function BinSection({ title, icon, count, note, items, col, actions, danger }) {
  return (
    <div style={S.binWrap} className="fade-in">
      <div style={S.binHead}>
        {icon}
        <span style={S.binTitle}>{title}</span>
        <span style={{ ...S.binCount, ...(danger ? { color: "#ff6b6b", borderColor: "rgba(255,107,107,0.4)" } : {}) }}>{toAr(count)}</span>
        {note && <span style={{ ...S.binNote, marginRight: "auto", fontSize: 12, opacity: 0.7 }}>{note}</span>}
      </div>
      <div style={S.binGrid}>
        {items.map((j) => (
          <div key={j.id} style={{ ...S.binItem }}>
            <span style={{ ...S.binItemIcon, color: danger ? "#ff8585" : col }}><ProjIcon img={j.iconImg} name={j.icon} size={18} color={danger ? "#ff8585" : col} /></span>
            <div style={{ flex: 1, minWidth: 150, textAlign: "right" }}>
              <div dir="auto" title={j.name || ""} style={{ ...S.binItemName, unicodeBidi: "plaintext", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{j.name || "بلا اسم"}</div>
              {j.date ? <div style={S.binItemDate}>{fmtDate(j.date)}</div> : null}
            </div>
            <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>{actions(j)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
function MiniBtn({ children, label, onClick, danger }) {
  return (
    <button className="mini-btn" style={{ ...S.miniBtn, ...(danger ? S.miniBtnDanger : {}) }} onClick={onClick}>
      {children}<span>{label}</span>
    </button>
  );
}

function Footer() {
  return (
    <div style={S.footer}>
      <span style={S.footText}>TARJIMTECH · PROJECT MANAGER · 2026</span>
      <span style={S.footPink}>دلال نصرالله</span>
    </div>
  );
}

/* --------------------- نافذة إضافة دار نشر --------------------- */
function AddPubModal({ name, setName, note, setNote, tag, setTag, icon, setIcon, iconImg, setIconImg, color, setColor, editing, onClose, onSave }) {
  const pickImg = (e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = () => setIconImg(r.result); r.readAsDataURL(f); e.target.value = ""; };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}><h3 style={S.modalTitle}>{editing ? "تعديل الجهة" : "إضافة جهة جديدة"}</h3><CloseBtn onClose={onClose} /></div>
      <div style={{ ...S.card, ...S.preview }}>
        <CardBorder dot="rainbow" />
        <div style={S.cardMeta}>{tag && <span style={{ ...S.tag, color, borderColor: "var(--accent)" }}>{tag}</span>}</div>
        <span className="pm-cardicon" style={{ ...S.cardIcon, color, boxShadow: `0 0 22px ${color}33` }}><ProjIcon img={iconImg} name={icon} size={40} color={"var(--accent)"} /></span>
        <div style={S.cardName}>{name.trim() || "اسم الدار"}</div>
        <div style={S.cardNote}>{note.trim() || "دار نشر"}</div>
      </div>
      <label style={S.label}>الاسم</label>
      <input style={S.input} value={name} onChange={(e) => setName(e.target.value)} placeholder="مثال: دار المدى" />
      <label style={S.label}>وصف مختصر</label>
      <input style={S.input} value={note} onChange={(e) => setNote(e.target.value)} placeholder="مثال: دار نشر أدبية" />
      <label style={S.label}>التصنيف</label>
      <div style={S.tagRow}>
        {["وكالة", "دار نشر", "مؤسسة", "ناشر مستقل"].map((t) => (
          <button key={t} className="ghost" style={{ ...S.tagOpt, ...(tag === t ? { background: "#e8ff00", color: "#0b1020", borderColor: "var(--accent)" } : {}) }} onClick={() => setTag(t)}>{t}</button>
        ))}
      </div>
      <input style={{ ...S.input, marginTop: 8 }} value={tag} onChange={(e) => setTag(e.target.value)} placeholder="أو اكتب نوعًا مخصّصًا (يدوي)" />
      <label style={S.label}>الأيقونة</label>
      <div style={S.iconGrid}>
        {ICON_KEYS.map((k) => (
          <button key={k} className="icon-opt" style={{ ...S.iconOpt, ...(!iconImg && icon === k ? { borderColor: "var(--accent)", background: "var(--surfaceHi)" } : {}) }} onClick={() => { setIcon(k); setIconImg && setIconImg(null); }}>
            <Icon name={k} size={22} color={!iconImg && icon === k ? color : "var(--muted)"} />
          </button>
        ))}
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}>
        <label style={S.delUpload}><Upload size={14} /> رفع صورة بدل الأيقونة<input type="file" style={{ display: "none" }} onChange={pickImg} /></label>
        {iconImg && <button className="ghost" style={S.miniBtn} onClick={() => setIconImg(null)}>إزالة الصورة</button>}
      </div>
      <label style={S.label}>اللون</label>
      <div style={S.swatchRow}>
        {SWATCHES.map((c) => (
          <button key={c} className="swatch" style={{ ...S.swatch, background: c, outline: color === c ? `2px solid ${"var(--text)"}` : "none", outlineOffset: 2 }} onClick={() => setColor(c)}>
            {color === c && <Check size={14} color="currentColor" />}
          </button>
        ))}
      </div>
      <ModalFoot canSave={!!name.trim()} onClose={onClose} onSave={onSave} label={editing ? "حفظ التعديل" : "إضافة"} />
    </Overlay>
  );
}

/* --------------------- نافذة إضافة مشروع --------------------- */
function AddProjModal({ color, name, setName, date, setDate, icon, setIcon, iconImg, setIconImg, dot, setDot, cat, setCat, onClose, onSave, title = "إضافة مشروع جديد", label = "إضافة المشروع" }) {
  const pickImg = (e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = () => setIconImg(r.result); r.readAsDataURL(f); e.target.value = ""; };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}><h3 style={S.modalTitle}>{title}</h3><CloseBtn onClose={onClose} /></div>
      <div style={{ ...S.card, ...S.preview }}>
        <CardBorder dot={dot} />
        <div style={S.cardMeta}>{cat && <span style={{ ...S.tag, color, borderColor: "var(--accent)" }}>{cat}</span>}</div>
        <span className="pm-cardicon" style={{ ...S.cardIcon, color, boxShadow: `0 0 22px ${color}33` }}><ProjIcon img={iconImg} name={icon} size={40} color={"var(--accent)"} /></span>
        <div style={S.cardName}>{name.trim() || "اسم المشروع"}</div>
        <div style={S.dateRow}><Calendar size={14} color={"var(--muted)"} /><span>{fmtDate(date)}</span></div>
      </div>
      <label style={S.label}>اسم المشروع</label>
      <input style={S.input} value={name} onChange={(e) => setName(e.target.value)} placeholder="مثال: ترجم 6" />
      <label style={S.label}>الفئة (اتركها فارغة لإخفائها)</label>
      <input style={S.input} value={cat || ""} onChange={(e) => setCat(e.target.value)} placeholder="مثال: مشروع · سلسلة · مبادرة" />
      <label style={S.label}>التاريخ</label>
      <input type="date" style={S.input} value={date} onChange={(e) => setDate(e.target.value)} />
      <label style={S.label}>الأيقونة</label>
      <div style={S.iconGrid}>
        {PROJECT_ICONS.map((k) => (
          <button key={k} className="icon-opt" style={{ ...S.iconOpt, ...(!iconImg && icon === k ? { borderColor: "var(--accent)", background: "var(--surfaceHi)" } : {}) }} onClick={() => { setIcon(k); setIconImg && setIconImg(null); }}>
            <Icon name={k} size={22} color={!iconImg && icon === k ? color : "var(--muted)"} />
          </button>
        ))}
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}>
        <label style={S.delUpload}><Upload size={14} /> رفع صورة أيقونة<input type="file" style={{ display: "none" }} onChange={pickImg} /></label>
        {iconImg && <button className="ghost" style={S.miniBtn} onClick={() => setIconImg(null)}>إزالة الصورة</button>}
      </div>
      <label style={S.label}>لون نقاط إطار البطاقة</label>
      <div style={S.swatchRow}>
        {DOT_SWATCHES.map((c) => (
          <button key={c} className="swatch" style={{ ...S.swatch, background: c === "rainbow" ? RAINBOW_CSS : c, outline: dot === c ? `2px solid ${"var(--text)"}` : "none", outlineOffset: 2 }} onClick={() => setDot(c)}>
            {dot === c && <Check size={14} color="currentColor" />}
          </button>
        ))}
      </div>
      <ModalFoot canSave={!!name.trim()} onClose={onClose} onSave={onSave} label={label} />
    </Overlay>
  );
}


/* م8: هل للمستخدم مفتاح إضافة كتاب على هذا المشروع؟ (المدير دائمًا نعم) */
function canAddBookHere(projectId, publisherId) {
  try {
    const g = (typeof window !== "undefined" && window.__tpmsGrants) || [];
    return g.some((x) => x.can_add_book && (
      x.scope_type === "all" ||
      (x.scope_type === "project" && x.scope_id === projectId) ||
      (x.scope_type === "publisher" && x.scope_id === publisherId)));
  } catch { return false; }
}

/* --------------------- نافذة إضافة كتاب (نموذج كامل) --------------------- */
function Field({ label, value, onChange, placeholder, type = "text", ltr = false }) {
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <label style={S.label}>{label}</label>
      <input
        type={type} style={{ ...S.input, ...(ltr ? { direction: "ltr", textAlign: "left" } : {}) }}
        value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
      />
    </div>
  );
}
function Group({ title }) { return <div style={S.groupTitle}>{title}</div>; }

function AddBookModal({ projectName, color, bk, setB, onClose, onSave }) {
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}>
        <h3 style={S.modalTitle}>إضافة كتاب في «{projectName}»</h3>
        <CloseBtn onClose={onClose} />
      </div>

      {/* معاينة */}
      <div style={{ ...S.card, ...S.preview }}>
        <CardBorder dot={bk.dotColor} />
        <div style={S.cardMeta}>{bk.category && <span style={{ ...S.tag, color, borderColor: "var(--accent)" }}>{bk.category}</span>}</div>
        <span className="pm-cardicon" style={{ ...S.cardIcon, color, boxShadow: `0 0 22px ${color}33` }}><ProjIcon img={bk.iconImg} name={bk.icon} size={40} color={"var(--accent)"} /></span>
        <div style={S.cardName}>{bk.name.trim() || "اسم الكتاب"}</div>
        <div style={S.langLine}>إلى {bk.lang}</div>
        <div style={S.dateRow}><Calendar size={14} color={"var(--muted)"} /><span>{fmtDate(bk.date)}</span></div>
      </div>

      <Group />
      <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13.5, fontWeight: 800, color: "var(--accent)", margin: "2px 0 10px", display: "flex", alignItems: "center", gap: 8 }}>بيانات الكتاب</div>
      <Field label="اسم الكتاب بالعربية" value={bk.name} onChange={(v) => setB("name", v)} placeholder="مثال: ثلوج الصحراء" />
      <Field label="اسم الكتاب باللغة المترجَم إليها" ltr value={bk.nameFr} onChange={(v) => setB("nameFr", v)} placeholder="Title in target language" />
      <Field label="الفئة (تظهر على البطاقة)" value={bk.category || ""} onChange={(v) => setB("category", v)} placeholder="مثال: كتاب · قصة قصيرة · رواية · شعر" />
      <label style={S.label}>ملاحظات</label>
      <textarea style={{ ...S.input, minHeight: 88, resize: "vertical", lineHeight: 1.6, fontFamily: "inherit" }} value={bk.notes || ""} onChange={(e) => setB("notes", e.target.value)} placeholder="ملاحظات حرة عن الكتاب..." />
      <label style={S.label}>من الأدب السعودي إلى اللغة</label>
      <TmSelect value={bk.lang} onChange={(v) => setB("lang", v)} options={LANGS.map((l) => [l, l])} />
      <div style={S.row}>
        <Field label="التاريخ" type="date" value={bk.date} onChange={(v) => setB("date", v)} ltr />
      </div>
      <label style={S.label}>الأيقونة</label>
      <div style={S.iconGrid}>
        {PROJECT_ICONS.map((k) => (
          <button key={k} className="icon-opt" style={{ ...S.iconOpt, ...(!bk.iconImg && bk.icon === k ? { borderColor: "var(--accent)", background: "var(--surfaceHi)" } : {}) }} onClick={() => { setB("icon", k); setB("iconImg", null); }}>
            <Icon name={k} size={22} color={!bk.iconImg && bk.icon === k ? color : "var(--muted)"} />
          </button>
        ))}
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}>
        <label style={S.delUpload}><Upload size={14} /> رفع صورة أيقونة<input type="file" style={{ display: "none" }} onChange={(e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = () => setB("iconImg", r.result); r.readAsDataURL(f); e.target.value = ""; }} /></label>
        {bk.iconImg && <button className="ghost" style={S.miniBtn} onClick={() => setB("iconImg", null)}>إزالة الصورة</button>}
      </div>
      <label style={S.label}>لون نقاط إطار البطاقة</label>
      <div style={S.swatchRow}>
        {DOT_SWATCHES.map((c) => (
          <button key={c} className="swatch" style={{ ...S.swatch, background: c === "rainbow" ? RAINBOW_CSS : c, outline: (bk.dotColor || "rainbow") === c ? `2px solid ${"var(--text)"}` : "none", outlineOffset: 2 }} onClick={() => setB("dotColor", c)}>
            {(bk.dotColor || "rainbow") === c && <Check size={14} color="currentColor" />}
          </button>
        ))}
      </div>
      <div style={S.row}>
        <FileSlot label="غلاف الكتاب العربي" image accent={"var(--accent)"} file={bk.coverAr} onSet={(f) => setB("coverAr", f)} />
        <FileSlot label="غلاف الكتاب الأجنبي" image accent={"var(--accent)"} file={bk.coverFr} onSet={(f) => setB("coverFr", f)} />
      </div>

      <Group />
      <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13.5, fontWeight: 800, color: "var(--accent)", margin: "2px 0 10px", display: "flex", alignItems: "center", gap: 8 }}>بيانات خاصة</div>
      <div style={S.row}>
        <Field label="الرقم التشغيلي" value={bk.opNumber} onChange={(v) => setB("opNumber", v)} placeholder="الرقم التشغيلي" />
        <Field label="رقم المنحة" value={bk.grantNumber} onChange={(v) => setB("grantNumber", v)} placeholder="رقم المنحة" />
      </div>
      <div style={S.row}>
        <Field label="نوع المنحة" value={bk.grantType} onChange={(v) => setB("grantType", v)} placeholder="نوع المنحة" />
        <Field label="رقم الفسح الإعلامي" value={bk.mediaPermit} onChange={(v) => setB("mediaPermit", v)} placeholder="رقم الفسح الإعلامي" />
      </div>

      <Group />
      <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13.5, fontWeight: 800, color: "var(--accent)", margin: "2px 0 10px", display: "flex", alignItems: "center", gap: 8 }}>المؤلف</div>
      <Field label="اسم المؤلف" value={bk.authorName} onChange={(v) => setB("authorName", v)} placeholder="اسم المؤلف" />
      <div style={S.row}>
        <Field label="إيميل المؤلف" type="email" ltr value={bk.authorEmail} onChange={(v) => setB("authorEmail", v)} placeholder="author@email.com" />
        <Field label="رقم هاتف المؤلف" type="tel" ltr value={bk.authorPhone} onChange={(v) => setB("authorPhone", v)} placeholder="+966 5x xxx xxxx" />
      </div>
      <FileSlot label="عقد المؤلف" accent={"var(--accent)"} file={bk.contractAuthor} onSet={(f) => setB("contractAuthor", f)} />

      <Group />
      <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13.5, fontWeight: 800, color: "var(--accent)", margin: "2px 0 10px", display: "flex", alignItems: "center", gap: 8 }}>المترجم</div>
      <div style={S.row}>
        <Field label="اسم المترجم" value={bk.transName} onChange={(v) => setB("transName", v)} placeholder="اسم المترجم" />
        <Field label="الجنسية" value={bk.transNat} onChange={(v) => setB("transNat", v)} placeholder="مثال: كويتي" />
      </div>
      <Field label="إيميل المترجم" type="email" ltr value={bk.transEmail} onChange={(v) => setB("transEmail", v)} placeholder="translator@email.com" />
      <Field label="رقم هاتف المترجم" type="tel" ltr value={bk.transPhone} onChange={(v) => setB("transPhone", v)} placeholder="+965 xxxx xxxx" />
      <div style={S.row}>
        <Field label="أجر المترجم" ltr value={bk.fee2} onChange={(v) => setB("fee2", v)} placeholder="مثال: 1500" />
      </div>
      <Field label="تاريخ تسليم الترجمة من المترجم" type="date" ltr value={bk.transDeliveryDate} onChange={(v) => setB("transDeliveryDate", v)} />
      <label style={S.checkRow}><input type="checkbox" style={S.checkbox} checked={!!bk.transReceived} onChange={(e) => setB("transReceived", e.target.checked)} /><span>استلمتُ الترجمة من المترجم</span></label>
      <div style={S.row}>
        <FileSlot label="عقد الترجمة" accent={"var(--accent)"} file={bk.contractTrans1} onSet={(f) => setB("contractTrans1", f)} />
      </div>

      <Group />
      <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13.5, fontWeight: 800, color: "var(--accent)", margin: "2px 0 10px", display: "flex", alignItems: "center", gap: 8 }}>الردمك (ISBN)</div>
      <div style={S.row}>
        <Field label="الردمك العربي" ltr value={bk.isbnAr} onChange={(v) => setB("isbnAr", v)} placeholder="978-..." />
        <Field label="الردمك الأجنبي" ltr value={bk.isbnFr} onChange={(v) => setB("isbnFr", v)} placeholder="978-..." />
      </div>

      <Group />
      <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13.5, fontWeight: 800, color: "var(--accent)", margin: "2px 0 10px", display: "flex", alignItems: "center", gap: 8 }}>دور النشر</div>
      <Field label="اسم دار النشر العربية" value={bk.pubAr} onChange={(v) => setB("pubAr", v)} placeholder="دار النشر العربية" />
      <Field label="اسم دار النشر الأجنبية" value={bk.pubFrHouse} onChange={(v) => setB("pubFrHouse", v)} placeholder="Foreign Publishing House" />

      <Group />
      <div style={{ fontFamily: "'Cairo','Segoe UI',sans-serif", fontSize: 13.5, fontWeight: 800, color: "var(--accent)", margin: "2px 0 10px", display: "flex", alignItems: "center", gap: 8 }}>الناشر الأجنبي وعرض الطباعة</div>
      <Field label="اسم الناشر" value={bk.pubFrName} onChange={(v) => setB("pubFrName", v)} placeholder="اسم الناشر" />
      <div style={S.row}>
        <Field label="إيميل الناشر" type="email" ltr value={bk.pubFrEmail} onChange={(v) => setB("pubFrEmail", v)} placeholder="publisher@email.com" />
        <Field label="قيمة عرض الطباعة" ltr value={bk.printOffer} onChange={(v) => setB("printOffer", v)} placeholder="مثال: 4000" />
      </div>
      <FileSlot label="عقد الناشر" accent={"var(--accent)"} file={bk.contractPublisher} onSet={(f) => setB("contractPublisher", f)} />
      <FileSlot label="ملف عرض الطباعة" accent={"var(--accent)"} file={bk.printOfferFile} onSet={(f) => setB("printOfferFile", f)} />

      <ModalFoot canSave={!!bk.name.trim()} onClose={onClose} onSave={onSave} label="إضافة الكتاب" />
    </Overlay>
  );
}

/* --------------------- نافذة تصدير Excel --------------------- */
function ExportModal({ rows, title, defaultName, color, onClose }) {
  const [sel, setSel] = useState(DEFAULT_COLS);
  const [name, setName] = useState(defaultName);
  const toggle = (k) => setSel((s) => s.includes(k) ? s.filter((x) => x !== k) : [...s, k]);
  const allKeys = EXPORT_COLUMNS.map((c) => c.key);
  const can = sel.length > 0 && rows.length > 0;
  const run = () => { if (!can) return; exportToExcel(rows, sel, name || "كتب"); onClose(); };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}>
        <h3 style={S.modalTitle}>تصدير إلى Excel</h3>
        <CloseBtn onClose={onClose} />
      </div>
      <div style={S.exportNote}>
        النطاق: <b style={{ color: "var(--text)" }}>{title}</b> - سيُصدَّر <b style={{ color }}>{toAr(rows.length)}</b> كتاب.
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button className="ghost" style={S.miniBtn} onClick={() => setSel(allKeys)}>تحديد الكل</button>
        <button className="ghost" style={S.miniBtn} onClick={() => setSel([])}>إلغاء التحديد</button>
      </div>

      <label style={S.label}>الأعمدة المطلوبة في الملف</label>
      {Array.from(new Set(EXPORT_COLUMNS.map((c) => c.group || "أخرى"))).map((g) => {
        const cols = EXPORT_COLUMNS.filter((c) => (c.group || "أخرى") === g);
        const allOn = cols.every((c) => sel.includes(c.key));
        return (
          <div key={g} style={{ marginBottom: 12 }}>
            <div style={S.colGroupHead}>
              <span>{g}</span>
              <button className="ghost" style={S.colGroupBtn} onClick={() => setSel((s) => allOn ? s.filter((k) => !cols.some((c) => c.key === k)) : [...new Set([...s, ...cols.map((c) => c.key)])])}>
                {allOn ? "إزالة الكل" : "تحديد الكل"}
              </button>
            </div>
            <div style={S.colGrid}>
              {cols.map((c) => {
                const on = sel.includes(c.key);
                return (
                  <button key={c.key} className="seg-btn"
                    style={{ ...S.colChip, ...(on ? { background: "#e8ff00", borderColor: "var(--accent)", color: "#0b1020" } : {}) }}
                    onClick={() => toggle(c.key)}>
                    {on ? <Check size={14} /> : <Plus size={14} />} {c.label}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}

      <label style={S.label}>اسم الملف</label>
      <input style={{ ...S.input, direction: "ltr", textAlign: "left" }} value={name} onChange={(e) => setName(e.target.value)} placeholder="كتب_ترجمتك" />

      <div style={S.modalFoot}>
        <button style={S.cancelBtn} className="ghost" onClick={onClose}>إلغاء</button>
        <button style={{ ...S.saveBtn, opacity: can ? 1 : 0.45, cursor: can ? "pointer" : "not-allowed" }} className="save-btn" disabled={!can} onClick={run}>
          <FileSpreadsheet size={16} /> تصدير ({toAr(sel.length)} عمود)
        </button>
      </div>
    </Overlay>
  );
}

/* --------------------- نافذة تفاصيل الكتاب --------------------- */
function DRow({ label, value, ltr }) {
  return (
    <div style={S.dRow}>
      <span style={S.dLabel}>{label}</span>
      <span style={{ ...S.dVal, ...(ltr ? { direction: "ltr", textAlign: "left" } : {}) }}>{value && String(value).trim() ? value : "-"}</span>
    </div>
  );
}

function BookDetailModal({ book, color, onUpdate, onClose }) {
  const [nfName, setNfName] = useState("");
  const { readOnly: ro } = useAuth();
  const [edit, setEdit] = useState(false);
  const [confirmSlot, setConfirmSlot] = useState(null);
  const setF = (k, v) => onUpdate((b) => ({ ...b, [k]: v }));


  const slotMeta = (key) => FILE_SLOTS.find((s) => s.key === key);
  const doDelete = (key) => {
    onUpdate((b) => ({
      ...b,
      filesTrash: [...(b.filesTrash || []), { id: Date.now(), slot: key, label: slotMeta(key).label, file: b[key] }],
      [key]: null,
    }));
    setConfirmSlot(null);
  };
  const restore = (item) => onUpdate((b) => ({ ...b, [item.slot]: b[item.slot] || item.file, filesTrash: (b.filesTrash || []).filter((x) => x.id !== item.id) }));
  const purge = (item) => onUpdate((b) => ({ ...b, filesTrash: (b.filesTrash || []).filter((x) => x.id !== item.id) }));

  const trash = book.filesTrash || [];

  return (
    <div style={S.overlay} className="fade-in" onClick={onClose}>
      <div style={{ ...S.modal, maxWidth: 560 }} className="modal-pop" onClick={(e) => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={{ ...S.modalTitle, flex: 1, textAlign: "center" }}>{book.name}</h3>
          <div style={{ display: "flex", gap: 8 }}>
            {!ro && (
            <button style={{ ...S.editBtn, ...(edit ? { background: "#e8ff00", color: "#0b1020", borderColor: "var(--accent)" } : {}) }} className="ghost" onClick={() => setEdit((v) => !v)}>
              <Pencil size={14} /> {edit ? "إنهاء التعديل" : "تعديل"}
            </button>)}
            <CloseBtn onClose={onClose} />
          </div>
        </div>

        {!ro && (
          <div style={{ display: "flex", gap: 8, alignItems: "center", padding: "2px 2px 8px" }}>
            <span style={{ fontSize: 14, color: "#64748b" }}>الرؤية للمستخدمين الفرعيين:</span>
            <button className="ghost" style={{ padding: "4px 12px", borderRadius: 8, fontWeight: 800, border: "1px solid", borderColor: (book.visibility ?? "shared") === "private" ? "#9a1b3a" : "var(--accent)", color: (book.visibility ?? "shared") === "private" ? "#9a1b3a" : "var(--accent)" }}
              onClick={() => onUpdate((b) => ({ ...b, visibility: (b.visibility ?? "shared") === "private" ? "shared" : "private" }))}>
              {(book.visibility ?? "shared") === "private" ? "خاصّ (المدير فقط)" : "مشترك للجميع"}
            </button>
          </div>
        )}

        {/* رأس مرئي: الغلافان */}
        <div style={S.coversRow}>
          {["coverAr", "coverFr"].map((k) => (
            <div key={k} style={S.coverBox}>
              <span style={S.coverCap}>{slotMeta(k).label}</span>
              {book[k] && (book[k].type || "").startsWith("image")
                ? <BookImg file={book[k]} alt="" style={S.coverImg} onClick={() => downloadFile(book[k])} />
                : <div style={S.coverEmpty}><ImageIcon size={22} color={"var(--faint)"} /></div>}
            </div>
          ))}
        </div>

        <Group />
        {edit ? (
          <>
            <Field label="اسم الكتاب بالعربية" value={book.name} onChange={(v) => setF("name", v)} />
            <Field label="اسم الكتاب باللغة المترجَم إليها" ltr value={book.nameFr} onChange={(v) => setF("nameFr", v)} />
            <Field label="الفئة (تظهر على البطاقة)" value={book.category || ""} onChange={(v) => setF("category", v)} placeholder="مثال: كتاب · قصة قصيرة · رواية" />
            <label style={S.label}>اللغة الهدف</label>
            <TmSelect value={book.lang} onChange={(v) => setF("lang", v)} options={LANGS.map((l) => [l, l])} />
            <Field label="التاريخ" type="date" ltr value={book.date} onChange={(v) => setF("date", v)} />
            <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8 }}>
              <label style={S.delUpload}><Upload size={14} /> رفع صورة أيقونة<input type="file" style={{ display: "none" }} onChange={(e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = () => setF("iconImg", r.result); r.readAsDataURL(f); e.target.value = ""; }} /></label>
              {book.iconImg && <button className="ghost" style={S.miniBtn} onClick={() => setF("iconImg", null)}>إزالة الصورة</button>}
            </div>
            <label style={S.label}>لون نقاط إطار البطاقة</label>
            <div style={S.swatchRow}>
              {DOT_SWATCHES.map((c) => (
                <button key={c} className="swatch" style={{ ...S.swatch, background: c === "rainbow" ? RAINBOW_CSS : c, outline: (book.dotColor || "rainbow") === c ? `2px solid ${"var(--text)"}` : "none", outlineOffset: 2 }} onClick={() => setF("dotColor", c)}>
                  {(book.dotColor || "rainbow") === c && <Check size={14} color="currentColor" />}
                </button>
              ))}
            </div>
          </>
        ) : (
          <>
            <DRow label="اسم الكتاب بالعربية" value={book.name} />
            <DRow label="اسم الكتاب المترجَم" value={book.nameFr} ltr />
            {book.category && <DRow label="الفئة" value={book.category} />}
            <DRow label="من الأدب السعودي إلى اللغة" value={book.lang} />
            <DRow label="التاريخ" value={fmtDate(book.date)} />
          </>
        )}

        {edit ? (
          <>
            <label style={S.label}>ملاحظات</label>
            <textarea style={{ ...S.input, minHeight: 88, resize: "vertical", lineHeight: 1.6, fontFamily: "inherit" }} value={book.notes || ""} onChange={(e) => setF("notes", e.target.value)} placeholder="ملاحظات حرة عن الكتاب..." />
          </>
        ) : (book.notes && String(book.notes).trim() ? (
          <div style={S.dRow}><span style={S.dLabel}>ملاحظات</span><span style={{ ...S.dVal, whiteSpace: "pre-wrap" }}>{book.notes}</span></div>
        ) : null)}

        <Group />
        {edit ? (
          <>
            <div style={S.row}>
              <Field label="الرقم التشغيلي" value={book.opNumber} onChange={(v) => setF("opNumber", v)} />
              <Field label="رقم المنحة" value={book.grantNumber} onChange={(v) => setF("grantNumber", v)} />
            </div>
            <div style={S.row}>
              <Field label="نوع المنحة" value={book.grantType} onChange={(v) => setF("grantType", v)} />
              <Field label="رقم الفسح الإعلامي" value={book.mediaPermit} onChange={(v) => setF("mediaPermit", v)} />
            </div>
            <Field label="اسم المؤلف" value={book.authorName} onChange={(v) => setF("authorName", v)} />
            <div style={S.row}>
              <Field label="إيميل المؤلف" ltr value={book.authorEmail} onChange={(v) => setF("authorEmail", v)} />
              <Field label="هاتف المؤلف" ltr value={book.authorPhone} onChange={(v) => setF("authorPhone", v)} />
            </div>
          </>
        ) : (
          <>
            <DRow label="الرقم التشغيلي" value={book.opNumber} />
            <DRow label="رقم المنحة" value={book.grantNumber} />
            <DRow label="نوع المنحة" value={book.grantType} />
            <DRow label="رقم الفسح الإعلامي" value={book.mediaPermit} />
            <DRow label="اسم المؤلف" value={book.authorName} />
            <DRow label="الإيميل" value={book.authorEmail} ltr />
            <DRow label="الهاتف" value={book.authorPhone} ltr />
          </>
        )}
        <FileLine slot="contractAuthor" book={book} color={"var(--accent)"} edit={edit} setF={setF} onAskDelete={setConfirmSlot} confirmSlot={confirmSlot} onDelete={doDelete} />

        <Group />
        {edit ? (
          <>
            <div style={S.row}>
              <Field label="اسم المترجم" value={book.transName} onChange={(v) => setF("transName", v)} />
              <Field label="الجنسية" value={book.transNat} onChange={(v) => setF("transNat", v)} />
            </div>
            <Field label="إيميل المترجم" ltr value={book.transEmail} onChange={(v) => setF("transEmail", v)} />
            <Field label="هاتف المترجم" ltr value={book.transPhone} onChange={(v) => setF("transPhone", v)} />
            <div style={S.row}>
              <Field label="أجر المترجم" ltr value={book.fee2} onChange={(v) => setF("fee2", v)} />
            </div>
            <Field label="تاريخ تسليم الترجمة من المترجم" type="date" ltr value={book.transDeliveryDate || ""} onChange={(v) => setF("transDeliveryDate", v)} />
            <label style={S.checkRow}><input type="checkbox" style={S.checkbox} checked={!!book.transReceived} onChange={(e) => setF("transReceived", e.target.checked)} /><span>استلمتُ الترجمة من المترجم</span></label>
          </>
        ) : (
          <>
            <DRow label="اسم المترجم" value={book.transName} />
            <DRow label="الجنسية" value={book.transNat} />
            <DRow label="الإيميل" value={book.transEmail} ltr />
            <DRow label="الهاتف" value={book.transPhone} ltr />
            <DRow label="أجر المترجم" value={book.fee2} ltr />
            <DRow label="تاريخ تسليم الترجمة" value={fmtDate(book.transDeliveryDate)} />
            <DRow label="استلام الترجمة" value={book.transReceived ? "مستلَمة ✓" : "بانتظار الاستلام"} />
          </>
        )}
        <FileLine slot="contractTrans1" book={book} color={"var(--accent)"} edit={edit} setF={setF} onAskDelete={setConfirmSlot} confirmSlot={confirmSlot} onDelete={doDelete} />

        <Group />
        {edit ? (
          <div style={S.row}>
            <Field label="الردمك العربي" ltr value={book.isbnAr} onChange={(v) => setF("isbnAr", v)} />
            <Field label="الردمك الأجنبي" ltr value={book.isbnFr} onChange={(v) => setF("isbnFr", v)} />
          </div>
        ) : (
          <>
            <DRow label="الردمك العربي" value={book.isbnAr} ltr />
            <DRow label="الردمك الأجنبي" value={book.isbnFr} ltr />
          </>
        )}

        <Group />
        {edit ? (
          <>
            <Field label="دار النشر العربية" value={book.pubAr} onChange={(v) => setF("pubAr", v)} />
            <Field label="دار النشر الأجنبية" value={book.pubFrHouse} onChange={(v) => setF("pubFrHouse", v)} />
            <Field label="اسم الناشر" value={book.pubFrName} onChange={(v) => setF("pubFrName", v)} />
            <div style={S.row}>
              <Field label="إيميل الناشر" ltr value={book.pubFrEmail} onChange={(v) => setF("pubFrEmail", v)} />
              <Field label="قيمة عرض الطباعة" ltr value={book.printOffer} onChange={(v) => setF("printOffer", v)} />
            </div>
          </>
        ) : (
          <>
            <DRow label="دار النشر العربية" value={book.pubAr} />
            <DRow label="دار النشر الأجنبية" value={book.pubFrHouse} />
            <DRow label="اسم الناشر" value={book.pubFrName} />
            <DRow label="إيميل الناشر" value={book.pubFrEmail} ltr />
            <DRow label="قيمة عرض الطباعة" value={book.printOffer} ltr />
          </>
        )}
        <FileLine slot="contractPublisher" book={book} color={"var(--accent)"} edit={edit} setF={setF} onAskDelete={setConfirmSlot} confirmSlot={confirmSlot} onDelete={doDelete} />
        <FileLine slot="printOfferFile" book={book} color={"var(--accent)"} edit={edit} setF={setF} onAskDelete={setConfirmSlot} confirmSlot={confirmSlot} onDelete={doDelete} />

        {edit && (
          <>
            <Group />
            <div style={S.row}>
              <FileSlot label="غلاف الكتاب العربي" image accent={"var(--accent)"} file={book.coverAr} onSet={(f) => setF("coverAr", f)} />
              <FileSlot label="غلاف الكتاب الأجنبي" image accent={"var(--accent)"} file={book.coverFr} onSet={(f) => setF("coverFr", f)} />
            </div>
          </>
        )}

        {trash.length > 0 && (
          <>
            <Group />
            {trash.map((item) => (
              <div key={item.id} style={S.trashRow}>
                <span style={{ color: "#e23d3d", display: "flex" }}><Paperclip size={16} /></span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={S.dLabel}>{item.label}</div>
                  <div style={{ ...S.dVal, fontSize: 14 }}>{item.file ? item.file.name : "-"}</div>
                </div>
                <button className="mini-btn" style={SF.fbtn} onClick={() => downloadFile(item.file)}><Download size={14} /></button>
                <button className="mini-btn" style={S.miniBtn} onClick={() => restore(item)}><RotateCcw size={14} /> استعادة</button>
                <button className="mini-btn" style={{ ...S.miniBtn, ...S.miniBtnDanger }} onClick={() => purge(item)}><X size={14} /> نهائي</button>
              </div>
            ))}
          </>
        )}

        <Group />
        <div style={S.dLabel}>ملفات إضافية</div>
        {(book.customFiles || []).map((cf) => (
          <div key={cf.id} style={SF.slot}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const f = e.dataTransfer.files && e.dataTransfer.files[0]; if (!f) return;
              const r = new FileReader();
              r.onload = async () => {
                try {
                  const up = await uploadBookFile({ name: f.name, type: f.type, data: r.result });
                  setF("customFiles", (book.customFiles || []).map((x) => x.id === cf.id ? { ...x, file: up } : x));
                } catch (err) { alert("تعذر رفع الملف: " + (err && err.message ? err.message : err)); }
              };
              r.readAsDataURL(f);
            }}>
            <span style={SF.slotLabel}>{cf.label}</span>
            {cf.file ? (
              <FilePeek file={cf.file}><div style={SF.chip}>
                <span style={{ ...SF.fileIco, color: "var(--accent)" }}><Paperclip size={16} /></span>
                <span style={SF.fileName}>{cf.file.name}</span>
                <button className="ghost" style={SF.fbtn} onClick={() => dlAny(cf.file)}><Download size={14} /></button>
                {edit && <button className="ghost" style={{ ...SF.fbtn, color: "#e23d3d" }} onClick={() => setF("customFiles", (book.customFiles || []).filter((x) => x.id !== cf.id))}><Trash2 size={14} /></button>}
             </div></FilePeek>
            ) : (edit
              ? <FileSlot label="" accent={"var(--accent)"} file={null} onSet={(f) => setF("customFiles", (book.customFiles || []).map((x) => x.id === cf.id ? { ...x, file: f } : x))} />
              : <span style={{ color: "var(--faint)", fontSize: 13 }}>بلا ملف</span>)}
          </div>
        ))}
        {edit && (
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 6 }}>
            <input value={nfName} onChange={(e) => setNfName(e.target.value)} placeholder="اسم الخانة الجديدة"
              style={{ flex: 1, padding: "9px 12px", borderRadius: 10, border: "1.5px solid var(--line)", background: "var(--panel)", color: "var(--ink)", fontFamily: "inherit", fontSize: 14 }}
              onKeyDown={(e) => { if (e.key === "Enter" && nfName.trim()) { setF("customFiles", [...(book.customFiles || []), { id: Date.now(), label: nfName.trim(), file: null }]); setNfName(""); } }} />
            <button className="ghost" style={{ ...SF.upBtn, color: "var(--accent)", borderColor: "var(--accent)" }}
              onClick={() => { if (!nfName.trim()) return; setF("customFiles", [...(book.customFiles || []), { id: Date.now(), label: nfName.trim(), file: null }]); setNfName(""); }}>
              <Upload size={16} /> إضافة خانة
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

/* سطر ملف داخل التفاصيل: معاينة/تنزيل/حذف(تأكيد) أو رفع */
function FileLine({ slot, book, color, edit, setF, onAskDelete, confirmSlot, onDelete }) {
  const meta = FILE_SLOTS.find((s) => s.key === slot);
  const file = book[slot];
  if (!file) {
    return <FileSlot label={meta.label} accent={"var(--accent)"} file={null} onSet={(f) => setF(slot, f)} />;
  }
  return (
    <div style={SF.slot}>
      <span style={SF.slotLabel}>{meta.label}</span>
      <div style={SF.chip}>
        <span style={{ ...SF.fileIco, color }}><Paperclip size={16} /></span>
        <span style={SF.fileName}>{file.name}</span>
        <button className="ghost" style={SF.fbtn} onClick={() => downloadFile(file)}><Download size={14} /></button>
        <button className="ghost" style={{ ...SF.fbtn, color: "#e23d3d" }} onClick={() => onAskDelete(slot)}><Trash2 size={14} /></button>
      </div>
      {confirmSlot === slot && (
        <div style={S.fileConfirm}>
          <span>حذف «{meta.label}»؟ سيُنقل إلى المهملات.</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="ghost" style={S.miniBtn} onClick={() => onAskDelete(null)}>إلغاء</button>
            <button className="mini-btn" style={{ ...S.miniBtn, ...S.miniBtnDanger }} onClick={() => onDelete(slot)}>تأكيد الحذف</button>
          </div>
        </div>
      )}
    </div>
  );
}

/* --------------------- لوحة إحصائيات الوكالة --------------------- */
function Kpi({ num, label, color }) {
  return (
    <div style={S.kpiCard}>
      <div style={{ ...S.kpiNum, color }}>{toAr(num)}</div>
      <div style={S.kpiLabel}>{label}</div>
    </div>
  );
}

function ColumnChart({ entries, color, height = 170 }) {
  if (!entries.length) return <div style={S.emptyHint}>لا بيانات.</div>;
  const max = Math.max(1, ...entries.map((e) => e[1]));
  return (
    <div style={S.colChartWrap}>
      {entries.map(([label, n]) => (
        <div key={label} style={S.colChartCol}>
          <div style={S.colChartVal}>{toAr(n)}</div>
          <div style={{ ...S.colChartBar, height: `${Math.max(6, (n / max) * height)}px`, background: `linear-gradient(180deg, #e8ff00, #e8ff00aa)` }} />
          <div style={S.colChartLabel}>{label}</div>
        </div>
      ))}
    </div>
  );
}

function BarList({ entries, color }) {
  if (!entries.length) return <div style={S.emptyHint}>لا بيانات.</div>;
  const max = Math.max(1, ...entries.map((e) => e[1]));
  return (
    <>
      {entries.map(([label, n]) => (
        <div key={label} style={S.barRow}>
          <span style={S.barLabel}>{label}</span>
          <div style={S.barTrack}><div style={{ ...S.barFill, width: `${(n / max) * 100}%`, background: "#e8ff00" }} /></div>
          <span style={S.barVal}>{toAr(n)}</span>
        </div>
      ))}
    </>
  );
}

function Stats({ publishers, publisher, onBack }) {
  const col = publisher ? publisher.color : C.pink;
  const [showExp, setShowExp] = useState(false);
  const [scope, setScope] = useState("agency"); // agency | all
  const [proj, setProj] = useState("الكل");
  const [lang, setLang] = useState("الكل");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const setScopeReset = (k) => { setScope(k); setProj("الكل"); };

  const sourcePubs = scope === "all" ? publishers : [publisher];
  const allRows = [];
  const allProjects = [];
  sourcePubs.forEach((p) => (p.projects || []).forEach((j) => {
    allProjects.push({ id: j.id, name: j.name, agency: p.name, ref: j });
    (j.works || []).forEach((w) => allRows.push({ ...w, agency: p.name, project: j.name, _pid: j.id, _marketing: j.marketing || {} }));
  }));
  const projectOptions = allProjects;
  const scopedProjects = (proj === "الكل" ? allProjects : allProjects.filter((j) => String(j.id) === String(proj))).map((j) => j.ref);
  const langOptions = Array.from(new Set(allRows.filter((r) => proj === "الكل" || String(r._pid) === String(proj)).map((r) => r.lang).filter(Boolean)));
  const rows = allRows.filter((r) => {
    if (proj !== "الكل" && String(r._pid) !== String(proj)) return false;
    if (lang !== "الكل" && r.lang !== lang) return false;
    if (from && (!r.date || r.date < from)) return false;
    if (to && (!r.date || r.date > to)) return false;
    return true;
  });

  const langT = tally(rows, (r) => r.lang);
  const authorT = tally(rows, (r) => r.authorName);
  const transT = tally(rows, (r) => r.transName);
  const arT = tally(rows, (r) => r.pubAr);
  const frT = tally(rows, (r) => r.pubFrHouse);
  const authors = new Set(rows.map((r) => r.authorName).filter(Boolean));
  const translators = new Set(rows.map((r) => r.transName).filter(Boolean));
  const langMap = {};
  rows.forEach((r) => { const l = (r.lang || "").trim() || "غير محدد"; (langMap[l] = langMap[l] || []).push(r); });
  const langKeys = langT.map((e) => e[0]);

  const missCover = rows.filter((r) => !r.coverFr).length;
  const missContract = rows.filter((r) => !(r.contractAuthor || r.contractTrans1 || r.contractPublisher)).length;
  const missIsbn = rows.filter((r) => bookMissing(r).includes("ردمك")).length;
  const incomplete = rows.map((r) => ({ r, m: bookMissing(r) })).filter((x) => x.m.length);

  const digitalN = rows.filter((r) => hasAny(mkCell(r, "digital"))).length;
  const storesN = rows.filter((r) => hasAny(mkCell(r, "stores"))).length;
  const awardsN = rows.filter((r) => hasAny(mkCell(r, "awards"))).length;
  const fairsN = scopedProjects.reduce((s, j) => s + ((j.marketing && j.marketing.fairs) ? j.marketing.fairs.length : 0), 0);

  const monthT = Object.entries(rows.reduce((m, r) => { const k = monthKey(r.date); m[k] = (m[k] || 0) + 1; return m; }, {})).sort((a, b) => a[0].localeCompare(b[0]));

  const selProj = proj === "الكل" ? null : allProjects.find((j) => String(j.id) === String(proj));
  const title = selProj ? selProj.name : (scope === "all" ? "كل الوكالات" : (publisher ? publisher.name : ""));
  const crumb = selProj ? `مشروع: ${selProj.name}${scope === "all" ? ` · ${selProj.agency}` : ""}` : (scope === "all" ? "على مستوى النظام" : "تجميع عبر كل المشاريع");
  const resetFilters = () => { setProj("الكل"); setLang("الكل"); setFrom(""); setTo(""); };

  return (
    <div style={S.page} className="fade-in">
      <div style={S.topbar}>
        <button style={S.backBtn} className="ghost" onClick={onBack}>المشاريع</button>
        <button className="ghost" style={S.exportBtn} onClick={() => setShowExp(true)}><FileSpreadsheet size={16} /> تصدير Excel</button>
      </div>
      <div style={S.body}>
        <div style={S.sectionHead}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ ...S.crumbIcon, color: "var(--accent)" }}><BarChart3 size={22} color={"var(--accent)"} /></span>
            <div>
              <h2 style={S.sectionTitle}>إحصائيات - {title}</h2>
            </div>
          </div>
        </div>

        {/* أدوات النطاق والفلترة */}
        <div style={S.statControls}>
          <div style={S.scopeWrap}>
            {[["agency", "هذه الوكالة"], ["all", "كل الوكالات"]].map(([k, lbl]) => (
              <button key={k} className="seg-btn" style={{ ...S.segBtn, ...(scope === k ? { ...S.segBtnOn, background: "var(--accent)", color: onAccent(_activeTheme.accent), borderColor: "var(--accent)" } : {}) }} onClick={() => setScopeReset(k)}>{lbl}</button>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={S.fLabel}>المشروع</span>
            <TmSelect value={proj} onChange={setProj} options={[["الكل", "كل المشاريع"], ...projectOptions.map((j) => [String(j.id), scope === "all" ? (j.agency + " › " + j.name) : j.name])]} />
            <span style={S.fLabel}>اللغة</span>
            <TmSelect value={lang} onChange={setLang} options={[["الكل", "الكل"], ...langOptions.map((l) => [l, l])]} />
            <span style={S.fLabel}>من</span>
            <input type="date" style={{ ...S.fInput, colorScheme: "light" }} value={from} onChange={(e) => setFrom(e.target.value)} />
            <span style={S.fLabel}>إلى</span>
            <input type="date" style={{ ...S.fInput, colorScheme: "light" }} value={to} onChange={(e) => setTo(e.target.value)} />
            <button className="ghost" style={S.miniBtn} onClick={resetFilters}>مسح الفلاتر</button>
          </div>
        </div>

        <div style={S.kpiRow}>
          <Kpi num={rows.length} label="إجمالي الكتب" color={"var(--accent)"} />
          <Kpi num={langT.length} label="عدد اللغات" color={"var(--accent)"} />
          <Kpi num={scopedProjects.length} label="عدد المشاريع" color={"var(--accent)"} />
          <Kpi num={authors.size} label="عدد المؤلفين" color={"var(--accent)"} />
          <Kpi num={translators.size} label="عدد المترجمين" color={"var(--accent)"} />
          {scope === "all" && <Kpi num={sourcePubs.length} label="عدد الوكالات" color={"var(--accent)"} />}
        </div>

        <div style={S.mkSection}>
          <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>عدد الكتب لكل لغة (أعمدة)</div>
          <div style={{ ...S.kpiRow, marginBottom: 16 }}>
            <Kpi num={rows.length} label="عدد الكتب" color={"var(--accent)"} />
            <Kpi num={langT.length} label="عدد اللغات" color={"var(--accent)"} />
            <Kpi num={translators.size} label="عدد المترجمين" color={"var(--accent)"} />
          </div>
          <ColumnChart entries={langT} color={"var(--accent)"} />
        </div>

        <div style={S.statCols}>
          <div style={S.mkSection}>
            <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>عدد الكتب لكل مؤلف</div>
            <BarList entries={authorT} color={"var(--accent)"} />
          </div>
          <div style={S.mkSection}>
            <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>عدد الكتب لكل مترجم</div>
            <BarList entries={transT} color={"var(--accent)"} />
          </div>
        </div>

        <div style={S.statCols}>
          <div style={S.mkSection}>
            <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>حسب دار النشر العربية</div>
            <BarList entries={arT} color={"var(--accent)"} />
          </div>
          <div style={S.mkSection}>
            <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>حسب دار النشر الأجنبية</div>
            <BarList entries={frT} color={"var(--accent)"} />
          </div>
        </div>

        {/* مؤشّر اكتمال البيانات */}
        <div style={S.mkSection}>
          <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>مؤشّر اكتمال البيانات</div>
          <div style={S.kpiRow}>
            <Kpi num={missCover} label="ينقصه غلاف مترجم" color="#e23d3d" />
            <Kpi num={missContract} label="ينقصه عقد" color="#e23d3d" />
            <Kpi num={missIsbn} label="ينقصه ردمك" color="#e23d3d" />
            <Kpi num={rows.length - incomplete.length} label="مكتمل" color="#8a1c3b" />
          </div>
          {incomplete.length > 0 && (
            <div style={{ ...S.mkTableWrap, marginTop: 12 }}>
              <table style={S.mkTable}>
                <thead><tr><th style={S.th}>اسم الكتاب</th><th style={S.th}>المشروع</th><th style={S.th}>الناقص</th></tr></thead>
                <tbody>
                  {incomplete.map(({ r, m }) => (
                    <tr key={r.id}>
                      <td style={S.tdName}>{r.name}</td>
                      <td style={S.tdDerived}>{r.project}</td>
                      <td style={S.td}>
                        <span style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                          {m.map((x) => <span key={x} style={S.missChip}>{x}</span>)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* حالة التسويق */}
        <div style={S.mkSection}>
          <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>حالة التسويق</div>
          <div style={S.kpiRow}>
            <Kpi num={digitalN} label="في منصّات رقمية" color={"var(--accent)"} />
            <Kpi num={storesN} label="في متاجر إلكترونية" color={"var(--accent)"} />
            <Kpi num={awardsN} label="مُرشّح لجوائز" color={"var(--accent)"} />
            <Kpi num={fairsN} label="مشاركات بمعارض" color={"var(--accent)"} />
          </div>
        </div>

        {/* حالة التسليمات ومتابعة العمل حتى الاكتمال */}
        {(() => {
          const dRows = rows.map((r) => ({ r, c: delivCounts(r) }));
          const oDone = dRows.reduce((s, x) => s + x.c.done, 0);
          const oTotal = dRows.reduce((s, x) => s + x.c.total, 0);
          const oPct = oTotal ? Math.round((oDone / oTotal) * 100) : 0;
          const completed = dRows.filter((x) => x.c.total > 0 && x.c.done === x.c.total).length;
          const notStarted = dRows.filter((x) => x.c.done === 0).length;
          const inProgress = dRows.length - completed - notStarted;
          const party = (key) => { const dn = rows.reduce((s, r) => s + partyCounts(r, key).done, 0); const items = DELIV.find((s) => s.key === key).items.length; const tot = rows.length * items; return { dn, tot, pct: tot ? Math.round((dn / tot) * 100) : 0 }; };
          const tP = party("translator"), pP = party("publisher"), aP = party("authority");
          const totalAmount = rows.reduce((s, r) => s + delivAmount(r), 0);
          const track = [...dRows].sort((a, b) => (a.c.done / (a.c.total || 1)) - (b.c.done / (b.c.total || 1)));
          const pctBar = (label, o) => (
            <div style={S.barRow}>
              <span style={S.barLabel}>{label}</span>
              <div style={S.barTrack}><div style={{ ...S.barFill, width: `${o.pct}%`, background: "#e8ff00" }} /></div>
              <span style={S.barVal}>{toAr(o.pct)}%</span>
            </div>
          );
          return (
            <>
              <div style={S.mkSection}>
                <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>حالة التسليمات - متابعة العمل حتى الاكتمال</div>
                <div style={S.kpiRow}>
                  <Kpi num={oPct} label="نسبة الإنجاز الكلّية ٪" color={"var(--accent)"} />
                  <Kpi num={completed} label="اكتملت بالكامل" color="#8a1c3b" />
                  <Kpi num={inProgress} label="قيد العمل" color="#d99a00" />
                  <Kpi num={notStarted} label="لم تبدأ" color="#e23d3d" />
                  {totalAmount > 0 && <Kpi num={totalAmount} label="إجمالي المبالغ المسجّلة" color={"var(--accent)"} />}
                </div>
                <div style={{ marginTop: 6 }}>
                  {pctBar("الإجمالي", { pct: oPct })}
                  {pctBar("المترجم", tP)}
                  {pctBar("الناشر", pP)}
                  {pctBar("الهيئة", aP)}
                </div>
              </div>

              <div style={S.mkSection}>
                <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>قائمة المتابعة (الأقل إنجازًا أولًا)</div>
                <div style={S.mkTableWrap}>
                  <table style={S.mkTable}>
                    <thead><tr>
                      <th style={S.th}>اسم الكتاب</th><th style={S.th}>المشروع</th>
                      <th style={S.th}>المترجم</th><th style={S.th}>الناشر</th><th style={S.th}>الهيئة</th>
                      <th style={S.th}>الإنجاز</th><th style={S.th}>المتبقّي</th><th style={S.th}>الحالة</th>
                    </tr></thead>
                    <tbody>
                      {track.length === 0 && <tr><td style={S.td} colSpan={8}>لا كتب.</td></tr>}
                      {track.map(({ r, c }) => {
                        const pct = c.total ? Math.round((c.done / c.total) * 100) : 0;
                        const t = partyCounts(r, "translator"), p = partyCounts(r, "publisher"), a = partyCounts(r, "authority");
                        const status = c.done === 0 ? ["لم تبدأ", "#e23d3d"] : (c.done === c.total ? ["مكتمل", "#8a1c3b"] : ["قيد العمل", "#d99a00"]);
                        return (
                          <tr key={r.id}>
                            <td style={S.tdName}>{r.name}</td>
                            <td style={S.tdDerived}>{r.project}</td>
                            <td style={S.tdDerived}>{toAr(t.done)}/{toAr(t.total)}</td>
                            <td style={S.tdDerived}>{toAr(p.done)}/{toAr(p.total)}</td>
                            <td style={S.tdDerived}>{toAr(a.done)}/{toAr(a.total)}</td>
                            <td style={S.tdDerived}>{toAr(c.done)}/{toAr(c.total)} ({toAr(pct)}٪)</td>
                            <td style={S.tdDerived}>{toAr(c.total - c.done)}</td>
                            <td style={S.td}><span style={{ ...S.missChip, color: status[1], borderColor: status[1] + "55", background: status[1] + "14" }}>{status[0]}</span></td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          );
        })()}

        {/* الخط الزمني */}
        <div style={S.mkSection}>
          <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>الخط الزمني - كتب مُضافة شهريًا</div>
          <BarList entries={monthT} color={"var(--accent)"} />
        </div>

        {/* تفصيل لكل لغة */}
        {langKeys.map((l) => (
          <div key={l} style={S.mkSection}>
            <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>
              اللغة: {l} <span style={{ color: "var(--muted)", fontWeight: 400 }}>- {toAr((langMap[l] || []).length)} كتاب</span>
            </div>
            <div style={S.mkTableWrap}>
              <table style={S.mkTable}>
                <thead><tr><th style={S.th}>م</th><th style={S.th}>اسم الكتاب</th><th style={S.th}>اسم المؤلف</th><th style={S.th}>المشروع</th></tr></thead>
                <tbody>
                  {(langMap[l] || []).map((r, i) => (
                    <tr key={r.id}>
                      <td style={S.tdNum}>{toAr(i + 1)}</td>
                      <td style={S.tdName}>{r.name}</td>
                      <td style={S.tdDerived}>{r.authorName || "-"}</td>
                      <td style={S.tdDerived}>{r.project}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
      {showExp && <StatsExportModal rows={rows} scopedProjects={scopedProjects} color={"var(--accent)"} onClose={() => setShowExp(false)} />}
    </div>
  );
}

/* نافذة اختيار فئات (أوراق) ملف إحصاءات Excel */
function StatsExportModal({ rows, scopedProjects, title, color, onClose }) {
  const [sel, setSel] = useState(STAT_SHEETS.map((s) => s.k));
  const [name, setName] = useState(`إحصائيات_${title}`);
  const toggle = (k) => setSel((s) => s.includes(k) ? s.filter((x) => x !== k) : [...s, k]);
  const can = sel.length > 0;
  const run = () => { if (!can) return; exportStats(rows, scopedProjects, title, { sheets: sel, filename: name }); onClose(); };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}><h3 style={S.modalTitle}>تصدير الإحصاءات</h3><CloseBtn onClose={onClose} /></div>
      <div style={S.exportNote}>النطاق: <b style={{ color: "var(--text)" }}>{title}</b> - <b style={{ color }}>{toAr(rows.length)}</b> كتاب. اختر الفئات (الأوراق) التي ستظهر في الملف:</div>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button className="ghost" style={S.miniBtn} onClick={() => setSel(STAT_SHEETS.map((s) => s.k))}>تحديد الكل</button>
        <button className="ghost" style={S.miniBtn} onClick={() => setSel([])}>إلغاء التحديد</button>
      </div>
      <div style={S.colGrid}>
        {STAT_SHEETS.map((s) => {
          const on = sel.includes(s.k);
          return (
            <button key={s.k} className="seg-btn" style={{ ...S.colChip, ...(on ? { background: "#e8ff00", borderColor: "var(--accent)", color: "#0b1020" } : {}) }} onClick={() => toggle(s.k)}>
              {on ? <Check size={14} /> : <Plus size={14} />} {s.label}
            </button>
          );
        })}
      </div>
      <label style={S.label}>اسم الملف</label>
      <input style={{ ...S.input, direction: "ltr", textAlign: "left" }} value={name} onChange={(e) => setName(e.target.value)} />
      <div style={S.modalFoot}>
        <button style={S.cancelBtn} className="ghost" onClick={onClose}>إلغاء</button>
        <button style={{ ...S.saveBtn, opacity: can ? 1 : 0.45, cursor: can ? "pointer" : "not-allowed" }} className="save-btn" disabled={!can} onClick={run}>
          <FileSpreadsheet size={16} /> تصدير ({toAr(sel.length)} ورقة)
        </button>
      </div>
    </Overlay>
  );
}

/* --------------------- نظام متابعة التسليمات --------------------- */
function DeliveryRow({ item, data, color, onPatch }) {
  const done = !!data.done;
  const pickFile = (e) => {
    const f = e.target.files[0]; if (!f) return;
    const r = new FileReader();
    r.onload = () => onPatch({ file: { name: f.name, type: f.type, data: r.result } });
    r.readAsDataURL(f); e.target.value = "";
  };
  return (
    <div style={{ ...S.delRow, ...(done ? { background: "rgba(26,156,91,0.05)" } : {}) }}>
      <button style={{ ...S.delCheck, ...(done ? { background: "#8a1c3b", borderColor: "#8a1c3b" } : {}) }} onClick={() => onPatch({ done: !done })} aria-label="تم">
        {done && <Check size={14} color="currentColor" />}
      </button>
      <span style={{ ...S.delLabel, ...(done ? { color: "var(--text)" } : {}) }}>{item.label}</span>
      {item.amount && <input style={S.delAmount} placeholder="المبلغ" value={data.amount || ""} onChange={(e) => onPatch({ amount: e.target.value })} />}
      <input type="date" style={{ ...S.delDate, colorScheme: "light" }} value={data.date || ""} onChange={(e) => onPatch({ date: e.target.value })} />
      {item.file && (data.file ? (
        <span style={S.delFileWrap}>
          <button className="ghost" style={{ ...S.delMini, color }} onClick={() => downloadFile(data.file)}><Download size={14} /> ملف</button>
          <button className="ghost" style={S.delMiniDel} onClick={() => onPatch({ file: null })}></button>
        </span>
      ) : (
        <label style={S.delUpload} onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); const f = e.dataTransfer.files && e.dataTransfer.files[0]; if (f) pickFile({ target: { files: [f], value: "" } }); }}><Upload size={14} /> رفع
          <input type="file" style={{ display: "none" }} onChange={pickFile} />
        </label>
      ))}
    </div>
  );
}

function FilePeek({ file, children }) {
  const [url, setUrl] = React.useState(null);
  const [on, setOn] = React.useState(false);
  const [pos, setPos] = React.useState({ x: 0, y: 0 });
  const nm = (file && file.name ? String(file.name) : "").toLowerCase();
  const isImg = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(nm) || (file && file.type && String(file.type).startsWith("image/"));
  const isPdf = /\.pdf$/.test(nm) || (file && file.type === "application/pdf");
  const show = async (e) => {
    setPos({ x: e.clientX, y: e.clientY }); setOn(true);
    if (url || !file) return;
    try {
      if (file.data && String(file.data).startsWith("data:")) { setUrl(file.data); return; }
      if (file.path) { const u = await bookFileUrl(file.path); if (u) setUrl(u); }
    } catch {}
  };
  if (!isImg && !isPdf) return children;
  const w = 300, h = 420;
  const left = Math.min(Math.max(8, pos.x - w / 2), (typeof window !== "undefined" ? window.innerWidth : 900) - w - 8);
  const top = Math.max(8, pos.y - h - 18);
  return (
    <span style={{ position: "relative", display: "block" }}
      onMouseEnter={show} onMouseMove={(e) => setPos({ x: e.clientX, y: e.clientY })} onMouseLeave={() => setOn(false)}>
      {children}
      {on && url ? (
        <div style={{ position: "fixed", left, top, width: w, height: h, zIndex: 9999,
          background: "color-mix(in srgb, var(--surface) 92%, transparent)",
          backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
          border: `1.5px solid ${_activeTheme.accent}`, borderRadius: 12, overflow: "hidden",
          boxShadow: "0 18px 48px rgba(0,0,0,.45)" }}>
          {isImg
            ? <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            : <object data={url + "#page=1&toolbar=0&navpanes=0&view=FitH"} type="application/pdf" style={{ width: "100%", height: "100%", border: 0, background: "#fff" }}><iframe src={url} title="preview" style={{ width: "100%", height: "100%", border: 0, background: "#fff" }} /></object>}
        </div>
      ) : null}
    </span>
  );
}
function NamedFileList({ title, entries, color, onAdd, onSet, onRemove, max }) {
  const pickFile = (id, e) => {
    const f = e.target.files[0]; if (!f) return;
    const r = new FileReader();
    r.onload = () => onSet(id, { file: { name: f.name, type: f.type, data: r.result } });
    r.readAsDataURL(f); e.target.value = "";
  };
  const atMax = max && entries.length >= max;
  return (
    <div style={S.mkSection}>
      <div style={{ ...S.mkSecTitle, color, borderColor: "var(--accent)" }}>{title}{max ? ` (حتى ${toAr(max)})` : ""}</div>
      <div style={S.delList}>
        {entries.length === 0 && <div style={{ ...S.delRow, color: "var(--faint)", fontFamily: arab, fontSize: 14 }}>لا عناصر بعد - أضِف بالأسفل.</div>}
        {entries.map((en, i) => (
          <div key={en.id} style={S.delRow}>
            <input style={S.nflName} value={en.name || ""} placeholder={`الاسم ${toAr(i + 1)}`} onChange={(e) => onSet(en.id, { name: e.target.value })} />
            {en.file ? (
              <span style={S.delFileWrap}>
                <button className="ghost" style={{ ...S.delMini, color }} onClick={() => downloadFile(en.file)}><Download size={14} /> ملف</button>
                <button className="ghost" style={S.delMiniDel} onClick={() => onSet(en.id, { file: null })}></button>
              </span>
            ) : (
              <label style={S.delUpload} onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); const f = e.dataTransfer.files && e.dataTransfer.files[0]; if (f) pickFile(en.id, { target: { files: [f], value: "" } }); }}><Upload size={14} /> رفع<input type="file" style={{ display: "none" }} onChange={(e) => pickFile(en.id, e)} /></label>
            )}
            <input style={S.nflNote} value={en.note || ""} placeholder="ملاحظات" onChange={(e) => onSet(en.id, { note: e.target.value })} />
            <button className="ghost" style={S.delMiniDel} onClick={() => onRemove(en.id)}></button>
          </div>
        ))}
      </div>
      <button className="ghost" style={{ ...S.mkAddRow, color, borderColor: "var(--accent)", opacity: atMax ? 0.5 : 1, cursor: atMax ? "not-allowed" : "pointer" }} disabled={!!atMax} onClick={onAdd}><Plus size={14} /> إضافة</button>
    </div>
  );
}

function Deliveries({ publisher, project, onUpdateBook, onBack }) {
  const col = publisher.color;
  const books = project.works || [];
  const [sel, setSel] = useState(books.length ? books[0].id : null);
  const book = books.find((b) => b.id === sel) || books[0] || null;

  const patch = (section, k, p) => onUpdateBook(book.id, (b) => {
    const d = { ...(b.deliveries || {}) };
    const sec = { ...(d[section] || {}) };
    sec[k] = { ...(sec[k] || {}), ...p };
    d[section] = sec;
    return { ...b, deliveries: d };
  });

  const overall = book ? delivCounts(book) : { done: 0, total: 0 };

  const ar = book ? ((book.deliveries || {}).authorityReceipts || {}) : {};
  const updAR = (updater) => onUpdateBook(book.id, (b) => { const d = { ...(b.deliveries || {}) }; d.authorityReceipts = updater(d.authorityReceipts || {}); return { ...b, deliveries: d }; });
  const setContract = (p) => updAR((a) => ({ ...a, beneficiaryContract: { ...(a.beneficiaryContract || {}), ...p } }));
  const addReceipt = () => updAR((a) => ({ ...a, receipts: [...(a.receipts || []), { id: Date.now(), name: `إيصال ${toAr((a.receipts || []).length + 1)}` }] }));
  const setReceipt = (id, p) => updAR((a) => ({ ...a, receipts: (a.receipts || []).map((x) => x.id === id ? { ...x, ...p } : x) }));
  const removeReceipt = (id) => updAR((a) => ({ ...a, receipts: (a.receipts || []).filter((x) => x.id !== id) }));
  const addDetail = () => updAR((a) => { const arr = a.transferDetails || []; if (arr.length >= 6) return a; return { ...a, transferDetails: [...arr, { id: Date.now(), name: `ملف ${toAr(arr.length + 1)}` }] }; });
  const setDetail = (id, p) => updAR((a) => ({ ...a, transferDetails: (a.transferDetails || []).map((x) => x.id === id ? { ...x, ...p } : x) }));
  const removeDetail = (id) => updAR((a) => ({ ...a, transferDetails: (a.transferDetails || []).filter((x) => x.id !== id) }));

  return (
    <div style={S.page} className="fade-in">
      <div style={S.topbar}>
        <button style={S.backBtn} className="ghost" onClick={onBack}>الكتب</button>
        <span style={{ width: 90 }} />
      </div>
      <div style={S.body}>
        <div style={S.sectionHead}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ ...S.crumbIcon, color: "var(--accent)" }}><ClipboardCheck size={22} color={"var(--accent)"} /></span>
            <div>
              <h2 style={S.sectionTitle}>متابعة التسليمات</h2>
            </div>
          </div>
        </div>

        {books.length === 0 && <div style={S.emptyHint}>لا كتب في هذا المشروع بعد - أضِف كتابًا أولًا.</div>}

        {book && (
          <>
            <div style={S.delBookBar}>
              {books.map((b) => {
                const c = delivCounts(b);
                const on = b.id === book.id;
                return (
                  <button key={b.id} className="seg-btn" style={{ ...S.delBookTab, ...(on ? { background: "#e8ff00", borderColor: "var(--accent)", color: "#0b1020" } : {}) }} onClick={() => setSel(b.id)}>
                    {b.name} <span style={{ opacity: 0.75, fontFamily: mono, fontSize: 14 }}>{toAr(c.done)}/{toAr(c.total)}</span>
                  </button>
                );
              })}
            </div>

            <div style={S.mkSection}>
              <div style={S.barRow}>
                <span style={S.barLabel}>الإنجاز الكلّي</span>
                <div style={S.barTrack}><div style={{ ...S.barFill, width: `${overall.total ? (overall.done / overall.total) * 100 : 0}%`, background: "#e8ff00" }} /></div>
                <span style={S.barVal}>{toAr(overall.done)}/{toAr(overall.total)}</span>
              </div>
            </div>

            {DELIV.map((secDef) => {
              const doneN = secDef.items.filter((it) => delivItem(book, secDef.key, it.k).done).length;
              return (
                <div key={secDef.key} style={S.mkSection}>
                  <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)", display: "flex", justifyContent: "space-between" }}>
                    <span>تسليمات {secDef.title}</span>
                    <span style={{ fontFamily: mono, fontSize: 14, color: doneN === secDef.items.length ? "#8a1c3b" : "var(--muted)", fontWeight: 700 }}>{toAr(doneN)}/{toAr(secDef.items.length)}</span>
                  </div>
                  <div style={S.delList}>
                    {secDef.items.map((it) => (
                      <DeliveryRow key={it.k} item={it} data={delivItem(book, secDef.key, it.k)} color={"var(--accent)"} onPatch={(p) => patch(secDef.key, it.k, p)} />
                    ))}
                  </div>
                </div>
              );
            })}

            {/* استلامات من الهيئة */}
            <div style={S.mkSection}>
              <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>استلامات من الهيئة</div>
              <div style={S.delList}>
                <DeliveryRow item={{ k: "beneficiaryContract", label: "عقد المستفيد بعد التوقيع (رفع الملف)", file: true }} data={ar.beneficiaryContract || {}} color={"var(--accent)"} onPatch={setContract} />
              </div>
            </div>

            <NamedFileList color={"var(--accent)"} entries={ar.receipts || []} onAdd={addReceipt} onSet={setReceipt} onRemove={removeReceipt} />

            <NamedFileList color={"var(--accent)"} entries={ar.transferDetails || []} onAdd={addDetail} onSet={setDetail} onRemove={removeDetail} max={6} />
          </>
        )}
      </div>
    </div>
  );
}

/* --------------------- نظام متابعة التسويق --------------------- */
function MkBookTable({ sec, books, m, onCell }) {
  const derived = sec.derived || [];
  const span = 2 + derived.length + sec.cols.length;
  return (
    <div style={S.mkTableWrap}>
      <table style={S.mkTable}>
        <thead>
          <tr>
            <th style={S.th}>م</th>
            <th style={S.th}>اسم الكتاب</th>
            {derived.map((d) => <th key={d.label} style={S.th}>{d.label}</th>)}
            {sec.cols.map((c) => <th key={c.k} style={S.th}>{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {books.length === 0 && <tr><td style={S.td} colSpan={span}>لا كتب في هذا المشروع بعد.</td></tr>}
          {books.map((b, i) => {
            const cell = ((m[sec.key] || {})[b.id]) || {};
            return (
              <tr key={b.id}>
                <td style={S.tdNum}>{toAr(i + 1)}</td>
                <td style={S.tdName}>{b.name}</td>
                {derived.map((d) => <td key={d.label} style={S.tdDerived}>{d.get(b) || "-"}</td>)}
                {sec.cols.map((c) => (
                  <td key={c.k} style={S.td}>
                    <input style={S.tdInput} value={cell[c.k] || ""} onChange={(e) => onCell(sec.key, b.id, c.k, e.target.value)} />
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function MkFairsTable({ sec, fairs, onAdd, onSet, onRemove, col }) {
  return (
    <div style={S.mkTableWrap}>
      <table style={S.mkTable}>
        <thead>
          <tr>
            <th style={S.th}>م</th>
            {sec.cols.map((c) => <th key={c.k} style={S.th}>{c.label}</th>)}
            <th style={S.th}></th>
          </tr>
        </thead>
        <tbody>
          {fairs.length === 0 && <tr><td style={S.td} colSpan={sec.cols.length + 2}>لا معارض بعد - أضِف صفًا.</td></tr>}
          {fairs.map((f, i) => (
            <tr key={f.id}>
              <td style={S.tdNum}>{toAr(i + 1)}</td>
              {sec.cols.map((c) => (
                <td key={c.k} style={S.td}><input style={S.tdInput} value={f[c.k] || ""} onChange={(e) => onSet(f.id, c.k, e.target.value)} /></td>
              ))}
              <td style={S.td}><button className="ghost" style={S.tdDel} onClick={() => onRemove(f.id)}></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="ghost" style={{ ...S.mkAddRow, color: "var(--accent)", borderColor: "var(--accent)" }} onClick={onAdd}><Plus size={14} /> إضافة معرض</button>
    </div>
  );
}

function Marketing({ publisher, project, onUpdate, onBack }) {
  const col = publisher.color;
  const books = project.works || [];
  const m = project.marketing || {};
  const pubName = (books.find((b) => b.pubFrHouse) || {}).pubFrHouse || "";
  const [showExp, setShowExp] = useState(false);
  const setMeta = (k, v) => onUpdate((j) => ({ ...j, marketing: { ...(j.marketing || {}), [k]: v } }));
  const setCell = (sk, bid, f, v) => onUpdate((j) => { const mm = { ...(j.marketing || {}) }; const sec = { ...(mm[sk] || {}) }; sec[bid] = { ...(sec[bid] || {}), [f]: v }; mm[sk] = sec; return { ...j, marketing: mm }; });
  const setContact = (f, v) => onUpdate((j) => { const mm = { ...(j.marketing || {}) }; mm.contact = { ...(mm.contact || {}), [f]: v }; return { ...j, marketing: mm }; });
  const addFair = () => onUpdate((j) => { const mm = { ...(j.marketing || {}) }; mm.fairs = [...(mm.fairs || []), { id: Date.now() }]; return { ...j, marketing: mm }; });
  const setFair = (id, f, v) => onUpdate((j) => { const mm = { ...(j.marketing || {}) }; mm.fairs = (mm.fairs || []).map((x) => x.id === id ? { ...x, [f]: v } : x); return { ...j, marketing: mm }; });
  const removeFair = (id) => onUpdate((j) => { const mm = { ...(j.marketing || {}) }; mm.fairs = (mm.fairs || []).filter((x) => x.id !== id); return { ...j, marketing: mm }; });

  return (
    <div style={S.page} className="fade-in">
      <div style={S.topbar}>
        <button style={S.backBtn} className="ghost" onClick={onBack}>الكتب</button>
        <button className="ghost" style={S.exportBtn} onClick={() => setShowExp(true)}><FileSpreadsheet size={16} /> تصدير Excel</button>
      </div>
      <div style={S.body}>
        <div style={S.sectionHead}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ ...S.crumbIcon, color: "var(--accent)" }}><Megaphone size={22} color={"var(--accent)"} /></span>
            <div>
              <h2 style={S.sectionTitle}>متابعة التوزيع والتسويق</h2>
            </div>
          </div>
        </div>

        <div style={S.mkMetaRow}>
          <div style={{ flex: 1 }}><label style={S.label}>تاريخ التقرير</label><input type="date" style={{ ...S.input, colorScheme: "light" }} value={m.reportDate || ""} onChange={(e) => setMeta("reportDate", e.target.value)} /></div>
          <div style={{ flex: 1 }}><label style={S.label}>اسم المسؤول</label><input style={S.input} value={m.manager || ""} onChange={(e) => setMeta("manager", e.target.value)} /></div>
        </div>

        {MK.map((sec) => (
          <div key={sec.key} style={S.mkSection}>
            <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>{sec.n}</div>
            {sec.type === "book"
              ? <MkBookTable sec={sec} books={books} m={m} onCell={setCell} />
              : <MkFairsTable sec={sec} fairs={m.fairs || []} onAdd={addFair} onSet={setFair} onRemove={removeFair} col={col} />}
          </div>
        ))}

        <div style={S.mkSection}>
          <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>ملاحظات وجهود تسويقية إضافية</div>
          <textarea style={S.mkNotes} value={m.extraNotes || ""} onChange={(e) => setMeta("extraNotes", e.target.value)} placeholder="مثال: مناقشات في لقاءات ومحاضرات زوم، ندوات، مقابلات صحفية..." />
        </div>

        <div style={S.mkSection}>
          <div style={{ ...S.mkSecTitle, color: "var(--accent)", borderColor: "var(--accent)" }}>بيانات التواصل مع الناشر</div>
          <div style={S.mkContactGrid}>
            {MK_CONTACT.map((f) => {
              const ltr = ["email", "website", "facebook", "twitter"].includes(f.k);
              return (
                <div key={f.k}>
                  <label style={S.label}>{f.label}</label>
                  <input style={{ ...S.input, marginBottom: 0, ...(ltr ? { direction: "ltr", textAlign: "left" } : {}) }} value={(m.contact || {})[f.k] || ""} onChange={(e) => setContact(f.k, e.target.value)} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {showExp && <MkExportModal project={project} books={books} color={"var(--accent)"} onClose={() => setShowExp(false)} />}
    </div>
  );
}

/* نافذة تصدير المتابعة الانتقائية: اختيار الكتاب + اللغة + أقسام التسويق */
function MkExportModal({ project, books, color, onClose }) {
  const langs = Array.from(new Set(books.map((b) => b.lang).filter(Boolean)));
  const [lang, setLang] = useState("الكل");
  const visible = books.filter((b) => lang === "الكل" || b.lang === lang);
  const [bookIds, setBookIds] = useState(books.map((b) => b.id));
  const SECTION_OPTS = [...MK.map((s) => ({ key: s.key, label: (s.n.split(": ")[1] || s.n) })), { key: "notes", label: "ملاحظات إضافية" }, { key: "contact", label: "بيانات التواصل" }];
  const [secs, setSecs] = useState(SECTION_OPTS.map((s) => s.key));
  const [name, setName] = useState(`متابعة_${project.name}`);

  const toggleBook = (id) => setBookIds((a) => a.includes(id) ? a.filter((x) => x !== id) : [...a, id]);
  const toggleSec = (k) => setSecs((a) => a.includes(k) ? a.filter((x) => x !== k) : [...a, k]);
  const setLangFilter = (l) => { setLang(l); setBookIds(books.filter((b) => l === "الكل" || b.lang === l).map((b) => b.id)); };

  const chosenBooks = visible.filter((b) => bookIds.includes(b.id));
  const sectionKeys = secs.filter((k) => k !== "notes" && k !== "contact");
  const can = chosenBooks.length > 0 && secs.length > 0;
  const run = () => {
    if (!can) return;
    mkExportExcel(project, chosenBooks, name || "متابعة", {
      sections: sectionKeys, includeNotes: secs.includes("notes"), includeContact: secs.includes("contact"),
    });
    onClose();
  };

  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}><h3 style={S.modalTitle}>تصدير تقرير المتابعة</h3><CloseBtn onClose={onClose} /></div>

      <label style={S.label}>اللغة المترجَم إليها</label>
      <TmSelect value={lang} onChange={setLangFilter} options={[["الكل", "كل اللغات"], ...langs.map((l) => [l, l])]} />

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <label style={S.label}>اختر الكتب</label>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="ghost" style={S.miniBtn} onClick={() => setBookIds(visible.map((b) => b.id))}>الكل</button>
          <button className="ghost" style={S.miniBtn} onClick={() => setBookIds([])}>لا شيء</button>
        </div>
      </div>
      <div style={S.colGrid}>
        {visible.length === 0 && <span style={{ fontFamily: arab, fontSize: 14, color: "var(--faint)" }}>لا كتب بهذه اللغة.</span>}
        {visible.map((b) => {
          const on = bookIds.includes(b.id);
          return (
            <button key={b.id} className="seg-btn" style={{ ...S.colChip, ...(on ? { background: "#e8ff00", borderColor: "var(--accent)", color: "#0b1020" } : {}) }} onClick={() => toggleBook(b.id)}>
              {on ? <Check size={14} /> : <Plus size={14} />} {b.name} <span style={{ opacity: 0.7 }}>· {b.lang}</span>
            </button>
          );
        })}
      </div>

      <label style={S.label}>بيانات التسويق المطلوبة</label>
      <div style={S.colGrid}>
        {SECTION_OPTS.map((s) => {
          const on = secs.includes(s.key);
          return (
            <button key={s.key} className="seg-btn" style={{ ...S.colChip, ...(on ? { background: "#e8ff00", borderColor: "var(--accent)", color: "#0b1020" } : {}) }} onClick={() => toggleSec(s.key)}>
              {on ? <Check size={14} /> : <Plus size={14} />} {s.label}
            </button>
          );
        })}
      </div>

      <label style={S.label}>اسم الملف</label>
      <input style={{ ...S.input, direction: "ltr", textAlign: "left" }} value={name} onChange={(e) => setName(e.target.value)} />

      <div style={S.modalFoot}>
        <button style={S.cancelBtn} className="ghost" onClick={onClose}>إلغاء</button>
        <button style={{ ...S.saveBtn, opacity: can ? 1 : 0.45, cursor: can ? "pointer" : "not-allowed" }} className="save-btn" disabled={!can} onClick={run}>
          <FileSpreadsheet size={16} /> تصدير ({toAr(chosenBooks.length)} كتاب)
        </button>
      </div>
    </Overlay>
  );
}
/* --------------------- النظام المالي للنشر --------------------- */
const finNum = (s) => { const n = parseFloat(String(s == null ? "" : s).replace(/[^0-9.\-]/g, "")); return isNaN(n) ? 0 : n; };
const finGid = () => `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
const finFmt = (n) => finNum(n).toLocaleString("en-US");
async function readFinFile(file) {
  const dataURL = await new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });
  if (!/^image\//.test(file.type || "")) return { name: file.name, data: dataURL, type: file.type || "application/octet-stream" };
  return await new Promise((res) => {
    const img = new Image();
    img.onload = () => {
      const max = 1600; let w = img.width, h = img.height;
      if (w > max || h > max) { const r = Math.min(max / w, max / h); w = Math.round(w * r); h = Math.round(h * r); }
      const cv = document.createElement("canvas"); cv.width = w; cv.height = h;
      cv.getContext("2d").drawImage(img, 0, 0, w, h);
      let out; try { out = cv.toDataURL("image/jpeg", 0.82); } catch { out = dataURL; }
      res({ name: file.name, data: out, type: "image/jpeg" });
    };
    img.onerror = () => res({ name: file.name, data: dataURL, type: file.type || "image" });
    img.src = dataURL;
  });
}
const FIN_ICONS = { truck: Truck, bank: Banknote, print: Printer, other: Wallet };
const FIN_DEFAULTS = (w) => ([
  { id: "ship", name: "الشحن للسعودية", icon: "truck", amount: "", done: false, date: "", ref: "", invoices: [] },
  { id: "author", name: "حقوق الكاتب / دار النشر", icon: "bank", amount: w.fee1 || "", done: false, date: "", ref: "", invoices: [] },
  { id: "translator", name: "حقوق المترجم", icon: "bank", amount: w.fee2 || "", done: false, date: "", ref: "", invoices: [] },
  { id: "print", name: "الطباعة", icon: "print", amount: "", done: false, date: "", ref: "", invoices: [] },
]);
function finSections(w, f) {
  if (f && Array.isArray(f.sections)) return f.sections.map((s) => ({ amount: "", done: false, date: "", ref: "", icon: "other", ...s, invoices: s.invoices || [] }));
  const def = FIN_DEFAULTS(w);
  if (f && (f.ship || f.author || f.translator || f.print || f.custom)) {
    const merged = def.map((d) => ({ ...d, ...(f[d.id] || {}), invoices: (f[d.id] && f[d.id].invoices) || [] }));
    const customs = Array.isArray(f.custom) ? f.custom.map((c) => ({ icon: "other", ref: "", ...c, invoices: c.invoices || [] })) : [];
    return [...merged, ...customs];
  }
  return def;
}
const finS = {
  summary: { display: "flex", flexWrap: "wrap", gap: 10, margin: "4px 0 10px" },
  sumCard: { flex: "1 1 120px", minWidth: 118, background: "color-mix(in srgb, var(--surface) 62%, transparent)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", border: "1px solid var(--line)", borderRadius: 12, padding: "11px 14px", textAlign: "center" },
  sumNum: { fontFamily: arab, fontWeight: 800, fontSize: 18, color: "var(--accent)", direction: "ltr" },
  sumLbl: { fontFamily: arab, fontSize: 14, color: "var(--muted)", marginTop: 3 },
  hint: { fontFamily: arab, fontSize: 14, color: "var(--faint)", margin: "0 0 14px" },
  warn: { background: "color-mix(in srgb, #e23d3d 14%, transparent)", border: "1px solid #e23d3d55", color: "var(--text)", fontFamily: arab, fontSize: 14, borderRadius: 10, padding: "9px 12px", marginBottom: 14 },
  bookCard: { background: "color-mix(in srgb, var(--surface) 62%, transparent)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", border: "1px solid var(--line)", borderRadius: 14, marginBottom: 12, overflow: "hidden" },
  bookHead: { width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "13px 16px", background: "transparent", border: "none", cursor: "pointer" },
  dot: { width: 12, height: 12, borderRadius: "50%", flexShrink: 0 },
  bookName: { fontFamily: arab, fontWeight: 700, fontSize: 15.5, color: "var(--text)" },
  bookMeta: { fontFamily: arab, fontSize: 14, color: "var(--faint)", marginTop: 2 },
  chev: { fontFamily: mono, fontSize: 14, color: "var(--faint)" },
  boxGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(258px,1fr))", gap: 12, padding: "0 16px 6px" },
  box: { background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 12, padding: 12 },
  boxHeadRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 9 },
  nameGrip: { display: "flex", alignItems: "center", gap: 8, flex: 1, cursor: "pointer", userSelect: "none" },
  boxIcon: { width: 28, height: 28, borderRadius: 8, display: "inline-flex", alignItems: "center", justifyContent: "center", background: "var(--surface)", border: "1px solid var(--line)", flexShrink: 0 },
  boxName: { flex: 1, fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)" },
  boxNameInput: { flex: 1, fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "1px solid var(--accent)", borderRadius: 8, padding: "4px 8px" },
  flag: { display: "inline-flex", alignItems: "center", gap: 5, fontFamily: arab, fontSize: 14, color: "var(--muted)", cursor: "pointer", whiteSpace: "nowrap" },
  saveBtn: { display: "inline-flex", alignItems: "center", gap: 5, fontFamily: arab, fontSize: 14, fontWeight: 700, color: "#fff", background: "var(--accent)", border: "none", borderRadius: 8, padding: "5px 10px", cursor: "pointer" },
  actions: { display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 9, padding: 6, background: "color-mix(in srgb, var(--surface) 75%, transparent)", border: "1px solid var(--line)", borderRadius: 9 },
  actBtn: { display: "inline-flex", alignItems: "center", gap: 5, fontFamily: arab, fontSize: 14, fontWeight: 600, color: "var(--text)", background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 8, padding: "5px 10px", cursor: "pointer" },
  boxRow: { display: "flex", gap: 7, flexWrap: "wrap", marginBottom: 8 },
  amt: { width: 88, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 8, padding: "6px 8px" },
  date: { width: 128, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 8, padding: "6px 8px" },
  ref: { flex: 1, minWidth: 100, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 8, padding: "6px 8px" },
  invWrap: { display: "flex", flexDirection: "column", gap: 6 },
  invRow: { display: "flex", alignItems: "center", gap: 6 },
  invName: { flex: 1, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 7, padding: "4px 7px" },
  invLink: { fontFamily: arab, fontSize: 14, color: "var(--accent)", textDecoration: "none", border: "1px solid var(--line)", borderRadius: 7, padding: "3px 8px", whiteSpace: "nowrap" },
  iconBtn: { padding: 4, borderRadius: 7, border: "1px solid var(--line)", background: "var(--surface)", cursor: "pointer", color: "var(--muted)", display: "inline-flex" },
  upBtn: { display: "inline-flex", alignItems: "center", gap: 6, fontFamily: arab, fontSize: 14, fontWeight: 600, color: "var(--accent)", background: "var(--surface)", border: "1px dashed var(--accent)", borderRadius: 8, padding: "6px 10px", cursor: "pointer", width: "fit-content" },
  addSection: { display: "inline-flex", alignItems: "center", gap: 6, fontFamily: arab, fontSize: 14, fontWeight: 700, color: "var(--accent)", background: "transparent", border: "1px dashed var(--accent)", borderRadius: 10, padding: "8px 12px", cursor: "pointer", margin: "4px 16px 16px" },
};

function Finance({ publisher, onUpdateFinance, onBack }) {
  const [open, setOpen] = useState({});
  const [actions, setActions] = useState(null);   // { bookId, sid }
  const [editing, setEditing] = useState(null);    // { b, sid }
  const [nameDraft, setNameDraft] = useState("");
  const lp = useLongPress(() => {}, (arg) => setActions(arg));

  const books = [];
  (publisher.projects || []).forEach((j) => (j.works || []).forEach((w) => { if ((w.status || "active") === "active") books.push({ ...w, _pid: j.id, _pname: j.name }); }));

  const setSections = (b, producer) => onUpdateFinance(b._pid, b.id, (f) => ({ sections: producer(finSections(b, f)) }));
  const patchSec = (b, sid, patch) => setSections(b, (secs) => secs.map((s) => (s.id === sid ? { ...s, ...patch } : s)));
  const addSec = (b) => { const id = finGid(); setSections(b, (secs) => [...secs, { id, name: "قسم جديد", icon: "other", amount: "", done: false, date: "", ref: "", invoices: [] }]); setActions(null); setEditing({ b: b.id, sid: id }); setNameDraft("قسم جديد"); };
  const delSec = (b, sid) => { setSections(b, (secs) => secs.filter((s) => s.id !== sid)); setActions(null); if (editing && editing.sid === sid) setEditing(null); };
  const saveName = (b, sec) => { patchSec(b, sec.id, { name: (nameDraft.trim() || sec.name) }); setEditing(null); setNameDraft(""); };
  const addInv = async (b, sid, fl) => { const file = fl && fl[0]; if (!file) return; const rec = await readFinFile(file); const inv = { id: finGid(), name: rec.name, data: rec.data, type: rec.type }; setSections(b, (secs) => secs.map((s) => (s.id === sid ? { ...s, invoices: [...(s.invoices || []), inv] } : s))); };
  const renInv = (b, sid, iid, name) => setSections(b, (secs) => secs.map((s) => (s.id === sid ? { ...s, invoices: s.invoices.map((i) => (i.id === iid ? { ...i, name } : i)) } : s)));
  const delInv = (b, sid, iid) => setSections(b, (secs) => secs.map((s) => (s.id === sid ? { ...s, invoices: s.invoices.filter((i) => i.id !== iid) } : s)));

  let grand = 0, invCount = 0; const incomplete = [];
  books.forEach((b) => {
    const secs = finSections(b, b.finance);
    let bad = false;
    secs.forEach((s) => { grand += finNum(s.amount); invCount += (s.invoices || []).length; if (finNum(s.amount) > 0 && !s.done) bad = true; });
    if (bad) incomplete.push(b.name);
  });

  const exportExcel = async () => { await ensureXLSX();
    const aoa = [["الكتاب", "المشروع", "القسم", "المبلغ", "تمّ؟", "التاريخ", "المرجع", "المرفقات"]];
    books.forEach((b) => finSections(b, b.finance).forEach((s) => aoa.push([b.name, b._pname, s.name, s.amount || "", s.done ? "نعم" : "لا", s.date || "", s.ref || "", (s.invoices || []).map((i) => i.name).join(" | ")])));
    const ws = XLSX.utils.aoa_to_sheet(aoa); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, "المالية");
    pmExportWorkbook(wb, `مالية-${publisher.name}`);
  };
  const exportJSON = () => {
    const payload = { publisher: publisher.name, exportedAt: new Date().toISOString(), books: books.map((b) => ({ name: b.name, project: b._pname, sections: finSections(b, b.finance) })) };
    const str = JSON.stringify(payload, null, 2); const name = `مالية-${publisher.name}.json`;
    if (typeof window !== "undefined" && window.pmSaveBytes) { try { window.pmSaveBytes(name, new TextEncoder().encode(str)); return; } catch {} }
    const a = document.createElement("a"); a.href = URL.createObjectURL(new Blob([str], { type: "application/json" })); a.download = name; a.click();
  };

  const renderBox = (b, sec) => {
    const Icon = FIN_ICONS[sec.icon] || Wallet;
    const arg = { bookId: b.id, sid: sec.id };
    const editingThis = editing && editing.b === b.id && editing.sid === sec.id;
    const actionsThis = actions && actions.bookId === b.id && actions.sid === sec.id;
    return (
      <div key={sec.id} style={finS.box}>
        <div style={finS.boxHeadRow}>
          <span style={finS.nameGrip}
            onMouseDown={() => lp.start(arg)} onMouseUp={lp.cancel} onMouseLeave={lp.cancel}
            onTouchStart={() => lp.start(arg)} onTouchEnd={lp.cancel}
            onContextMenu={(e) => { e.preventDefault(); setActions(arg); }}>
            <span style={finS.boxIcon}><Icon size={16} color={"var(--accent)"} /></span>
            {editingThis
              ? <input autoFocus value={nameDraft} onChange={(e) => setNameDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && saveName(b, sec)} style={finS.boxNameInput} />
              : <span style={finS.boxName}>{sec.name}</span>}
          </span>
          {editingThis
            ? <button style={finS.saveBtn} onClick={() => saveName(b, sec)}><Check size={14} /> حفظ</button>
            : <label style={finS.flag}><input type="checkbox" checked={!!sec.done} onChange={(e) => patchSec(b, sec.id, { done: e.target.checked })} /> تمّ</label>}
        </div>
        {actionsThis && (
          <div style={finS.actions}>
            <button style={finS.actBtn} onClick={() => { setEditing({ b: b.id, sid: sec.id }); setNameDraft(sec.name); setActions(null); }}><Pencil size={14} /> تعديل الاسم</button>
            <button style={{ ...finS.actBtn, color: "#e23d3d", borderColor: "#e23d3d55" }} onClick={() => delSec(b, sec.id)}><Trash2 size={14} /> حذف القسم</button>
            <button style={finS.actBtn} onClick={() => setActions(null)}>إلغاء</button>
          </div>
        )}
        <div style={finS.boxRow}>
          <input value={sec.amount} onChange={(e) => patchSec(b, sec.id, { amount: e.target.value })} placeholder="المبلغ" dir="ltr" style={finS.amt} />
          <input value={sec.date || ""} onChange={(e) => patchSec(b, sec.id, { date: e.target.value })} type="date" style={finS.date} />
          <input value={sec.ref || ""} onChange={(e) => patchSec(b, sec.id, { ref: e.target.value })} placeholder="مرجع التحويل" style={finS.ref} />
        </div>
        <div style={finS.invWrap} onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); if (e.dataTransfer.files && e.dataTransfer.files.length) addInv(b, sec.id, e.dataTransfer.files); }}>
          {(sec.invoices || []).map((inv) => (
            <div key={inv.id} style={finS.invRow}>
              <Paperclip size={14} color={"var(--faint)"} />
              <input value={inv.name} onChange={(e) => renInv(b, sec.id, inv.id, e.target.value)} style={finS.invName} />
              <a href={inv.data} download={inv.name} target="_blank" rel="noreferrer" style={finS.invLink}>فتح</a>
              <button className="ghost" style={finS.iconBtn} onClick={() => delInv(b, sec.id, inv.id)}><X size={14} /></button>
            </div>
          ))}
          <label style={finS.upBtn}><Upload size={14} /> رفع فاتورة<input type="file" hidden onChange={(e) => { addInv(b, sec.id, e.target.files); e.target.value = ""; }} /></label>
        </div>
      </div>
    );
  };

  return (
    <div style={S.page} className="fade-in">
      <div style={S.topbar}>
        <button style={S.exportBtn} className="ghost" onClick={onBack}><ChevronRight size={16} /> الكتب</button>
        <span style={{ width: 90 }} />
      </div>
      <div style={S.body}>
        <div style={S.sectionHead}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ ...S.crumbIcon, color: "var(--accent)" }}><Wallet size={22} color={"var(--accent)"} /></span>
            <div><h2 style={S.sectionTitle}>النظام المالي - {publisher.name}</h2></div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="ghost" style={S.exportBtn} onClick={exportExcel}><FileSpreadsheet size={16} /> Excel</button>
            <button className="ghost" style={S.exportBtn} onClick={exportJSON}><Download size={16} /> JSON</button>
          </div>
        </div>

        <div style={finS.summary}>
          {[["الإجمالي", grand], ["فواتير مرفوعة", invCount]].map(([l, v]) => (
            <div key={l} style={finS.sumCard}><div style={finS.sumNum}>{finFmt(v)}</div><div style={finS.sumLbl}>{l}</div></div>
          ))}
          <div style={finS.sumCard}><div style={finS.sumNum}>{books.length}</div><div style={finS.sumLbl}>كتب</div></div>
        </div>
        <div style={finS.hint}>اضغط مطوّلًا (أو زرّ الفأرة الأيمن) على اسم أي خانة لتعديل اسمها أو حذفها.</div>
        {incomplete.length > 0 && <div style={finS.warn}>تحويلات غير مكتملة في: {incomplete.join("، ")}</div>}

        {books.length === 0 && <div style={S.emptyHint}>لا كتب في هذه الجهة بعد - أضِف كتبًا لتظهر هنا تلقائيًّا بمبالغها.</div>}

        {books.map((b) => {
          const secs = finSections(b, b.finance);
          const isOpen = !!open[b.id];
          const bookTotal = secs.reduce((s, x) => s + finNum(x.amount), 0);
          const allDone = secs.filter((x) => finNum(x.amount) > 0).every((x) => x.done) && secs.some((x) => finNum(x.amount) > 0);
          return (
            <div key={b.id} style={finS.bookCard}>
              <button style={finS.bookHead} onClick={() => setOpen((o) => ({ ...o, [b.id]: !o[b.id] }))}>
                <span style={{ ...finS.dot, background: allDone ? "#16a34a" : "var(--accent)" }} />
                <div style={{ flex: 1, textAlign: "right" }}>
                  <div style={finS.bookName}>{b.name}</div>
                  <div style={finS.bookMeta}>{b._pname} · الإجمالي: {finFmt(bookTotal)}</div>
                </div>
                <span style={finS.chev}>{isOpen ? "▲" : "▼"}</span>
              </button>
              {isOpen && (
                <>
                  <div style={finS.boxGrid}>
                    {secs.map((sec) => renderBox(b, sec))}
                  </div>
                  <button style={finS.addSection} onClick={() => addSec(b)}><Plus size={16} /> إضافة قسم</button>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
const AR_DAYS = ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"];
const AGENDA_TYPES = ["تسليم", "موعد", "دفعة", "اجتماع", "معرض", "أخرى"];
const AGENDA_COLORS = { "تسليم": "#0a84ff", "موعد": "var(--accent)", "دفعة": "#16a34a", "اجتماع": "#bf5af2", "معرض": "var(--accent)", "أخرى": "#64748b", "مالي": "#16a34a" };
const BOOK_FAIRS = [
  { name: "معرض القاهرة الدولي للكتاب", city: "القاهرة، مصر", date: "2027-01-21", approx: true },
  { name: "معرض مسقط الدولي للكتاب", city: "مسقط، عُمان", date: "2027-02-20", approx: true },
  { name: "معرض لندن للكتاب", city: "لندن، بريطانيا", date: "2027-03-16", approx: true },
  { name: "معرض بولونيا لكتاب الطفل", city: "بولونيا، إيطاليا", date: "2027-03-29", approx: true },
  { name: "معرض باريس للكتاب", city: "باريس، فرنسا", date: "2027-04-09", approx: true },
  { name: "معرض أبوظبي الدولي للكتاب", city: "أبوظبي، الإمارات", date: "2027-04-26", approx: true },
  { name: "معرض الدوحة الدولي للكتاب", city: "الدوحة، قطر", date: "2027-05-06", approx: true },
  { name: "معرض بكين الدولي للكتاب", city: "بكين، الصين", date: "2026-06-17", approx: true },
  { name: "معرض الرياض الدولي للكتاب", city: "الرياض، السعودية", date: "2026-10-01", approx: true },
  { name: "معرض فرانكفورت للكتاب", city: "فرانكفورت، ألمانيا", date: "2026-10-07", approx: false },
  { name: "معرض الشارقة الدولي للكتاب", city: "الشارقة، الإمارات", date: "2026-11-04", approx: false },
  { name: "معرض الكويت الدولي للكتاب", city: "الكويت", date: "2026-11-18", approx: false },
  { name: "معرض غوادالاخارا للكتاب (FIL)", city: "غوادالاخارا، المكسيك", date: "2026-11-28", approx: true },
  { name: "معرض جدة للكتاب", city: "جدة، السعودية", date: "2026-12-10", approx: true },
];
const pad2 = (n) => (n < 10 ? "0" + n : "" + n);
const toISO = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
const fmtISO = (iso) => { const [y, m, dd] = iso.split("-"); return `${dd}/${m}/${y}`; };

function Agenda({ events, publishers, onAdd, onUpdate, onDelete, onBack, fairs, onSaveFair, onAddFair, onRemoveFair, onFairToAgenda }) {
  const today = new Date();
  const todayISO = toISO(today);
  const [vy, setVy] = useState(today.getFullYear());
  const [vm, setVm] = useState(today.getMonth());
  const [view, setView] = useState("month");
  const [sel, setSel] = useState(todayISO);
  const [form, setForm] = useState(null); // {id?, date, title, type, note}
  const [fNm, setFNm] = useState(""); const [fCt, setFCt] = useState(""); const [fDt, setFDt] = useState("");
  const arNum = (n) => String(n).replace(/[0-9]/g, (d) => "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669"[d]);
  const fairsSorted = (fairs || []).slice().sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
  const fmtFair = (iso) => { try { return new Date(iso + "T00:00:00").toLocaleDateString("ar-u-nu-latn", { day: "numeric", month: "long", year: "numeric" }); } catch { return iso; } };

  // أحداث تلقائية من تواريخ الأقسام المالية لكل الكتب
  const autoEvents = [];
  (publishers || []).forEach((p) => (p.projects || []).forEach((j) => (j.works || []).forEach((w) => {
    if ((w.status || "active") !== "active") return;
    finSections(w, w.finance).forEach((s) => {
      if (s.date) autoEvents.push({ id: "fin-" + w.id + "-" + s.id, date: s.date, title: `${s.name} - ${w.name}`, type: "مالي", amount: s.amount, auto: true });
    });
  })));
  const manual = events || [];
  const all = [...autoEvents, ...manual];
  const byDate = {};
  all.forEach((e) => { (byDate[e.date] = byDate[e.date] || []).push(e); });

  const isoOf = (dt) => dt.getFullYear() + "-" + pad2(dt.getMonth() + 1) + "-" + pad2(dt.getDate());
  const first = new Date(vy, vm, 1);
  const startDow = first.getDay();
  const dim = new Date(vy, vm + 1, 0).getDate();
  let cells = [];
  if (view === "week") {
    const selD = new Date((sel || todayISO) + "T00:00:00");
    const ws = new Date(selD); ws.setDate(selD.getDate() - selD.getDay());
    for (let i = 0; i < 7; i++) { const d = new Date(ws); d.setDate(ws.getDate() + i); cells.push(isoOf(d)); }
  } else {
    for (let i = 0; i < startDow; i++) cells.push(null);
    for (let d = 1; d <= dim; d++) cells.push(isoOf(new Date(vy, vm, d)));
    while (cells.length % 7 !== 0) cells.push(null);
  }

  const prev = () => {
    if (view === "week") { const d = new Date((sel || todayISO) + "T00:00:00"); d.setDate(d.getDate() - 7); setSel(isoOf(d)); setVy(d.getFullYear()); setVm(d.getMonth()); }
    else { if (vm === 0) { setVy(vy - 1); setVm(11); } else setVm(vm - 1); }
  };
  const next = () => {
    if (view === "week") { const d = new Date((sel || todayISO) + "T00:00:00"); d.setDate(d.getDate() + 7); setSel(isoOf(d)); setVy(d.getFullYear()); setVm(d.getMonth()); }
    else { if (vm === 11) { setVy(vy + 1); setVm(0); } else setVm(vm + 1); }
  };
  const goToday = () => { setVy(today.getFullYear()); setVm(today.getMonth()); setSel(todayISO); setView("month"); };
  const yearData = Array.from({ length: 12 }, (_, m) => { let c = 0; for (const k in byDate) { if (k.slice(0, 4) === String(vy) && Number(k.slice(5, 7)) - 1 === m) c += (byDate[k] || []).length; } return { m, count: c }; });

  const selList = (byDate[sel] || []).slice().sort((a, b) => (a.auto === b.auto ? 0 : a.auto ? 1 : -1));
  const upcoming = all.filter((e) => e.date >= todayISO).sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0)).slice(0, 8);

  const hoursTo = (iso) => { try { return (new Date(iso + "T00:00:00").getTime() - today.getTime()) / 3600000; } catch { return 9999; } };
  const isSoon = (iso) => { const h = hoursTo(iso); return h >= -24 && h <= 48; };
  const fmtDay = (iso) => { try { return new Date(iso + "T00:00:00").toLocaleDateString("ar-u-nu-latn", { weekday: "short", day: "numeric", month: "short" }); } catch { return iso; } };

  const colorOf = (t) => AGENDA_COLORS[t] || "var(--accent)";
  const openAdd = (dateISO) => setForm({ date: dateISO || sel, title: "", type: "موعد", note: "" });
  const openEdit = (e) => { if (e.auto) return; setForm({ id: e.id, date: e.date, title: e.title, type: e.type, note: e.note || "", __ce: e.__ce, __by: e.__by, __own: e.__own, __src: e.__src }); };
  const saveForm = () => {
    if (!form.title.trim()) return;
    if (form.id) onUpdate(form.id, { date: form.date, title: form.title.trim(), type: form.type, note: form.note });
    else onAdd({ date: form.date, title: form.title.trim(), type: form.type, note: form.note });
    setForm(null);
  };

  const selPretty = (() => { try { return new Date(sel + "T00:00:00").toLocaleDateString("ar-u-nu-latn", { weekday: "long", day: "numeric", month: "long", year: "numeric" }); } catch { return sel; } })();

  const aS = {
    head: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 18, flexWrap: "wrap" },
    hTitle: { display: "flex", alignItems: "center", gap: 12 },
    nav: { display: "flex", alignItems: "center", justifyContent: "center", gap: 16, margin: "0 0 16px" },
    navBtn: { width: 38, height: 38, borderRadius: 0, border: "1px solid var(--line)", background: "color-mix(in srgb, var(--surface) 70%, transparent)", color: "var(--text)", fontSize: 18, cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center" },
    monthLbl: { fontFamily: mono, fontWeight: 800, fontSize: 20, color: "var(--text)", minWidth: 190, textAlign: "center", direction: "rtl", letterSpacing: ".02em" },
    wrap: { position: "relative", background: "var(--surface)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", borderRadius: 0, padding: 18, marginBottom: 18, overflow: "hidden" },
    dow: { display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 8, marginBottom: 8, position: "relative", zIndex: 1 },
    dowCell: { textAlign: "center", fontFamily: arab, fontWeight: 700, fontSize: 13, color: "var(--faint)", padding: "4px 0" },
    grid: { display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 8, position: "relative", zIndex: 1 },
    day: { position: "relative", minHeight: 78, borderRadius: 0, border: "1px solid var(--line)", background: "var(--surface)", padding: "7px 8px", cursor: "pointer", overflow: "hidden", display: "flex", flexDirection: "column", gap: 4 },
    dayNum: { fontFamily: mono, fontSize: 15, fontWeight: 800, color: "var(--text)", direction: "ltr", alignSelf: "flex-start", lineHeight: 1 },
    chip: { fontFamily: arab, fontSize: 11, fontWeight: 700, color: "#fff", borderRadius: 0, padding: "1px 6px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: 1.7, cursor: "pointer" },
    more: { fontFamily: mono, fontSize: 11, color: "var(--faint)", direction: "rtl" },
    panels: { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 14, marginBottom: 18 },
    panel: { position: "relative", background: "var(--surface)", backdropFilter: "blur(8px)", borderRadius: 0, padding: 18 },
    pTitle: { fontFamily: arab, fontWeight: 800, fontSize: 15, color: "var(--text)", marginBottom: 14, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, position: "relative", zIndex: 1 },
    evRow: { position: "relative", display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 0, background: "var(--surface)", border: "1px solid var(--line)", marginBottom: 8 },
    evDot: { width: 9, height: 9, borderRadius: "50%", flexShrink: 0 },
    evBody: { flex: 1, minWidth: 0 },
    evTitle: { fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    evMeta: { fontFamily: mono, fontSize: 12, color: "var(--faint)", direction: "rtl", marginTop: 1 },
    emptyHint: { fontFamily: arab, fontSize: 13, color: "var(--faint)", textAlign: "center", padding: "18px 8px" },
    iconBtn: { padding: 5, borderRadius: 0, border: "1px solid var(--line)", background: "var(--surface)", cursor: "pointer", color: "var(--muted)", display: "inline-flex" },
    addBtn: { display: "inline-flex", alignItems: "center", gap: 6, fontFamily: arab, fontSize: 14, fontWeight: 800, color: "#fff", background: "var(--accent)", border: "none", borderRadius: 0, padding: "9px 14px", cursor: "pointer" },
    formBg: { position: "fixed", inset: 0, background: "rgba(8,12,24,0.55)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)", animation: "tmFadeIn .18s ease both", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9600, padding: 20 },
    formCard: { width: "100%", maxWidth: 440, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 0, animation: "agcPop .2s ease both", padding: 20, boxShadow: "0 24px 70px rgba(0,0,0,0.35)" },
    label: { fontFamily: arab, fontWeight: 700, fontSize: 13, color: "var(--muted)", display: "block", margin: "10px 0 5px" },
    input: { width: "100%", fontFamily: arab, fontSize: 15, color: "var(--text)", background: "color-mix(in srgb, var(--surface) 80%, transparent)", border: "1px solid var(--line)", borderRadius: 0, padding: "9px 12px" },
    typeRow: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(72px, 1fr))", gap: 7 },
    typeBtn: (on, c) => ({ fontFamily: arab, fontSize: 13, fontWeight: 700, padding: "6px 12px", borderRadius: 0, cursor: "pointer", border: "1px solid " + (on ? c : "var(--line)"), background: on ? c : "transparent", color: on ? "#fff" : "var(--text)" }),
  };

  return (
    <div style={S.page} className="fade-in">
      <style>{`
        .agc-dotbg{position:absolute;inset:0;z-index:0;background-image:radial-gradient(circle, color-mix(in srgb,var(--lineHi) 60%,transparent) 1px, transparent 1.4px);background-size:22px 22px;opacity:.5;pointer-events:none;}
        .agc-glowedge{position:absolute;inset:0;z-index:0;pointer-events:none;background:radial-gradient(120% 60% at 50% -10%, color-mix(in srgb,var(--accent) 14%,transparent), transparent 70%);}
        .agc-day{transition:transform .15s ease, box-shadow .15s ease, background .15s ease, border-color .15s ease;}
        .agc-day:hover{transform:translateY(-3px);box-shadow:0 8px 22px rgba(27,36,64,.16);background:color-mix(in srgb,var(--accent) 9%,transparent);border-color:var(--accent);}
        .agc-sel{border-color:var(--accent)!important;box-shadow:inset 0 0 0 2px var(--accent);}
        .agc-today .agc-dn{background:var(--accent);color:#fff;border-radius:8px;padding:1px 7px;}
        .agc-today{animation:agcGlow 2.4s ease-in-out infinite;}
        @keyframes agcGlow{0%,100%{box-shadow:0 0 0 0 color-mix(in srgb,var(--accent) 0%,transparent);}50%{box-shadow:0 0 0 5px color-mix(in srgb,var(--accent) 30%,transparent);}}
        @keyframes agcPop{from{opacity:0;transform:translateY(10px) scale(.97);}to{opacity:1;transform:none;}}
        @keyframes agcMonth{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:none;}}
        @keyframes agcSoon{0%,100%{box-shadow:0 0 0 0 rgba(226,61,61,0);}50%{box-shadow:0 0 0 3px rgba(226,61,61,.35);}}
        .agc-grid{animation:agcMonth .28s ease both;}
        .agc-chip{animation:agcPop .22s ease both;}
        .agc-soon{animation:agcSoon 1.8s ease-in-out infinite;border-color:#e23d3d !important;}
        .agc-soondot{width:7px;height:7px;border-radius:50%;background:#e23d3d;flex-shrink:0;animation:agcSoon 1.8s ease-in-out infinite;}
      `}</style>
      <div style={S.topbar}>
        <button style={S.exportBtn} className="ghost" onClick={onBack}><ChevronRight size={16} /> رجوع</button>
        <span style={{ width: 60 }} />
      </div>
      <div style={S.body}>
        <div style={aS.head}>
          <div style={aS.hTitle}>
            <span style={{ ...S.crumbIcon, color: "var(--accent)" }}><CalendarDays size={22} color={"var(--accent)"} /></span>
            <h2 style={S.sectionTitle}>الأجندة</h2>
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <div style={{ display: "inline-flex" }}>
              {[["week", "أسبوع"], ["month", "شهر"], ["year", "سنة"]].map(([v, lbl]) => (
                <button key={v} onClick={() => setView(v)} style={{ fontFamily: arab, fontSize: 13, fontWeight: 800, padding: "7px 13px", border: "1px solid var(--line)", background: view === v ? "var(--accent)" : "transparent", color: view === v ? "#fff" : "var(--text)", cursor: "pointer" }}>{lbl}</button>
              ))}
            </div>
            <button className="ghost" style={S.exportBtn} onClick={goToday}>اليوم</button>
            {window.__agMe && window.__agMe.role === "admin" && (
              <button className="ghost" style={S.exportBtn} onClick={() => { try { window.dispatchEvent(new CustomEvent("tpms:agenda-control")); } catch {} }}>تحكم بأجندات الأعضاء</button>
            )}
            <button style={aS.addBtn} onClick={() => openAdd(sel)}><Plus size={16} /> حدث جديد</button>
          </div>
        </div>

        <div style={aS.nav}>
          <button style={aS.navBtn} onClick={next}>›</button>
          <span style={aS.monthLbl}>{view === "week" ? (cells[0] && cells[6] ? (Number(cells[0].slice(8, 10)) + " " + AR_MONTHS[Number(cells[0].slice(5, 7)) - 1] + " - " + Number(cells[6].slice(8, 10)) + " " + AR_MONTHS[Number(cells[6].slice(5, 7)) - 1] + " " + String(vy)) : "") : (AR_MONTHS[vm] + " " + String(vy))}</span>
          <button style={aS.navBtn} onClick={prev}>‹</button>
        </div>

        <div style={aS.wrap}>
          <div className="agc-dotbg" />
          <div className="agc-glowedge" />
          <CardBorder radius={0} />
          {view === "year" && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(148px, 1fr))", gap: 10, position: "relative", zIndex: 1 }}>
              {yearData.map(({ m, count }) => (
                <button key={m} onClick={() => { setVm(m); setView("month"); }} style={{ padding: "18px 12px", border: "1px solid var(--line)", background: (m === today.getMonth() && vy === today.getFullYear()) ? "color-mix(in srgb, var(--accent) 14%, transparent)" : "var(--surface)", cursor: "pointer", display: "flex", flexDirection: "column", gap: 6, alignItems: "center" }}>
                  <span style={{ fontFamily: arab, fontWeight: 800, fontSize: 15, color: "var(--text)" }}>{AR_MONTHS[m]}</span>
                  <span style={{ fontFamily: mono, fontSize: 12.5, fontWeight: 700, color: count ? "var(--accent)" : "var(--faint)" }}>{count ? (String(count) + " حدث") : "-"}</span>
                </button>
              ))}
            </div>
          )}
          {view !== "year" && (<><div style={aS.dow}>{AR_DAYS.map((d) => <div key={d} style={aS.dowCell}>{d}</div>)}</div>
          <div style={aS.grid} className="agc-grid" key={vy + "-" + vm}>
            {cells.map((iso, i) => {
              if (iso === null) return <div key={"b" + i} />;
              const evs = byDate[iso] || [];
              const cls = "agc-day" + (iso === todayISO ? " agc-today" : "") + (iso === sel ? " agc-sel" : "");
              return (
                <div key={iso} className={cls} style={aS.day} onClick={() => setSel(iso)} onDoubleClick={() => openAdd(iso)}>
                  <span className="agc-dn" style={aS.dayNum}>{String(Number(iso.slice(8, 10)))}</span>
                  {evs.slice(0, 3).map((e, ci) => (
                    <span key={e.id} className="agc-chip" style={{ ...aS.chip, background: (e.__src === "owner" || e.__src === "pm") ? "#dc2626" : colorOf(e.type), color: (e.__src === "owner" || e.__src === "pm") ? "#fff" : undefined, animationDelay: `${ci * 60}ms` }} onClick={(ev) => { ev.stopPropagation(); openEdit(e); }}>{(window.__agMe && window.__agMe.role === "admin" && e.__own) ? e.title + " - " + e.__own : e.title}</span>
                  ))}
                  {evs.length > 3 && <span style={aS.more}>+{String(evs.length - 3)}</span>}
                </div>
              );
            })}
          </div></>)}
        </div>

        <div style={aS.panels}>
          <div style={aS.panel}>
            <div className="agc-dotbg" />
            <CardBorder radius={0} />
            <div style={aS.pTitle}><span>{selPretty}</span><CalendarDays size={17} color={"var(--accent)"} /></div>
            <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: 8, maxHeight: 320, overflowY: "auto" }}>
              {selList.length === 0 ? <div style={aS.emptyHint}>لا أحداث في هذا اليوم. انقر مرّتين على يوم لإضافة حدث.</div> :
               selList.map((e, i) => (
                <div key={e.id} className="agc-chip" style={{ ...aS.evRow, animationDelay: `${i * 50}ms`, cursor: e.auto ? "default" : "pointer" }} onClick={() => openEdit(e)}>
                  <span style={{ ...aS.evDot, background: colorOf(e.type) }} />
                  <div style={aS.evBody}>
                    <div style={aS.evTitle}>{e.title}</div>
                    <div style={aS.evMeta}>{e.type}{e.amount ? " · " + String(e.amount) : ""}{e.auto ? " · تلقائي" : ""}</div>
                  </div>
                  {isSoon(e.date) && <span className="agc-soondot" />}
                </div>
              ))}
            </div>
          </div>

          <div style={aS.panel}>
            <div className="agc-dotbg" />
            <CardBorder radius={0} />
            <div style={aS.pTitle}><span>القادمة</span><span style={{ fontFamily: mono, fontSize: 12, color: "var(--faint)", direction: "rtl" }}>{String(upcoming.length)}</span></div>
            <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: 8, maxHeight: 320, overflowY: "auto" }}>
              {upcoming.length === 0 ? <div style={aS.emptyHint}>لا مواعيد قادمة.</div> :
               upcoming.map((e, i) => (
                <div key={e.id} className={"agc-chip" + (isSoon(e.date) ? " agc-soon" : "")} style={{ ...aS.evRow, animationDelay: `${i * 50}ms`, cursor: e.auto ? "default" : "pointer" }} onClick={() => { setSel(e.date); if (!e.auto) openEdit(e); }}>
                  <span style={{ ...aS.evDot, background: colorOf(e.type) }} />
                  <div style={aS.evBody}>
                    <div style={aS.evTitle}>{e.title}</div>
                    <div style={aS.evMeta}>{fmtDay(e.date)}{e.auto ? " · تلقائي" : ""}</div>
                  </div>
                  {isSoon(e.date) && <span className="agc-soondot" />}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ ...aS.panel, marginTop: 0 }}>
          <div className="agc-dotbg" />
          <CardBorder radius={0} />
          <div style={aS.pTitle}><span>معارض الكتب</span><Globe size={18} color={"var(--accent)"} /></div>
          <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: 9, maxHeight: 360, overflowY: "auto", paddingLeft: 2 }}>
            {fairsSorted.map((f) => (
              <div key={f.id} style={fr.row}>
                <div style={{ flex: "1 1 auto", minWidth: 0 }}>
                  <div style={fr.name}>{f.approx ? "~ " : ""}{f.name}</div>
                  <div style={fr.city}>{f.city} · {fmtFair(f.date)}</div>
                </div>
                <input type="date" value={f.date} onChange={(e) => onSaveFair(f.id, { date: e.target.value })} style={fr.date} />
                <button style={fr.add} onClick={() => onFairToAgenda(f)}>أضف للأجندة</button>
                <button style={fr.del} className="ghost" onClick={() => onRemoveFair(f.id)}><X size={16} /></button>
              </div>
            ))}
          </div>
          <div style={fr.addBox}>
            <div style={{ fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)", marginBottom: 9 }}>إضافة معرض جديد</div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
              <input style={{ ...S.input, flex: "2 1 170px", marginBottom: 0 }} placeholder="اسم المعرض" value={fNm} onChange={(e) => setFNm(e.target.value)} />
              <input style={{ ...S.input, flex: "1 1 130px", marginBottom: 0 }} placeholder="المدينة، الدولة" value={fCt} onChange={(e) => setFCt(e.target.value)} />
              <input type="date" style={{ ...S.input, flex: "0 0 150px", marginBottom: 0, colorScheme: "light" }} value={fDt} onChange={(e) => setFDt(e.target.value)} />
              <button style={{ ...S.saveBtn, opacity: (fNm.trim() && fDt) ? 1 : .5, pointerEvents: (fNm.trim() && fDt) ? "auto" : "none" }} onClick={() => { onAddFair({ name: fNm.trim(), city: fCt.trim(), date: fDt }); setFNm(""); setFCt(""); setFDt(""); }}><Plus size={16} />إضافة</button>
            </div>
          </div>
        </div>
      </div>

      {form && (
        <div className="u4-bg" style={aS.formBg} onClick={(e) => { if (e.target === e.currentTarget) setForm(null); }}>
          <div className="u4 u4-win" style={{ ...aS.formCard, position: "relative", borderTop: "3px solid " + AGENDA_COLORS[form.type], transition: "border-color .35s ease" }}>
            <div style={{ position: "absolute", top: 0, insetInlineStart: 0, insetInlineEnd: 0, height: 96, background: "radial-gradient(135% 100% at 50% 0%, " + AGENDA_COLORS[form.type] + "2b, transparent 72%)", pointerEvents: "none", transition: "background .35s ease" }} />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
              <div className="u4-title" style={{ margin: 0 }}>{form.__ce === false ? "تفاصيل الحدث" : form.id ? "تعديل حدث" : "حدث جديد"}</div>
              <button onClick={() => setForm(null)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--muted)", display: "inline-flex", padding: 4 }}><X size={20} /></button>
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 12 }}>
              <div style={{ flex: 1, minWidth: 150 }}>
                <label className="u4-lbl" style={aS.label}>العنوان</label>
                <input autoFocus value={form.title} readOnly={form.__ce === false} onChange={(e) => setForm({ ...form, title: e.target.value })} className="u4-in" style={aS.input} placeholder="مثال: تسليم المسودة" />
              </div>
              <div>
                <label className="u4-lbl" style={aS.label}>التاريخ</label>
                <input type="date" lang="en-GB" value={form.date} readOnly={form.__ce === false} onChange={(e) => setForm({ ...form, date: e.target.value })} className="u4-in" style={{ ...aS.input, direction: "ltr", width: 148 }} />
              </div>
              <div>
                <label className="u4-lbl" style={aS.label}>النوع</label>
                {form.__ce === false ? <div style={{ fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)", padding: "10px 12px", borderInlineStart: "4px solid " + AGENDA_COLORS[form.type], background: "color-mix(in srgb, var(--surface) 80%, transparent)" }}>{form.type}</div> : <TmSelect value={form.type} options={AGENDA_TYPES} onChange={(v) => setForm({ ...form, type: v })} style={{ width: "100%", borderInlineStart: "4px solid " + AGENDA_COLORS[form.type] }} />}
              </div>
              <div style={{ flex: "1 1 180px", minWidth: 0 }}>
                <label className="u4-lbl" style={aS.label}>التفاصيل</label>
                <textarea value={form.note} readOnly={form.__ce === false} onChange={(e) => setForm({ ...form, note: e.target.value })} rows={2} className="u4-in" style={{ ...aS.input, resize: "vertical", width: "100%" }} />
              </div>
            </div>
            {form.__ce === false && (
              <div style={{ marginTop: 12, fontSize: 13, fontWeight: 800, color: "var(--accent)", border: "1px dashed var(--accent)", padding: "8px 12px", textAlign: "center" }}>
                أضافه {form.__by || "الإدارة"} - للاطلاع فقط
              </div>
            )}
            {form.__ce !== false && (
              <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
                <button style={{ ...aS.addBtn, flex: 1, justifyContent: "center" }} onClick={saveForm}><Check size={13} /> حفظ</button>
                {form.id && <button className="ghost" style={{ ...aS.iconBtn, padding: "9px 14px", color: "#e23d3d", borderColor: "#e23d3d55" }} onClick={() => { onDelete(form.id); setForm(null); }}><Trash2 size={16} /></button>}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function Works({ publisher, project, share, groupBy, editMode, onToggleEdit, onSettings, onTrash, onRestore, onDeleteForever, onOpenMenu, onOpenBook, onExport, onMarketing, onDeliveries, onFinance, onBack, onAdd }) {
  const col = publisher.color;
  const { readOnly: ro, me , isManager } = useAuth();
  const allWorks = project.works || [];
  const _ab = me?.assignedBooks;
  const works = allWorks.filter((w) => (w.status || "active") === "active" && (!ro || _ab === "all" || (Array.isArray(_ab) && _ab.includes(w.id))));
  const archived = allWorks.filter((w) => w.status === "archived");
  const trashed = allWorks.filter((w) => w.status === "trashed");
  const lp = useLongPress(onOpenBook, onOpenMenu);

  const activeView = VIEWS.find((v) => v.key === groupBy);
  const coverView = groupBy === "cover";

  const BookCard = (w, i) => (
    <div key={w.id} className="pm-card" style={{ ...S.card, animationDelay: `${i * 60}ms`, ...(bookIcon(w) ? { aspectRatio: "2 / 3", padding: 0, overflow: "hidden" } : {}) }}
      onMouseDown={() => lp.start(w)} onMouseUp={lp.cancel} onMouseLeave={lp.cancel}
      onTouchStart={() => lp.start(w)} onTouchEnd={lp.cancel}
      onClick={() => lp.click(w)} onDoubleClick={() => onOpenMenu(w)}
      onContextMenu={(e) => { e.preventDefault(); onOpenMenu(w); }}
      >
      <CardBorder dot={w.dotColor} />
      {editMode && <button className="btn-del" style={S.del} onClick={(e) => { e.stopPropagation(); onTrash(w); }}></button>}
      {bookIcon(w) ? (
        <div style={{ position: "absolute", inset: 0, borderRadius: "inherit", overflow: "hidden" }}>
          <img src={bookIcon(w)} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
          {w.approvalStatus === "pending" && <div style={{ position: "absolute", top: 10, right: 10, background: "#f59e0bee", color: "#3b2604", borderRadius: 8, padding: "2px 10px", fontSize: 11.5, fontWeight: 800 }}>بانتظار الاعتماد</div>}
          <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "color-mix(in srgb, var(--surface) 78%, transparent)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", borderTop: `1.5px solid ${_activeTheme.accent}`, padding: "8px 12px 10px", textAlign: "center" }}>
            <div style={{ fontFamily: arab, fontWeight: 800, fontSize: 15.5, color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{w.name}</div>
            {(w.authorName || w.lang) && <div style={{ fontFamily: arab, fontSize: 12.5, color: "var(--muted)", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{[w.authorName, w.lang].filter(Boolean).join(" · ")}</div>}
          </div>
        </div>
      ) : (<>
      <div style={S.cardMeta}>
        {w.category && <span style={{ ...S.tag, color: "var(--accent)", borderColor: "var(--accent)" }}>{w.category}</span>}
      </div>
      <span className="pm-cardicon" style={{ ...S.cardIcon, color: _activeTheme.accent, boxShadow: `0 0 22px ${_activeTheme.accent}33` }}><ProjIcon img={bookIcon(w)} name={w.icon} size={40} color={_activeTheme.accent} /></span>
      <div style={S.cardName}>{w.name}</div>
      {w.approvalStatus === "pending" && <div style={{ background: "#f59e0b22", color: "#b45309", border: "1px solid #f59e0b66", borderRadius: 8, padding: "2px 10px", fontSize: 12, fontWeight: 700, display: "inline-block", margin: "4px auto" }}> بانتظار الاعتماد</div>}
      {w.lang && <div style={S.langLine}>{w.lang}</div>}
      {w.authorName && <div style={S.metaMini}><span>{w.authorName}</span></div>}
      </>)}
    </div>
  );

  const AddCard = (
    <div className="pm-card add-card" style={{ ...S.addCard, display: (useAuth().isManager || canAddBookHere(project && project.id, publisher && publisher.id)) ? undefined : "none" }} onClick={onAdd}>
      <span style={{ ...S.addCircle, borderColor: "var(--accent)" }}><Plus size={22} color={"var(--accent)"} /></span>
      <div style={{ ...S.addText, color: "var(--accent)" }}>إضافة كتاب</div>
    </div>
  );

  // تجميع
  let groups = null;
  if (activeView && activeView.field) {
    const map = {};
    works.forEach((w) => {
      const key = (w[activeView.field] || "").trim() || "غير محدد";
      (map[key] = map[key] || []).push(w);
    });
    groups = Object.keys(map).sort((a, b) => a.localeCompare(b, "ar")).map((k) => [k, map[k]]);
  }

  return (
    <div style={S.page} className="fade-in">
      <div style={S.body}>
        <div style={{ ...S.sectionHead, justifyContent: "center", position: "relative" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <h2 style={S.sectionTitle}>{project.name}</h2>
          </div>
          <div style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 10 }}>
            <NavBtns onBack={onBack} backLabel="المشاريع" onSettings={onSettings} />
          </div>
        </div>

        {!groups && !coverView && (
          <div style={S.grid}>
            {works.map((w, i) => BookCard(w, i))}
            {AddCard}
          </div>
        )}

        {coverView && (
          <div style={S.coverProGrid}>
            {works.map((w, i) => {
              const hasImg = w.coverFr && (w.coverFr.type || "").startsWith("image");
              return (
                <div key={w.id} className="pm-card cover-pro" style={{ ...S.coverProCard, animationDelay: `${i * 60}ms` }}
                  onMouseDown={() => lp.start(w)} onMouseUp={lp.cancel} onMouseLeave={lp.cancel}
                  onTouchStart={() => lp.start(w)} onTouchEnd={lp.cancel}
                  onClick={() => lp.click(w)} onDoubleClick={() => onOpenMenu(w)}
                  onContextMenu={(e) => { e.preventDefault(); onOpenMenu(w); }}
                  >
                  {editMode && <button className="btn-del" style={{ ...S.del, zIndex: 4 }} onClick={(e) => { e.stopPropagation(); onTrash(w); }}></button>}
                  <div style={S.coverProImgWrap}>
                    {hasImg ? (
                      <>
                        <BookImg file={w.coverFr} alt="" aria-hidden="true" style={S.coverProBg} />
                        <BookImg file={w.coverFr} alt={w.name} style={S.coverProImg} />
                      </>
                    ) : (
                      <div style={S.coverProEmpty}><Icon name={w.icon} size={40} color={"var(--accent)"} /><span style={S.coverNoImg}>لا غلاف مترجم</span></div>
                    )}
                    <div style={S.coverProOverlay}>
                      {w.authorName && <div style={S.coverProAuthor}>{w.authorName}</div>}
                      <div style={S.coverProLang}>إلى {w.lang}</div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="pm-card add-card" style={{ ...S.addCard, minHeight: 300, display: (isManager || canAddBookHere(project && project.id, publisher && publisher.id)) ? undefined : "none" }} onClick={onAdd}>
              <span style={{ ...S.addCircle, borderColor: "var(--accent)" }}><Plus size={22} color={"var(--accent)"} /></span>
              <div style={{ ...S.addText, color: "var(--accent)" }}>إضافة كتاب</div>
            </div>
          </div>
        )}

        {groups && (
          <>
            {groups.map(([value, items]) => (
              <div key={value} style={{ marginBottom: 22 }} className="fade-in">
                <div style={S.grid}>{items.map((w, i) => BookCard(w, i))}</div>
              </div>
            ))}
            <div style={S.grid}>{AddCard}</div>
          </>
        )}

        {archived.length > 0 && (
          <BinSection icon={<Archive size={18} color={"var(--muted)"} />} count={archived.length}
            items={archived} col={col}
            actions={(w) => (
              <>
                <MiniBtn onClick={() => onRestore(w)} label="استعادة"><RotateCcw size={14} /></MiniBtn>
                <MiniBtn onClick={() => onTrash(w)} label="نقل للسلة"><Trash2 size={14} /></MiniBtn>
              </>
            )}
          />
        )}

        {trashed.length > 0 && (
          <BinSection icon={<Trash2 size={18} color={"var(--muted)"} />} count={trashed.length}
            note="لا يُحذف شيء تلقائيًا - الحذف النهائي يدويّ فقط."
            items={trashed} col={col} danger
            actions={(w) => (
              <>
                <MiniBtn onClick={() => onRestore(w)} label="استعادة"><RotateCcw size={14} /></MiniBtn>
                <MiniBtn onClick={() => onDeleteForever(w)} label="حذف نهائي" danger><X size={14} /></MiniBtn>
              </>
            )}
          />
        )}
      </div>
    </div>
  );
}

/* --------------------- نافذة خيارات المشروع (نقرة مزدوجة) --------------------- */
function ProjectActionModal({ project, color, onArchive, onTrash, onSetIcon, onEdit, onClose }) {
  const [stage, setStage] = useState("menu"); // menu | archive | delete | icon
  const covers = (project.works || []).filter((w) => w.coverFr && (w.coverFr.type || "").startsWith("image"));
  const pickImg = (e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = () => onSetIcon(r.result); r.readAsDataURL(f); e.target.value = ""; };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}>
        <h3 style={S.modalTitle}>{project.name}</h3>
        <CloseBtn onClose={onClose} />
      </div>
      <div style={{ ...S.card, ...S.preview }}>
        <CardBorder dot={project.dotColor} />
        <div style={S.cardMeta}>{project.category && <span style={{ ...S.tag, color, borderColor: "var(--accent)" }}>{project.category}</span>}</div>
        <span className="pm-cardicon" style={{ ...S.cardIcon, color, boxShadow: `0 0 22px ${color}33` }}><ProjIcon img={project.iconImg} name={project.icon} size={40} color={"var(--accent)"} /></span>
        <div style={S.cardName}>{project.name}</div>
        <div style={S.dateRow}><Calendar size={14} color={"var(--muted)"} /><span>{fmtDate(project.date)}</span></div>
      </div>

      {stage === "menu" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <button className="opt-btn" style={S.optBtn} onClick={() => onEdit && onEdit(project)}>
            <ImageIcon size={18} color={"var(--accent)"} /><span>تعديل المشروع</span>
          </button>
          <button className="opt-btn" style={S.optBtn} onClick={() => setStage("icon")}>
            <ImageIcon size={18} color={"var(--accent)"} /><span>تغيير أيقونة المشروع</span>
          </button>
          <button className="opt-btn" style={S.optBtn} onClick={() => setStage("archive")}>
            <Archive size={18} color={"var(--accent)"} /><span>أرشفة المشروع</span>
          </button>
          <button className="opt-btn opt-danger" style={{ ...S.optBtn, ...S.optDanger }} onClick={() => setStage("delete")}>
            <Trash2 size={18} color="#ff8585" /><span>حذف المشروع</span>
          </button>
        </div>
      )}

      {stage === "icon" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <label style={S.delUpload}><Upload size={14} /> رفع صورة أيقونة<input type="file" style={{ display: "none" }} onChange={pickImg} /></label>
            {project.iconImg && <button className="ghost" style={S.miniBtn} onClick={() => onSetIcon(null)}>إزالة الصورة</button>}
          </div>
          <div>
            <label style={S.label}>أو اختر غلافًا أجنبيًا لأحد الكتب</label>
            {covers.length === 0 ? (
              <div style={S.emptyHint}>لا أغلفة أجنبية (صور) في كتب هذا المشروع بعد.</div>
            ) : (
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                {covers.map((w) => (
                  <button key={w.id} className="ghost" style={{ ...S.coverPick, ...(project.iconImg === w.coverFr.data ? { borderColor: "var(--accent)" } : {}) }} onClick={() => onSetIcon(w.coverFr.data)}>
                    <BookImg file={w.coverFr} alt="" style={{ width: 54, height: 72, objectFit: "cover", borderRadius: 6, display: "block" }} />
                  </button>
                ))}
              </div>
            )}
          </div>
          <button className="ghost" style={S.miniBtn} onClick={() => setStage("menu")}>رجوع</button>
        </div>
      )}



      {stage === "archive" && (
        <ConfirmBlock
          text={<>هل تريد أرشفة المشروع <b style={{ color: "var(--text)" }}>«{project.name}»</b>؟ سيُنقل إلى قسم الأرشيف أسفل الصفحة، ويمكن استعادته في أي وقت.</>}
          confirmLabel="تأكيد الأرشفة" onBack={() => setStage("menu")} onConfirm={() => onArchive(project)}
        />
      )}

      {stage === "delete" && (
        <ConfirmBlock danger
          text={<>سيُنقل المشروع <b style={{ color: "var(--text)" }}>«{project.name}»</b> إلى سلة المهملات. لا يُحذف نهائيًا إلا يدويًا من السلة.</>}
          confirmLabel="تأكيد الحذف" onBack={() => setStage("menu")} onConfirm={() => onTrash(project)}
        />
      )}
    </Overlay>
  );
}

/* --------------------- نافذة خيارات الكتاب (نقرة مزدوجة) --------------------- */
function BookActionModal({ book, color, onArchive, onTrash, onClose }) {
  const [stage, setStage] = useState("menu");
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}>
        <h3 style={{ ...S.modalTitle, flex: 1, textAlign: "center" }}>{book.name}</h3>
        <CloseBtn onClose={onClose} />
      </div>
      <div style={{ ...S.card, ...S.preview }}>
        <CardBorder dot={book.dotColor} />
        <div style={S.cardMeta}>{book.category && <span style={{ ...S.tag, color, borderColor: "var(--accent)" }}>{book.category}</span>}</div>
        <span className="pm-cardicon" style={{ ...S.cardIcon, color, boxShadow: `0 0 22px ${color}33` }}><ProjIcon img={bookIcon(book)} name={book.icon} size={40} color={"var(--accent)"} /></span>
        <div style={S.cardName}>{book.name}</div>
        {book.lang && <div style={S.langLine}>إلى {book.lang}</div>}
        <div style={S.dateRow}><Calendar size={14} color={"var(--muted)"} /><span>{fmtDate(book.date)}</span></div>
      </div>
      {stage === "menu" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <button className="opt-btn" style={S.optBtn} onClick={() => setStage("archive")}>
            <Archive size={18} color={"var(--accent)"} /><span>أرشفة الكتاب</span>
          </button>
          <button className="opt-btn opt-danger" style={{ ...S.optBtn, ...S.optDanger }} onClick={() => setStage("delete")}>
            <Trash2 size={18} color="#ff8585" /><span>حذف الكتاب</span>
          </button>
        </div>
      )}
      {stage === "archive" && (
        <ConfirmBlock
          text={<>هل تريد أرشفة الكتاب <b style={{ color: "var(--text)" }}>«{book.name}»</b>؟ سيُنقل إلى أرشيف الكتب، ويمكن استعادته في أي وقت.</>}
          confirmLabel="تأكيد الأرشفة" onBack={() => setStage("menu")} onConfirm={() => onArchive(book)}
        />
      )}
      {stage === "delete" && (
        <ConfirmBlock danger
          text={<>سيُنقل الكتاب <b style={{ color: "var(--text)" }}>«{book.name}»</b> إلى سلة الكتب. لا يُحذف نهائيًا إلا يدويًا من السلة.</>}
          confirmLabel="تأكيد الحذف" onBack={() => setStage("menu")} onConfirm={() => onTrash(book)}
        />
      )}
    </Overlay>
  );
}

/* --------------------- نافذة خيارات الجهة (ضغطة مطوّلة) --------------------- */
function PublisherActionModal({ pub, onArchive, onTrash, onSetIcon, onEdit, onClose }) {
  const [stage, setStage] = useState("menu");
  const color = pub.color || "var(--accent)";
  const pickImg = (e) => {
    const f = e.target.files && e.target.files[0]; if (!f) return;
    const rd = new FileReader(); rd.onload = () => onSetIcon(rd.result); rd.readAsDataURL(f);
  };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}>
        <h3 style={S.modalTitle}>{pub.name}</h3>
        <CloseBtn onClose={onClose} />
      </div>
      <div style={{ ...S.card, ...S.preview }}>
        <CardBorder dot={pub.dotColor} />
        <div style={S.cardMeta}>{pub.tag && <span style={{ ...S.tag, color, borderColor: color }}>{pub.tag}</span>}</div>
        <span className="pm-cardicon" style={{ ...S.cardIcon, color, boxShadow: `0 0 22px ${color}33` }}><ProjIcon img={pub.iconImg} name={pub.icon} size={40} color={"var(--accent)"} /></span>
        <div style={S.cardName}>{pub.name}</div>
        {pub.note && <div style={S.cardNote}>{pub.note}</div>}
      </div>
      {stage === "menu" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <button className="opt-btn" style={S.optBtn} onClick={() => onEdit && onEdit(pub)}>
            <ImageIcon size={18} color={"var(--accent)"} /><span>تعديل الجهة</span>
          </button>
          <button className="opt-btn" style={S.optBtn} onClick={() => setStage("icon")}>
            <ImageIcon size={18} color={"var(--accent)"} /><span>تغيير الأيقونة</span>
          </button>
          <button className="opt-btn" style={S.optBtn} onClick={() => setStage("archive")}>
            <Archive size={18} color={"var(--accent)"} /><span>أرشفة الجهة</span>
          </button>
          <button className="opt-btn opt-danger" style={{ ...S.optBtn, ...S.optDanger }} onClick={() => setStage("delete")}>
            <Trash2 size={18} color="#ff8585" /><span>حذف الجهة</span>
          </button>
        </div>
      )}
      {stage === "icon" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <label style={S.delUpload}><Upload size={14} /> رفع صورة أيقونة<input type="file" accept="image/*" style={{ display: "none" }} onChange={pickImg} /></label>
            {pub.iconImg && <button className="ghost" style={S.miniBtn} onClick={() => onSetIcon(null)}>إزالة الصورة</button>}
          </div>
          <button className="ghost" style={S.miniBtn} onClick={() => setStage("menu")}>رجوع</button>
        </div>
      )}
      {stage === "archive" && (
        <ConfirmBlock
          text={<>هل تريد أرشفة الجهة <b style={{ color: "var(--text)" }}>«{pub.name}»</b>؟ ستُنقل إلى أرشيف الجهات، ويمكن استعادتها في أي وقت.</>}
          confirmLabel="تأكيد الأرشفة" onBack={() => setStage("menu")} onConfirm={() => onArchive(pub)}
        />
      )}
      {stage === "delete" && (
        <ConfirmBlock danger
          text={<>ستُنقل الجهة <b style={{ color: "var(--text)" }}>«{pub.name}»</b> بكل مشاريعها إلى سلة الجهات. لا تُحذف نهائيًا إلا يدويًا من السلة.</>}
          confirmLabel="تأكيد الحذف" onBack={() => setStage("menu")} onConfirm={() => onTrash(pub)}
        />
      )}
    </Overlay>
  );
}

function SettingsModal({ isAdminUser, isOwner, coverTitle, onSaveCoverTitle, appTitle, onSaveAppTitle, settings, onSave, editMode, onToggleEdit, share, onShare, onClose }) {
  const [mainTab, setMainTab] = useState("general");
  const auth = useAuth();
  const ro = auth.readOnly;
  const users = (auth.users && auth.users.length ? auth.users
    : (auth.members || []).map((m) => ({ id: m.id, fullName: m.full_name || m.email || "عضو", role: m.role })))
    .filter((u) => u.role !== "admin" && u.role !== "manager");
  const [topMsgs, setTopMsgs] = useState({});
  const [msgUser, setMsgUser] = useState("");
  const [msgText, setMsgText] = useState("");
  useEffect(() => { (async () => { try { if (typeof window !== "undefined" && window.storage) { const r = await window.storage.get("pm:topmsg"); if (r && r.value) setTopMsgs(JSON.parse(r.value) || {}); } } catch {} })(); }, []);
  const pickMsgUser = (id) => { setMsgUser(id); setMsgText((topMsgs && topMsgs[id]) || ""); };
  const saveTopMsg = async () => {
    const next = { ...topMsgs };
    if (msgText.trim()) next[msgUser] = msgText.trim(); else delete next[msgUser];
    setTopMsgs(next);
    let saved = null;
    try { if (typeof window !== "undefined" && window.storage) saved = await window.storage.set("pm:topmsg", JSON.stringify(next)); } catch (e) { saved = null; try { toast(" خطأ الحفظ: " + (e && e.message || e), "err"); } catch {} }
    if (!saved) { try { toast(" لم تُحفظ رسالة الشريط - انظر سطر [tpms] kvSet في الكونسول", "err"); } catch {} }
    try { window.dispatchEvent(new CustomEvent("pm:topmsg")); } catch {}
  };
  const [text, setText] = useState(settings.text);
  const [size, setSize] = useState(settings.size);
  const [theme, setTheme] = useState(settings.theme);
  const [rotate, setRotate] = useState(!!settings.rotate);
  const [bg, setBg] = useState(settings.bg || null);
  const [dark, setDark] = useState(!!settings.dark);
  const [cardBorder, setCardBorder] = useState(settings.cardBorder !== false);
  const [cardBg, setCardBg] = useState(settings.cardBg !== false);
  const [titleColor, setTitleColor] = useState(settings.titleColor || "theme");
  const [hideBorders, setHideBorders] = useState(settings.hideBorders || false);
  const [appName, setAppName] = useState(appTitle || "مشاريع ترجمة");
  const [coverName, setCoverName] = useState(coverTitle || "نظام إدارة مشاريع الترجمة");
  const loadBg = (file) => {
    const r = new FileReader();
    r.onload = () => {
      const img = new Image();
      img.onload = () => {
        const max = 1920; let w = img.width, h = img.height;
        if (w > max) { h = Math.round(h * max / w); w = max; }
        const cv = document.createElement("canvas"); cv.width = w; cv.height = h;
        cv.getContext("2d").drawImage(img, 0, 0, w, h);
        try { setBg(cv.toDataURL("image/jpeg", 0.82)); } catch { setBg(r.result); }
      };
      img.src = r.result;
    };
    r.readAsDataURL(file);
  };
  const th = TITLE_THEMES[theme] || TITLE_THEMES.neon;
  const lines = (text || "").split("\n").map((x) => x.trim()).filter(Boolean);
  const preview = lines[0] || "-";
  return (
    <Overlay onClose={onClose} u4>
      <div className="u4-head">
        <h3 className="u4-title" style={{ margin: 0 }}>الإعدادات</h3>
        <CloseBtn onClose={onClose} />
      </div>

      {isOwner && (
        <div style={{ display: "flex", gap: 6, marginBottom: 20, padding: 5, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 8 }}>
          <button onClick={() => setMainTab("general")} style={{ flex: 1, padding: "8px 12px", background: mainTab === "general" ? "var(--accent)" : "transparent", color: mainTab === "general" ? "var(--bg)" : "var(--text)", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 700, fontSize: 13, fontFamily: "inherit" }}>عام</button>
          <button onClick={() => setMainTab("ui")} style={{ flex: 1, padding: "8px 12px", background: mainTab === "ui" ? "var(--accent)" : "transparent", color: mainTab === "ui" ? "var(--bg)" : "var(--text)", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 700, fontSize: 13, fontFamily: "inherit" }}>التحكم بالواجهة</button>
        </div>
      )}

      {mainTab === "ui" && isOwner ? (
        <UIControl embedded />
      ) : (
      <>
      {isAdminUser && (
        <>
          <label style={S.label}>اسم الواجهة الرئيسية - يظهر لكل المستخدمين (للمدير فقط)</label>
          <input value={appName} onChange={(e) => setAppName(e.target.value)} dir="rtl" placeholder="مشاريع ترجمة" className="u4-in" style={{ marginBottom: 16 }} />
        </>
      )}
      {isOwner && (
        <>
          <label style={S.label}>العنوان العام للمنصة - يظهر في شاشة الدخول لكل المستخدمين (لمالك المنصة)</label>
          <input value={coverName} onChange={(e) => setCoverName(e.target.value)} dir="rtl" placeholder="نظام إدارة مشاريع الترجمة" className="u4-in" style={{ marginBottom: 16 }} />
        </>
      )}

      {isAdminUser && (
        <div style={{ marginBottom: 18, padding: "13px 14px", borderRadius: 0, borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)" }}>
          <label style={{ ...S.label, fontWeight: 800 }}> رسالة الشريط - تظهر في أعلى شاشة العضو المحدد</label>
          <TmSelect value={msgUser} onChange={pickMsgUser} placeholder="- اختر مستخدمًا -" options={[["", "- اختر مستخدمًا -"], ...users.map((u) => [u.id, u.fullName])]} style={{ marginBottom: msgUser ? 10 : 0 }} />
          {msgUser && (
            <>
              <textarea value={msgText} onChange={(e) => setMsgText(e.target.value)} dir="rtl" rows={2} placeholder="اكتب الرسالة… (اتركها فارغة ثم احفظ للحذف)" className="u4-in" style={{ minHeight: 58, resize: "vertical", marginBottom: 10 }} />
              <button className="save-btn" style={S.saveBtn} onClick={saveTopMsg}><Check size={16} /> حفظ الرسالة</button>
            </>
          )}
        </div>
      )}

      <label style={S.label}>نصّ الشريط العلوي - كل سطر بيت/عبارة مستقلّة (تُعرض بالتدوير)</label>
      <textarea
        value={text} onChange={(e) => setText(e.target.value)} dir="rtl" rows={3}
        placeholder="اكتب ما تشائين… كل سطر عبارة"
        className="u4-in" style={{ minHeight: 92, resize: "vertical", lineHeight: 2, marginBottom: 12 }}
      />

      <div style={{ background: th.grad, borderRadius: 0, padding: "11px 14px", marginBottom: 16, textAlign: "center", boxShadow: "0 3px 14px rgba(11,59,54,0.22)" }}>
        <span style={{ fontFamily: arab, fontWeight: 800, fontSize: size, color: th.text, whiteSpace: "nowrap" }}>{preview}</span>
      </div>

      <label style={S.label}>لون الشريط</label>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 18 }}>
        {Object.keys(TITLE_THEMES).map((k) => (
          <button key={k} className="ghost" onClick={() => setTheme(k)}
            style={{ width: 52, height: 32, borderRadius: 0, cursor: "pointer", background: TITLE_THEMES[k].grad, padding: 0,
              borderWidth: 2, borderStyle: "solid", borderColor: theme === k ? "var(--text)" : "rgba(0,0,0,0.08)",
              boxShadow: theme === k ? "0 0 0 2px #fff inset, 0 2px 8px rgba(27,36,64,0.18)" : "none" }} />
        ))}
      </div>

      <label style={S.label}>لون اسم الواجهة</label>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 18 }}>
        {[["theme", "بلون الشريط"], ["white", "أبيض"], ["black", "أسود"]].map(([k, lbl]) => (
          <button key={k} className="ghost" onClick={() => setTitleColor(k)}
            style={{ fontFamily: arab, fontSize: 14, fontWeight: 700, padding: "8px 16px", borderRadius: 999, cursor: "pointer", color: "var(--text)", background: titleColor === k ? "rgba(20,184,166,0.12)" : "transparent", borderWidth: 1, borderStyle: "solid", borderColor: titleColor === k ? "var(--accent)" : "var(--line)" }}>{lbl}</button>
        ))}
      </div>

      <label style={S.label}>حجم الخطّ: {size}px</label>
      <input type="range" min={14} max={30} value={size} onChange={(e) => setSize(+e.target.value)}
        style={{ width: "100%", accentColor: "var(--accent)", marginBottom: 18 }} />

      <button className="opt-btn" style={{ ...S.optBtn, ...(rotate ? { borderColor: "var(--accent)", background: "rgba(20,184,166,0.10)" } : {}) }} onClick={() => setRotate((v) => !v)}>
        <RotateCcw size={18} color={"var(--accent)"} />
        <span>{rotate ? "التدوير التلقائي مُفعّل - اضغط للإيقاف" : "تدوير الأبيات تلقائيًا (كل ٩ ثوانٍ)"}</span>
      </button>
      {rotate && lines.length < 2 && <div style={{ ...S.emptyHint, marginTop: 8 }}>أضِف سطرين أو أكثر ليبدأ التدوير.</div>}

      <div style={{ height: 14 }} />
      <label style={S.label}>خلفية الواجهة (خاصّة بك - بدل المربّعات)</label>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <label className="ghost" style={{ ...S.miniBtn, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}>
          <Upload size={16} color={"var(--accent)"} /> رفع صورة خلفية
          <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => { const f = e.target.files && e.target.files[0]; if (f) loadBg(f); }} />
        </label>
        {bg && <button className="ghost" style={S.miniBtn} onClick={() => setBg(null)}>إزالة الخلفية</button>}
      </div>
      {bg && <div style={{ marginTop: 10, height: 92, borderRadius: 0, backgroundImage: `url(${bg})`, backgroundSize: "cover", backgroundPosition: "center", border: `1px solid ${"var(--lineHi)"}` }} />}

      <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 12, padding: "10px 14px", borderRadius: 0, border: "1px solid var(--line)", width: "100%" }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: "var(--text)" }}>حدود الإطارات</span>
          <div style={{ display: "flex", gap: 8 }}>
            {[[false, "ظاهرة"], [true, "مخفية"]].map(([v, l]) => (
              <button key={String(v)} onClick={() => setHideBorders(v)} style={{ fontFamily: arab, fontSize: 13.5, fontWeight: 700, padding: "7px 16px", borderRadius: 0, cursor: "pointer", color: "var(--text)", background: hideBorders === v ? "rgba(20,184,166,0.12)" : "transparent", borderWidth: 1, borderStyle: "solid", borderColor: hideBorders === v ? "var(--accent)" : "var(--line)" }}>{l}</button>
            ))}
          </div>
        </div>
        <button className="save-btn" style={{ ...S.saveBtn, flex: 1 }} onClick={() => { onSave({ text, size, theme, rotate, bg, dark, cardBorder, cardBg, titleColor, hideBorders }); if (!ro && onSaveAppTitle) onSaveAppTitle(appName); if (isOwner && onSaveCoverTitle) onSaveCoverTitle(coverName); onClose(); }}>حفظ</button>
        <button className="ghost" style={S.miniBtn} onClick={() => { setText(DEFAULT_VERSE); setSize(19); setTheme("neon"); setRotate(false); setBg(null); setDark(false); setCardBorder(true); setTitleColor("theme"); }}>الافتراضي</button>
      </div>

      <div style={{ height: 14 }} />
      <button className="opt-btn" style={{ ...S.optBtn, ...(dark ? { borderColor: "var(--accent)", background: "rgba(20,184,166,0.10)" } : {}) }} onClick={() => setDark((v) => !v)}>
        <span>{dark ? "الوضع الليلي مُفعّل - اضغط للوضع النهاري" : "تفعيل الوضع الليلي "}</span>
      </button>
      <button className="opt-btn" style={{ ...S.optBtn, marginTop: 8, ...(cardBorder ? { borderColor: "var(--accent)", background: "rgba(20,184,166,0.10)" } : {}) }} onClick={() => setCardBorder((v) => !v)}>
        <span>{cardBorder ? "إطار البطاقات: ظاهر - اضغط للإخفاء" : "إظهار إطار البطاقات (بلون الشريط)"}</span>
      </button>
      <button className="opt-btn" style={{ ...S.optBtn, marginTop: 8, ...(cardBg ? { borderColor: "var(--accent)", background: "rgba(20,184,166,0.10)" } : {}) }} onClick={() => setCardBg((v) => !v)}>
        <span>{cardBg ? "خلفية البطاقات: ظاهرة - اضغط للإخفاء" : "إخفاء خلفية البطاقات (تظهر الأيقونة/الصورة والبيانات فقط)"}</span>
      </button>

      {!ro && (
        <>
          <div style={{ height: 14 }} />
        </>
      )}
      </>
      )}
    </Overlay>
  );
}

function ConfirmBlock({ text, confirmLabel, onBack, onConfirm, danger }) {
  return (
    <div className="fade-in">
      <div style={S.confirmText}>{text}</div>
      <div style={S.modalFoot}>
        <button style={S.cancelBtn} className="ghost" onClick={onBack}>رجوع</button>
        <button
          style={{ ...S.saveBtn, ...(danger ? { background: "linear-gradient(135deg,#ff8585,#e23d3d)" } : {}) }}
          className="save-btn" onClick={onConfirm}
        >{confirmLabel}</button>
      </div>
    </div>
  );
}

/* ----------------- عناصر نافذة مشتركة ----------------- */
const fr = {
  row: { display: "flex", alignItems: "center", gap: 8, background: "color-mix(in srgb, var(--surface) 62%, transparent)", border: "1px solid var(--line)", borderRadius: 11, padding: "9px 12px" },
  name: { fontFamily: arab, fontWeight: 700, fontSize: 15, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  city: { fontFamily: arab, fontSize: 12, color: "var(--muted)", marginTop: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  date: { fontFamily: mono, fontSize: 12, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 8, padding: "6px 8px", color: "var(--text)", colorScheme: "light", flex: "0 0 auto" },
  add: { fontFamily: arab, fontWeight: 700, fontSize: 13, color: "#fff", background: AGENDA_COLORS["معرض"], border: "none", borderRadius: 8, padding: "7px 12px", cursor: "pointer", whiteSpace: "nowrap", flex: "0 0 auto" },
  del: { display: "inline-flex", padding: 6, color: "var(--muted)", flex: "0 0 auto" },
  addBox: { marginTop: 14, paddingTop: 14, borderTop: "1px solid var(--line)" },
};
function DbModal({ publishers, onRestore, onClose }) {
  const [st, setSt] = useState(null);
  const [backups, setBackups] = useState([]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [confirmName, setConfirmName] = useState(null);
  const counts = (() => {
    let ag = 0, pj = 0, bk = 0;
    for (const p of (publishers || [])) { if (!p || p.deleted) continue; ag++; for (const j of (p.projects || [])) { if (!j || j.deleted) continue; pj++; for (const w of (j.works || [])) { if (!w || w.deleted) continue; bk++; } } }
    return { ag, pj, bk };
  })();
  const refresh = async () => {
    try { if (window.pmdb) { setSt(await window.pmdb.status()); setBackups(await window.pmdb.listBackups()); } } catch {}
  };
  useEffect(() => { refresh(); }, []);
  const doBackup = async () => {
    setBusy(true); setMsg("");
    try { const r = window.pmdb ? await window.pmdb.makeBackup() : null; setMsg(r && r.ok ? "تم أخذ نسخة ✓" : ("تعذّر: " + (r && r.error || "غير متاح"))); await refresh(); }
    catch (e) { setMsg("خطأ: " + (e && e.message || e)); }
    setBusy(false);
  };
  const doRestore = async (name) => {
    setBusy(true); setMsg(""); setConfirmName(null);
    try {
      const r = window.pmdb ? await window.pmdb.restoreBackup(name) : null;
      if (r && r.ok) { await onRestore(r.publishers, r.value); setMsg("تمّت الاستعادة ✓"); await refresh(); }
      else { setMsg("تعذّرت الاستعادة: " + (r && r.error || "غير متاح")); }
    } catch (e) { setMsg("خطأ: " + (e && e.message || e)); }
    setBusy(false);
  };
  const upd = st && st.snapshot && st.snapshot.updated_at ? String(st.snapshot.updated_at).replace("T", " ").slice(0, 16) : "-";
  const len = st && st.snapshot && st.snapshot.len ? st.snapshot.len : 0;
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}><h3 style={S.modalTitle}>قاعدة البيانات</h3><CloseBtn onClose={onClose} /></div>

      <div style={{ background: "color-mix(in srgb, var(--surface) 62%, transparent)", border: "1px solid var(--line)", borderRadius: 12, padding: "14px 16px", marginBottom: 14 }}>
        <div style={{ fontFamily: arab, fontWeight: 700, fontSize: 15, marginBottom: 8, color: "var(--text)" }}>
          {st && st.ok ? "SQLite تعمل ✓" : "SQLite غير مفعّلة"}
        </div>
        <div style={{ fontFamily: mono, fontSize: 13, color: "var(--muted)", lineHeight: 1.9 }}>
          الجهات: {counts.ag} · المشاريع: {counts.pj} · الكتب: {counts.bk}<br />
          آخر حفظ في القاعدة: {upd}<br />
          حجم البيانات المخزّنة: {len} حرف
          {st && !st.ok && st.error ? <><br />الخطأ: {st.error}</> : null}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ fontFamily: arab, fontWeight: 700, fontSize: 15, color: "var(--text)" }}>النسخ الاحتياطية (آخر ٣)</div>
        <button style={{ ...S.saveBtn, opacity: busy ? .6 : 1, pointerEvents: busy ? "none" : "auto" }} onClick={doBackup}><Save size={16} />أخذ نسخة الآن</button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: "34vh", overflowY: "auto" }}>
        {backups.length === 0 && <div style={{ fontFamily: arab, fontSize: 13, color: "var(--muted)", padding: "10px 2px" }}>لا نسخ بعد - اضغط «أخذ نسخة الآن».</div>}
        {backups.map((b) => (
          <div key={b.name} style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 10, padding: "10px 13px" }}>
            <Database size={18} color={"var(--accent)"} style={{ flex: "0 0 auto" }} />
            <div style={{ flex: "1 1 auto", minWidth: 0 }}>
              <div style={{ fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)" }}>{b.when}</div>
              <div style={{ fontFamily: mono, fontSize: 11, color: "var(--muted)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{b.name}</div>
            </div>
            {confirmName === b.name ? (
              <>
                <button style={{ fontFamily: arab, fontWeight: 700, fontSize: 12.5, color: "#fff", background: "#c0392b", border: "none", borderRadius: 8, padding: "7px 11px", cursor: "pointer" }} onClick={() => doRestore(b.name)}>تأكيد الاستبدال</button>
                <button className="ghost" style={{ fontFamily: arab, fontSize: 12.5, color: "var(--muted)", padding: "7px 9px" }} onClick={() => setConfirmName(null)}>إلغاء</button>
              </>
            ) : (
              <button style={{ fontFamily: arab, fontWeight: 700, fontSize: 13, color: "var(--accent)", background: "transparent", border: "1px solid var(--accent)", borderRadius: 8, padding: "7px 13px", cursor: "pointer", flex: "0 0 auto" }} onClick={() => setConfirmName(b.name)}>استعادة</button>
            )}
          </div>
        ))}
      </div>

      {msg && <div style={{ marginTop: 12, fontFamily: arab, fontSize: 13.5, color: "var(--text)", textAlign: "center" }}>{msg}</div>}
      <p style={{ marginTop: 12, fontFamily: arab, fontSize: 12, color: "var(--muted)", lineHeight: 1.7 }}>الاستعادة تستبدل بياناتك الحالية بمحتوى النسخة المختارة. تُؤخذ نسخة تلقائيًّا عند كل فتح للتطبيق، ويُحتفظ بآخر ٣ فقط.</p>
    </Overlay>
  );
}
function TrashModal({ publishers, onRestorePub, onPurgePub, onRestoreProj, onPurgeProj, onRestoreWork, onPurgeWork, onClose }) {
  const [confirm, setConfirm] = useState(null); // key of item pending purge
  const items = (() => {
    const out = [];
    for (const pub of (publishers || [])) {
      if (!pub) continue;
      if (pub.status === "trashed") out.push({ key: "p:" + pub.id, type: "جهة", name: pub.name, path: "", icon: bookIcon ? null : null, iconName: pub.icon, img: pub.iconImg,
        restore: () => onRestorePub(pub), purge: () => onPurgePub(pub) });
      for (const proj of (pub.projects || [])) {
        if (!proj) continue;
        if (proj.status === "trashed") out.push({ key: "j:" + pub.id + ":" + proj.id, type: "مشروع", name: proj.name, path: pub.name, iconName: proj.icon, img: proj.iconImg,
          restore: () => onRestoreProj(pub.id, proj.id), purge: () => onPurgeProj(pub.id, proj.id) });
        for (const w of (proj.works || [])) {
          if (!w) continue;
          if (w.status === "trashed") out.push({ key: "w:" + pub.id + ":" + proj.id + ":" + w.id, type: "كتاب", name: w.name, path: pub.name + " › " + proj.name, iconName: w.icon, img: bookIcon(w),
            restore: () => onRestoreWork(pub.id, proj.id, w.id), purge: () => onPurgeWork(pub.id, proj.id, w.id) });
        }
      }
    }
    return out;
  })();
  const TYPE_COLOR = { "جهة": "#c084fc", "مشروع": "#2aa6b6", "كتاب": "#e8a53a" };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}><h3 style={S.modalTitle}>سلّة المحذوفات</h3><CloseBtn onClose={onClose} /></div>
      {items.length === 0 ? (
        <div style={{ fontFamily: arab, fontSize: 14, color: "var(--muted)", textAlign: "center", padding: "26px 8px" }}>السلّة فارغة - لا عناصر محذوفة.</div>
      ) : (
        <>
          <div style={{ fontFamily: arab, fontSize: 13, color: "var(--muted)", marginBottom: 10 }}>{items.length} عنصر محذوف</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: "56vh", overflowY: "auto" }}>
            {items.map((it) => (
              <div key={it.key} style={{ display: "flex", alignItems: "center", gap: 11, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 11, padding: "10px 13px" }}>
                <span style={{ flex: "0 0 auto", width: 38, height: 38, borderRadius: 9, overflow: "hidden", display: "grid", placeItems: "center", background: "rgba(42,166,182,.10)", border: "1px solid var(--line)" }}>
                  <ProjIcon img={it.img} name={it.iconName} size={22} color={"var(--accent)"} />
                </span>
                <span style={{ flex: "1 1 auto", minWidth: 0 }}>
                  <span style={{ display: "flex", alignItems: "center", gap: 7 }}>
                    <span style={{ fontFamily: arab, fontSize: 10.5, fontWeight: 700, color: TYPE_COLOR[it.type] || "var(--accent)", border: "1px solid " + (TYPE_COLOR[it.type] || "var(--accent)"), borderRadius: 6, padding: "1px 7px" }}>{it.type}</span>
                    <span style={{ fontFamily: arab, fontWeight: 700, fontSize: 14.5, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{it.name || "بدون اسم"}</span>
                  </span>
                  {it.path && <span style={{ display: "block", fontFamily: arab, fontSize: 11.5, color: "var(--muted)", marginTop: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{it.path}</span>}
                </span>
                {confirm === it.key ? (
                  <>
                    <button style={{ fontFamily: arab, fontWeight: 700, fontSize: 12, color: "#fff", background: "#c0392b", border: "none", borderRadius: 8, padding: "7px 10px", cursor: "pointer" }} onClick={() => { it.purge(); setConfirm(null); }}>حذف نهائي</button>
                    <button className="ghost" style={{ fontFamily: arab, fontSize: 12, color: "var(--muted)", padding: "7px 8px" }} onClick={() => setConfirm(null)}>إلغاء</button>
                  </>
                ) : (
                  <>
                    <button style={{ fontFamily: arab, fontWeight: 700, fontSize: 12.5, color: "var(--accent)", background: "transparent", border: "1px solid var(--accent)", borderRadius: 8, padding: "7px 12px", cursor: "pointer", flex: "0 0 auto" }} onClick={it.restore}>استعادة</button>
                    <button className="ghost" style={{ padding: "7px 8px", color: "#ff8585" }} onClick={() => setConfirm(it.key)}><Trash2 size={16} /></button>
                  </>
                )}
              </div>
            ))}
          </div>
          <p style={{ marginTop: 12, fontFamily: arab, fontSize: 12, color: "var(--muted)", lineHeight: 1.7 }}>«استعادة» تُعيد العنصر إلى مكانه. «حذف نهائي» لا يمكن التراجع عنه.</p>
        </>
      )}
    </Overlay>
  );
}
function SearchModal({ publishers, onGo, onClose }) {
  const [q, setQ] = useState("");
  const norm = (t) => String(t || "")
    .replace(/[\u064B-\u0652\u0670]/g, "")
    .replace(/[\u0622\u0623\u0625\u0671]/g, "\u0627")
    .replace(/\u0649/g, "\u064A").replace(/\u0629/g, "\u0647")
    .toLowerCase().trim();
  const nq = norm(q);
  const terms = nq.split(/\s+/).filter(Boolean);
  const STAT = { active: "نشط", archived: "مؤرشف", trashed: "سلة" };
  const STAT_COLOR = { active: "#059669", archived: "#b45309", trashed: "#dc2626" };
  const results = (() => {
    if (!terms.length) return [];
    const out = [];
    for (const pub of (publishers || [])) {
      if (!pub) continue;
      for (const proj of (pub.projects || [])) {
        if (!proj) continue;
        for (const bk of (proj.works || [])) {
          if (!bk) continue;
          const hay = norm([bk.name, bk.nameFr, bk.authorName, bk.transName, bk.category, bk.lang,
            bk.isbnAr, bk.isbnFr, bk.notes, bk.pubAr, bk.pubFrHouse, STAT[bk.status] || bk.status,
            proj.name, pub.name].join(" \u0000 "));
          if (terms.every((t) => hay.includes(t))) out.push({ pub, proj, bk });
          if (out.length > 400) break;
        }
      }
    }
    return out;
  })();
  const hlName = (name) => {
    if (!terms.length || !name) return name;
    const parts = [];
    let rest = name, guard = 0;
    while (rest && guard++ < 40) {
      let bi = -1, bt = "";
      for (const t of terms) { const idx = norm(rest).indexOf(t); if (idx >= 0 && (bi < 0 || idx < bi)) { bi = idx; bt = t; } }
      if (bi < 0) { parts.push(rest); break; }
      parts.push(rest.slice(0, bi));
      parts.push(<mark key={guard} style={{ background: "color-mix(in srgb, var(--accent) 30%, transparent)", color: "inherit", borderRadius: 0, padding: "0 1px" }}>{rest.slice(bi, bi + bt.length)}</mark>);
      rest = rest.slice(bi + bt.length);
    }
    return parts;
  };
  const hl = (b) => {
    const tags = [];
    if (b.bk.authorName) tags.push("تأليف: " + b.bk.authorName);
    if (b.bk.transName) tags.push("ترجمة: " + b.bk.transName);
    if (b.bk.category) tags.push(b.bk.category);
    return tags.join(" · ");
  };
  return (
    <Overlay onClose={onClose}>
      <div style={S.modalHead}><h3 style={S.modalTitle}>بحث شامل</h3><CloseBtn onClose={onClose} /></div>
      <div style={{ position: "relative", marginBottom: 14 }}>
        <Search size={18} color={"var(--muted)"} style={{ position: "absolute", insetInlineStart: 12, top: "50%", transform: "translateY(-50%)" }} />
        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="اسم كتاب، مؤلف، مترجم، فئة، ISBN، مشروع، جهة…"
          style={{ ...S.input, marginBottom: 0, paddingInlineStart: 40 }} />
      </div>
      {nq && <div style={{ fontFamily: arab, fontSize: 13, color: "var(--muted)", marginBottom: 10 }}>{results.length ? (results.length + " نتيجة") : "لا نتائج"}</div>}
      <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: "52vh", overflowY: "auto" }}>
        {results.map(({ pub, proj, bk }) => (
          <button key={pub.id + "/" + proj.id + "/" + bk.id} className="opt-btn"
            onClick={() => onGo(pub.id, proj.id, bk.id)}
            style={{ display: "flex", alignItems: "center", gap: 12, textAlign: "start", background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 0, padding: "11px 14px", cursor: "pointer", width: "100%" }}>
            <span style={{ flex: "0 0 auto", width: 40, height: 40, borderRadius: 0, overflow: "hidden", display: "grid", placeItems: "center", background: "rgba(42,166,182,.12)", border: "1px solid var(--line)" }}>
              <ProjIcon img={bookIcon(bk)} name={bk.icon} size={22} color={"var(--accent)"} />
            </span>
            <span style={{ flex: "1 1 auto", minWidth: 0 }}>
              <span style={{ display: "flex", alignItems: "center", gap: 7, fontFamily: arab, fontWeight: 700, fontSize: 15, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden" }}>
                <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{hlName(bk.name || "بدون اسم")}</span>
                {bk.status && bk.status !== "active" && <span style={{ flex: "0 0 auto", fontSize: 10.5, fontWeight: 800, color: "#fff", background: STAT_COLOR[bk.status] || "var(--muted)", padding: "1px 7px" }}>{STAT[bk.status] || bk.status}</span>}
              </span>
              <span style={{ display: "block", fontFamily: arab, fontSize: 12, color: "var(--muted)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{pub.name} › {proj.name}{hl({ pub, proj, bk }) ? " · " + hl({ pub, proj, bk }) : ""}</span>
            </span>
            <ChevronRight size={16} color={"var(--muted)"} style={{ flex: "0 0 auto", transform: "scaleX(-1)" }} />
          </button>
        ))}
      </div>
      {!nq && <p style={{ fontFamily: arab, fontSize: 13, color: "var(--muted)", lineHeight: 1.8, marginTop: 4 }}>ابحث عبر كل الكتب في كل الجهات والمشاريع. اضغط أي نتيجة للانتقال إليها مباشرة.</p>}
    </Overlay>
  );
}
function Overlay({ children, onClose, u4 }) {
  return (
    <div style={S.overlay} className={"fade-in" + (u4 ? " u4-bg" : "")} onClick={onClose}>
      <div style={S.modal} className={"modal-pop" + (u4 ? " u4 u4-win" : "")} onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
}
function CloseBtn({ onClose }) { return <button style={S.closeBtn} className="ghost" onClick={onClose}><X size={18} /></button>; }
function ModalFoot({ canSave, onClose, onSave, label }) {
  return (
    <div style={S.modalFoot}>
      <button style={S.cancelBtn} className="ghost" onClick={onClose}>إلغاء</button>
      <button style={{ ...S.saveBtn, opacity: canSave ? 1 : 0.45, cursor: canSave ? "pointer" : "not-allowed" }} className="save-btn" onClick={onSave} disabled={!canSave}>
        <Plus size={16} /> {label}
      </button>
    </div>
  );
}

/* ------------------------------- الأنماط ------------------------------- */
const serif = "'Instrument Serif', serif";

const S = {
  root: {
    fontFamily: arab, minHeight: "100vh", color: "var(--text)",
    backgroundColor: "var(--bg)",
    backgroundImage: `repeating-linear-gradient(${"var(--grid)"} 0 1px, transparent 1px 26px), repeating-linear-gradient(90deg, ${"var(--grid)"} 0 1px, transparent 1px 26px)`,
    backgroundAttachment: "fixed",
  },

  cover: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "transparent", position: "relative", overflow: "hidden", padding: 24 },
  corner: { position: "absolute", fontFamily: mono, fontSize: 14, letterSpacing: 1.5, color: "var(--faint)", zIndex: 3 },
  coverInner: { textAlign: "center", position: "relative", zIndex: 3 },
  coverLogo: { width: "clamp(96px,16vw,148px)", height: "clamp(96px,16vw,148px)", borderRadius: "50%", objectFit: "cover", margin: "0 auto 18px", display: "block", boxShadow: "0 10px 34px rgba(0,0,0,0.18)", border: "3px solid color-mix(in srgb, var(--accent) 35%, transparent)" },
  coverTitle: { fontFamily: arab, fontWeight: 800, fontSize: "clamp(32px, 6.5vw, 58px)", margin: 0, lineHeight: 1.4, letterSpacing: "normal", color: "var(--accent)" },
  coverSubEn: { fontFamily: serif, fontStyle: "italic", fontSize: "clamp(22px,4vw,34px)", color: "var(--accent)", marginTop: 6 },
  coverSub: { fontFamily: mono, fontSize: "clamp(10px,1.8vw,13px)", letterSpacing: 3, color: "var(--faint)", marginTop: 18 },
  enter: { marginTop: 44, fontFamily: arab, fontWeight: 700, fontSize: 16, color: "#0b1020", background: `linear-gradient(135deg, #f0ff66, #e8ff00 55%, #c5e000)`, border: "none", borderRadius: 6, padding: "14px 40px", cursor: "pointer", letterSpacing: 1, boxShadow: `0 8px 22px rgba(232,255,0,0.3)`, transition: "transform .2s, box-shadow .2s" },

  page: { minHeight: "100vh", background: "transparent", display: "flex", flexDirection: "column" },
  topbar: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px clamp(16px,4vw,40px) 0", background: "transparent" },
  brand: { fontFamily: arab, fontWeight: 800, fontSize: 20 },
  backBtn: { fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "transparent", border: "none", borderRadius: 6, padding: "7px 16px", cursor: "pointer" },
  editBtn: { display: "inline-flex", alignItems: "center", gap: 5, fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "transparent", border: "none", borderRadius: 6, padding: "7px 14px", cursor: "pointer" },
  editBtnOn: { background: "#e8ff00", color: "#0b1020", borderColor: "var(--accent)" },

  body: { flex: 1, position: "relative", overflow: "hidden", padding: "30px clamp(16px,4vw,48px) 40px" },
  sectionHead: { position: "relative", zIndex: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 14 },
  sectionTitle: { fontFamily: arab, fontWeight: 700, fontSize: "clamp(22px,4vw,30px)", color: "var(--title-color)", margin: 0 },
  crumb: { fontFamily: mono, fontSize: 14, letterSpacing: 1, color: "var(--faint)", marginTop: 2 },
  emptyHint: { position: "relative", zIndex: 2, marginTop: 22, fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "color-mix(in srgb, var(--surface) 62%, transparent)", border: `1px dashed ${"var(--lineHi)"}`, borderRadius: 10, padding: "16px 18px" },
  crumbIcon: { width: 44, height: 44, borderRadius: 0, background: "var(--surface)", border: "none", display: "flex", alignItems: "center", justifyContent: "center" },
  statBox: { background: "color-mix(in srgb, var(--surface) 62%, transparent)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 8, padding: "8px 18px", textAlign: "center" },
  exportBtn: { display: "inline-flex", alignItems: "center", gap: 6, fontFamily: arab, fontWeight: 600, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "none", borderRadius: 8, padding: "9px 16px", cursor: "pointer" },

  mkBanner: { position: "relative", zIndex: 2, width: "100%", display: "flex", alignItems: "center", gap: 14, background: "var(--surface)", backdropFilter: "blur(9px)", WebkitBackdropFilter: "blur(9px)", borderStyle: "solid", borderColor: "var(--line)", borderTopWidth: 1, borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderRadius: 12, padding: "16px 18px", marginBottom: 18, cursor: "pointer", fontFamily: arab, boxShadow: "0 2px 8px rgba(27,36,64,0.06)", transition: "transform .2s, box-shadow .2s" },
  mkBannerIcon: { width: 44, height: 44, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  mkBannerTitle: { fontFamily: arab, fontWeight: 700, fontSize: 16, color: "var(--text)" },
  sysIcon: { display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 9, padding: "13px 18px", minWidth: 122, borderRadius: 15, background: "var(--surface)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", border: "1px solid var(--line)", cursor: "pointer", transition: "transform .14s, box-shadow .14s" },
  sysIconLabel: { fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)", whiteSpace: "nowrap" },
  mkBannerSub: { fontFamily: arab, fontSize: 14, color: "var(--muted)", marginTop: 2 },
  mkBannerGo: { fontFamily: arab, fontWeight: 700, fontSize: 14 },

  kpiRow: { position: "relative", zIndex: 2, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 14, marginBottom: 26 },
  statControls: { position: "relative", zIndex: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap", background: "color-mix(in srgb, var(--surface) 62%, transparent)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 12, padding: "12px 14px", marginBottom: 22 },
  scopeWrap: { display: "flex", gap: 8 },
  fLabel: { fontFamily: arab, fontSize: 14, color: "var(--muted)" },
  fInput: { fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 8, padding: "6px 10px", outline: "none" },
  statCols: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 22 },
  missChip: { fontFamily: arab, fontSize: 14, color: "#e23d3d", background: "rgba(226,61,61,0.08)", border: "1px solid rgba(226,61,61,0.3)", borderRadius: 999, padding: "2px 9px" },
  kpiCard: { background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 14, padding: "20px 16px", textAlign: "center", boxShadow: "0 2px 8px rgba(27,36,64,0.06)" },
  kpiNum: { fontFamily: mono, fontWeight: 700, fontSize: 34, lineHeight: 1 },
  kpiLabel: { fontFamily: arab, fontSize: 14, color: "var(--muted)", marginTop: 8 },
  barRow: { display: "flex", alignItems: "center", gap: 12, marginBottom: 10 },
  barLabel: { fontFamily: arab, fontSize: 14, color: "var(--text)", width: 90, textAlign: "left", flexShrink: 0 },
  barTrack: { flex: 1, height: 22, background: "var(--surfaceHi)", borderRadius: 999, overflow: "hidden", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)" },
  barFill: { height: "100%", borderRadius: 999, transition: "width .5s ease", minWidth: 4 },
  barVal: { fontFamily: mono, fontSize: 14, color: "var(--muted)", width: 30, textAlign: "center" },
  colChartWrap: { display: "flex", alignItems: "flex-end", justifyContent: "flex-start", gap: 16, overflowX: "auto", padding: "14px 16px 8px", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 12, minHeight: 230 },
  colChartCol: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", minWidth: 56, flexShrink: 0 },
  colChartVal: { fontFamily: mono, fontSize: 14, fontWeight: 700, color: "var(--text)", marginBottom: 6 },
  colChartBar: { width: 38, borderTopLeftRadius: 7, borderTopRightRadius: 7, transition: "height .5s ease", boxShadow: "0 2px 8px rgba(27,36,64,0.10)" },
  colChartLabel: { fontFamily: arab, fontSize: 14, color: "var(--muted)", marginTop: 9, textAlign: "center", maxWidth: 70, lineHeight: 1.4 },
  projStatGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: 12 },
  projStatCard: { background: "var(--surface)", borderStyle: "solid", borderTopColor: "var(--line)", borderBottomColor: "var(--line)", borderLeftColor: "var(--line)", borderRightColor: "var(--line)", borderTopWidth: 1, borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderRadius: 10, padding: "14px 12px", textAlign: "center" },
  mkMetaRow: { position: "relative", zIndex: 2, display: "flex", gap: 14, marginBottom: 20 },
  mkSection: { position: "relative", zIndex: 2, marginBottom: 26 },
  mkSecTitle: { fontFamily: arab, fontWeight: 700, fontSize: 15, color: "var(--accent)", borderRightWidth: 3, borderRightStyle: "solid", paddingRight: 10, marginBottom: 12 },
  mkTableWrap: { overflowX: "auto", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, background: "var(--surface)" },
  mkTable: { borderCollapse: "collapse", width: "100%", minWidth: 720 },
  th: { fontFamily: arab, fontSize: 14, fontWeight: 700, color: "var(--text)", background: "var(--surfaceHi)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", padding: "9px 10px", whiteSpace: "nowrap", textAlign: "right" },
  td: { borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", padding: 4, verticalAlign: "middle" },
  tdNum: { borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", padding: "4px 8px", fontFamily: mono, fontSize: 14, color: "var(--muted)", textAlign: "center", background: "var(--surfaceHi)" },
  tdName: { borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", padding: "4px 10px", fontFamily: arab, fontSize: 14, fontWeight: 700, color: "var(--text)", whiteSpace: "nowrap", background: "var(--surfaceHi)" },
  tdDerived: { borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", padding: "4px 10px", fontFamily: arab, fontSize: 14, color: "var(--muted)", whiteSpace: "nowrap" },
  tdInput: { width: "100%", minWidth: 110, boxSizing: "border-box", border: "none", outline: "none", background: "transparent", fontFamily: arab, fontSize: 14, color: "var(--text)", padding: "6px 8px" },
  tdDel: { background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", color: "var(--muted)", borderRadius: 6, width: 28, height: 28, cursor: "pointer", lineHeight: 1 },
  mkAddRow: { display: "inline-flex", alignItems: "center", gap: 6, margin: 10, fontFamily: arab, fontSize: 14, fontWeight: 600, background: "transparent", borderWidth: 1, borderStyle: "solid", borderRadius: 8, padding: "7px 14px", cursor: "pointer" },
  mkNotes: { width: "100%", boxSizing: "border-box", minHeight: 90, background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, padding: "12px 14px", fontFamily: arab, fontSize: 14, color: "var(--text)", outline: "none", resize: "vertical" },
  mkContactGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14, background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, padding: 16 },
  delBookBar: { position: "relative", zIndex: 2, display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 18 },
  delBookTab: { display: "inline-flex", alignItems: "center", gap: 7, fontFamily: arab, fontSize: 14, fontWeight: 600, color: "var(--muted)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 999, padding: "7px 14px", cursor: "pointer" },
  delList: { background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, overflow: "hidden" },
  delRow: { display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderBottomWidth: 1, borderBottomStyle: "solid", borderBottomColor: "var(--line)", flexWrap: "wrap" },
  delCheck: { width: 22, height: 22, flexShrink: 0, borderRadius: 6, borderWidth: 1.5, borderStyle: "solid", borderColor: "var(--lineHi)", background: "var(--surface)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" },
  delLabel: { flex: 1, minWidth: 160, fontFamily: arab, fontSize: 14, color: "var(--muted)" },
  delAmount: { width: 100, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "5px 8px", outline: "none" },
  delDate: { width: 140, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "5px 8px", outline: "none" },
  delFileWrap: { display: "inline-flex", gap: 5 },
  delMini: { display: "inline-flex", alignItems: "center", gap: 4, fontFamily: arab, fontSize: 14, background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "5px 9px", cursor: "pointer" },
  delMiniDel: { fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "5px 8px", cursor: "pointer" },
  delUpload: { display: "inline-flex", alignItems: "center", gap: 5, fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "var(--surface)", borderWidth: 1, borderStyle: "dashed", borderColor: "var(--lineHi)", borderRadius: 7, padding: "5px 11px", cursor: "pointer" },
  coverPick: { padding: 3, background: "var(--surface)", borderWidth: 2, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 8, cursor: "pointer" },
  nflName: { width: 150, fontFamily: arab, fontSize: 14, fontWeight: 600, color: "var(--text)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "6px 9px", outline: "none" },
  nflNote: { flex: 1, minWidth: 140, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "6px 9px", outline: "none" },
  exportNote: { fontFamily: arab, fontSize: 14, color: "var(--muted)", lineHeight: 1.8, marginBottom: 16, background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, padding: "12px 14px" },
  colGrid: { display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 },
  colGroupHead: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 7, fontFamily: arab, fontSize: 14, fontWeight: 700, color: "var(--muted)" },
  colGroupBtn: { fontFamily: arab, fontSize: 14, color: "var(--accent)", background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "3px 10px", cursor: "pointer" },
  colChip: { display: "inline-flex", alignItems: "center", gap: 5, fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 999, padding: "6px 13px", cursor: "pointer" },
  statNum: { fontFamily: mono, fontWeight: 600, fontSize: 22, color: "var(--accent)", lineHeight: 1 },
  statLabel: { fontFamily: arab, fontSize: 14, color: "var(--muted)", marginTop: 3 },

  grid: { position: "relative", zIndex: 2, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 18 },
  coverGrid: { position: "relative", zIndex: 2, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 20 },
  coverCard: { position: "relative", background: "var(--surface)", borderRadius: 12, borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", padding: 12, cursor: "pointer", transition: "transform .2s, box-shadow .2s", animation: "rise .5s ease both", boxShadow: "0 2px 8px rgba(27,36,64,0.06)", display: "flex", flexDirection: "column", gap: 8 },
  coverThumbWrap: { position: "relative", width: "100%", aspectRatio: "2 / 3", borderRadius: 8, overflow: "hidden", background: "var(--surfaceHi)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)" },
  coverThumb: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  coverThumbEmpty: { width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8 },
  coverNoImg: { fontFamily: arab, fontSize: 14, color: "var(--faint)" },
  coverLangBadge: { position: "absolute", top: 8, left: 8, fontFamily: arab, fontWeight: 700, fontSize: 14, color: "#fff", borderRadius: 999, padding: "2px 10px" },
  coverTitle2: { fontFamily: arab, fontWeight: 700, fontSize: 15.5, color: "var(--text)", lineHeight: 1.4 },
  coverAuthor: { fontFamily: arab, fontSize: 14, color: "var(--muted)" },
  coverNameFr: { fontFamily: arab, fontSize: 14, color: "var(--muted)", direction: "ltr", textAlign: "right" },
  coverLangLine: { fontFamily: arab, fontSize: 14, color: "var(--muted)" },
  card: { position: "relative", background: "color-mix(in srgb, var(--surface) 32%, transparent)", backdropFilter: "blur(9px)", WebkitBackdropFilter: "blur(9px)", borderRadius: 12, borderStyle: "solid", borderTopColor: "transparent", borderBottomColor: "transparent", borderLeftColor: "transparent", borderRightColor: "transparent", borderTopWidth: 1, borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, padding: "22px 18px 20px", cursor: "pointer", transition: "transform .2s, box-shadow .2s, border-color .2s", animation: "rise .5s ease both", display: "flex", flexDirection: "column", alignItems: "center", gap: 10, boxShadow: "0 4px 16px rgba(27,36,64,0.05)" },
  cardMeta: { width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" },
  tag: { fontFamily: arab, fontWeight: 600, fontSize: 14, borderWidth: 1, borderStyle: "solid", borderRadius: 4, padding: "2px 9px", background: "rgba(232,255,0,0.14)" },
  code: { fontFamily: arab, fontSize: 14, color: "var(--faint)", letterSpacing: 0 },
  cardIcon: { width: 82, height: 82, borderRadius: "50%", background: "var(--surfaceHi)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", marginTop: 4 },
  cardName: { fontFamily: arab, fontWeight: 700, fontSize: 17, color: "var(--text)", textAlign: "center" },
  cardNote: { fontFamily: arab, fontSize: 14, color: "var(--muted)" },
  dateRow: { display: "flex", alignItems: "center", gap: 6, fontFamily: arab, fontSize: 14, color: "var(--muted)" },
  del: { position: "absolute", top: 8, left: 8, background: "none", border: "none", color: "var(--faint)", cursor: "pointer", fontSize: 14, padding: 4, borderRadius: 4, lineHeight: 1 },

  addCard: { border: `2px dashed ${"var(--lineHi)"}`, borderRadius: 12, background: "rgba(255,255,255,0.10)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)", padding: "22px 18px", cursor: "pointer", minHeight: 168, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, transition: "border-color .2s, background .2s" },
  addCircle: { width: 50, height: 50, borderRadius: "50%", borderWidth: 2, borderStyle: "dotted", borderColor: "var(--lineHi)", display: "flex", alignItems: "center", justifyContent: "center" },
  addText: { fontFamily: arab, fontWeight: 600, fontSize: 14, color: "var(--accent)" },

  footer: { background: "color-mix(in srgb, var(--surface) 72%, transparent)", backdropFilter: "blur(4px)", padding: "14px clamp(16px,4vw,40px)", display: "flex", alignItems: "center", justifyContent: "space-between", borderTop: `1px solid ${"var(--line)"}` },
  footText: { fontFamily: mono, fontSize: 14, color: "var(--faint)", letterSpacing: 1 },
  footPink: { fontFamily: arab, fontSize: 14, color: "var(--accent)" },

  /* الأرشيف / السلة */
  binWrap: { position: "relative", zIndex: 2, marginTop: 36, paddingTop: 22, borderTop: `1px dashed ${"var(--line)"}` },
  binHead: { display: "flex", alignItems: "center", gap: 10, marginBottom: 16, flexWrap: "wrap" },
  binTitle: { fontFamily: arab, fontWeight: 700, fontSize: 18, color: "var(--text)" },
  binCount: { fontFamily: mono, fontSize: 14, color: "var(--muted)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 999, padding: "1px 9px" },
  binNote: { fontFamily: arab, fontSize: 14, color: "var(--faint)", marginRight: "auto" },
  binGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 },
  binItem: { display: "flex", alignItems: "center", gap: 12, background: "color-mix(in srgb, var(--surface) 72%, transparent)", borderStyle: "solid", borderTopColor: "var(--line)", borderBottomColor: "var(--line)", borderLeftColor: "var(--line)", borderRightColor: "var(--line)", borderTopWidth: 1, borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderRadius: 10, padding: "12px 14px", opacity: 0.95 },
  binItemIcon: { width: 38, height: 38, borderRadius: 9, background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  binItemName: { fontFamily: arab, fontWeight: 700, fontSize: 14.5, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  binItemDate: { fontFamily: arab, fontSize: 14, color: "var(--muted)", marginTop: 2 },
  miniBtn: { display: "inline-flex", alignItems: "center", gap: 4, fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 7, padding: "5px 10px", cursor: "pointer", whiteSpace: "nowrap" },
  miniBtnDanger: { color: "#ff8585", borderColor: "rgba(255,107,107,0.35)" },

  /* خيارات المشروع */
  optBtn: { display: "flex", alignItems: "center", gap: 10, width: "100%", fontFamily: arab, fontWeight: 700, fontSize: 15, color: "var(--text)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, padding: "14px 16px", cursor: "pointer", transition: "border-color .15s, background .15s" },
  optDanger: {},
  confirmText: { fontFamily: arab, fontSize: 15, lineHeight: 1.9, color: "var(--muted)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, padding: "16px 18px", marginBottom: 20 },

  /* رسالة عابرة */
  titlebar: { position: "sticky", top: 0, zIndex: 60, height: 46, display: "flex", alignItems: "center", justifyContent: "center", paddingLeft: 84, background: "linear-gradient(90deg, #e8ff00 0%, #c6f700 45%, #14b8a6 100%)", borderBottom: "2px solid #0b3b36", boxShadow: "0 3px 20px rgba(232,255,0,0.5)", userSelect: "none", cursor: "default" },
  titlebarBrand: { fontFamily: arab, fontWeight: 800, fontSize: 19, color: "#0b3b36", whiteSpace: "nowrap", textShadow: "0 0 10px var(--surface)" },
  homeRow: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px clamp(16px,4vw,40px) 0" },
  folderBtn: { display: "inline-flex", alignItems: "center", gap: 7, fontFamily: arab, fontWeight: 600, fontSize: 14, color: "var(--text)", background: "var(--surface)", border: "none", borderRadius: 10, padding: "9px 15px", cursor: "pointer" },
  homeBtn: { width: 78, height: 78, borderRadius: "50%", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", boxShadow: "0 6px 20px rgba(27,36,64,0.16)", cursor: "pointer", padding: 0 },
  savePill: { position: "fixed", bottom: 22, left: 22, zIndex: 55, fontFamily: arab, fontWeight: 600, fontSize: 14, color: "var(--muted)", background: "color-mix(in srgb, var(--surface) 92%, transparent)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 999, padding: "7px 15px", boxShadow: "0 4px 14px rgba(27,36,64,0.10)", backdropFilter: "blur(6px)" },
  savePillOk: { color: "#8a1c3b", borderColor: "rgba(26,156,91,0.35)" },
  savePillErr: { color: "#e23d3d", borderColor: "rgba(226,61,61,0.4)" },
  toast: { position: "fixed", bottom: 26, left: "50%", transform: "translateX(-50%)", zIndex: 60, fontFamily: arab, fontWeight: 600, fontSize: 14, color: "#0b1020", background: `linear-gradient(135deg, #f0ff66, #e8ff00)`, borderRadius: 999, padding: "11px 24px", boxShadow: "0 8px 22px rgba(232,255,0,0.35)" },

  overlay: { position: "fixed", inset: 0, background: "rgba(27,36,64,0.45)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)", animation: "tmFadeIn .18s ease both", display: "flex", alignItems: "center", justifyContent: "center", padding: "clamp(8px, 2.5vw, 20px)", zIndex: 50 },
  modal: { width: "100%", maxWidth: 460, maxHeight: "92dvh", overflowY: "auto", animation: "tmModalIn .24s cubic-bezier(.16,1,.3,1) both", background: "color-mix(in srgb, var(--surface) 66%, transparent)", backdropFilter: "blur(18px)", WebkitBackdropFilter: "blur(18px)", border: `1px solid ${"var(--lineHi)"}`, borderRadius: 0, padding: "clamp(14px, 4vw, 26px)", boxShadow: "4px 4px 0 color-mix(in srgb, var(--accent) 25%, transparent)" },
  modalHead: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 },
  modalTitle: { fontFamily: arab, fontWeight: 700, fontSize: 23, color: "var(--text)", margin: 0 },
  closeBtn: { background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", color: "var(--muted)", borderRadius: 8, width: 34, height: 34, display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer" },
  preview: { cursor: "default", marginBottom: 22, animation: "none" },

  checkRow: { display: "flex", alignItems: "center", gap: 9, fontFamily: arab, fontSize: 14, color: "var(--text)", cursor: "pointer", margin: "4px 0 16px", userSelect: "none" },
  checkbox: { width: 18, height: 18, accentColor: "var(--accent)", cursor: "pointer", flexShrink: 0 },
  notesWrap: { background: "var(--surface)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 14, padding: "14px 16px", marginBottom: 22 },
  notesHead: { display: "flex", alignItems: "center", gap: 8, marginBottom: 12 },
  notesTitle: { fontFamily: arab, fontWeight: 800, fontSize: 14, color: "var(--text)", flex: 1 },
  noteRow: { display: "flex", alignItems: "center", gap: 10, fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", borderRadius: 9, padding: "9px 12px", cursor: "pointer", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", marginBottom: 0 },
  noteRowDone: { background: "rgba(20,184,166,0.07)", borderColor: "rgba(20,184,166,0.32)" },
  noteDone: { fontFamily: arab, fontSize: 14, color: "var(--accent)", fontWeight: 700, flexShrink: 0 },
  label: { display: "block", fontFamily: arab, fontSize: 14, color: "var(--muted)", marginBottom: 7, marginTop: 4 },
  groupTitle: { fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--accent)", letterSpacing: 0.5, margin: "18px 0 10px", paddingBottom: 6, borderBottom: `1px solid ${"var(--line)"}` },
  dRow: { display: "flex", alignItems: "baseline", gap: 12, padding: "7px 0", borderBottom: `1px dashed ${"var(--line)"}` },
  dLabel: { fontFamily: arab, fontSize: 14, color: "var(--muted)", minWidth: 150 },
  dVal: { fontFamily: arab, fontSize: 14, color: "var(--text)", fontWeight: 600, flex: 1 },
  coversRow: { display: "flex", gap: 12, marginBottom: 8 },
  coverProGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 18, marginTop: 6 },
  coverProCard: { position: "relative", borderRadius: 16, overflow: "hidden", cursor: "pointer", background: "color-mix(in srgb, var(--surface) 62%, transparent)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", boxShadow: "0 10px 30px rgba(27,36,64,0.16)" },
  coverProImgWrap: { position: "relative", width: "100%", aspectRatio: "3 / 4", overflow: "hidden", background: "#0d1b2a" },
  coverProBg: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", filter: "blur(22px) brightness(0.5)", transform: "scale(1.18)" },
  coverProImg: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" },
  coverProEmpty: { position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, background: "var(--surfaceHi)" },
  coverProOverlay: { position: "absolute", left: 0, right: 0, bottom: 0, padding: "34px 16px 14px", background: "linear-gradient(to top, rgba(7,12,24,0.94) 14%, rgba(7,12,24,0.55) 58%, rgba(7,12,24,0) 100%)", textAlign: "right" },
  coverProAuthor: { fontFamily: arab, fontWeight: 800, fontSize: 17, color: "#ffffff", lineHeight: 1.3, textShadow: "0 1px 6px rgba(0,0,0,0.55)" },
  coverProLang: { fontFamily: arab, fontWeight: 700, fontSize: 14, color: "#5eead4", marginTop: 3, textShadow: "0 1px 6px rgba(0,0,0,0.55)" },
  coverBox: { flex: 1, textAlign: "center" },
  coverCap: { display: "block", fontFamily: arab, fontSize: 14, color: "var(--muted)", marginBottom: 6 },
  coverImg: { width: "100%", height: 150, objectFit: "cover", borderRadius: 10, borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", cursor: "pointer" },
  coverEmpty: { height: 150, borderRadius: 10, border: `1px dashed ${"var(--lineHi)"}`, background: "var(--surface)", display: "flex", alignItems: "center", justifyContent: "center" },
  trashRow: { display: "flex", alignItems: "center", gap: 8, padding: "8px 0", borderBottom: `1px dashed ${"var(--line)"}` },
  fileConfirm: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, flexWrap: "wrap", marginTop: 8, background: "rgba(226,61,61,0.06)", border: "1px solid rgba(226,61,61,0.25)", borderRadius: 8, padding: "10px 12px", fontFamily: arab, fontSize: 14, color: "var(--text)" },
  row: { display: "flex", gap: 12, alignItems: "flex-start" },
  langLine: { fontFamily: arab, fontSize: 14, color: "var(--accent)", fontWeight: 600 },
  metaMini: { display: "flex", flexDirection: "column", gap: 2, fontFamily: arab, fontSize: 14, color: "var(--muted)", textAlign: "center" },

  viewBar: { position: "relative", zIndex: 2, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 22 },
  viewLabel: { fontFamily: arab, fontWeight: 700, fontSize: 14, color: "var(--text)", marginLeft: 4 },
  viewHint: { fontFamily: arab, fontSize: 14, color: "var(--faint)", marginRight: "auto" },
  segBtn: { fontFamily: arab, fontSize: 14, color: "var(--muted)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 999, padding: "6px 16px", cursor: "pointer", transition: "all .15s" },
  segBtnOn: { color: "var(--text)", fontWeight: 700 },
  groupHead: { position: "relative", zIndex: 2, display: "flex", alignItems: "center", gap: 10, marginBottom: 12 },
  groupPill: { fontFamily: arab, fontWeight: 600, fontSize: 14, borderWidth: 1, borderStyle: "solid", borderRadius: 4, padding: "2px 9px", background: "rgba(232,255,0,0.14)" },
  groupValue: { fontFamily: arab, fontWeight: 700, fontSize: 17, color: "var(--text)" },
  groupCount: { fontFamily: mono, fontSize: 14, color: "var(--muted)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 999, padding: "1px 9px" },
  input: { width: "100%", boxSizing: "border-box", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 8, padding: "11px 14px", color: "var(--text)", fontSize: 15, fontFamily: arab, marginBottom: 18, outline: "none", colorScheme: "light" },
  tagRow: { display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 18 },
  tagOpt: { fontFamily: arab, fontSize: 14, color: "var(--text)", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 6, padding: "7px 14px", cursor: "pointer" },
  iconGrid: { display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 8, marginBottom: 18 },
  iconOpt: { aspectRatio: "1 / 1", background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "border-color .15s, background .15s" },
  swatchRow: { display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 26 },
  swatch: { width: 34, height: 34, borderRadius: "50%", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  modalFoot: { display: "flex", gap: 12, justifyContent: "flex-start" },
  cancelBtn: { fontFamily: arab, fontSize: 15, color: "var(--muted)", background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 8, padding: "11px 22px", cursor: "pointer" },
  saveBtn: { display: "inline-flex", alignItems: "center", gap: 7, fontFamily: arab, fontWeight: 700, fontSize: 15, color: "#0b1020", background: `linear-gradient(135deg, #f0ff66, #e8ff00 55%, #c5e000)`, border: "none", borderRadius: 8, padding: "11px 26px" },
};

const SF = {
  slot: { marginBottom: 16 },
  slotLabel: { display: "block", fontFamily: arab, fontSize: 14, color: "var(--muted)", marginBottom: 7 },
  chip: { display: "flex", alignItems: "center", gap: 8, background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", borderRadius: 9, padding: "8px 10px" },
  thumb: { width: 36, height: 36, objectFit: "cover", borderRadius: 6, borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)" },
  fileIco: { display: "flex" },
  fileName: { flex: 1, minWidth: 0, fontFamily: arab, fontSize: 14, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", direction: "ltr", textAlign: "left" },
  fbtn: { background: "transparent", borderWidth: 1, borderStyle: "solid", borderColor: "var(--line)", color: "var(--muted)", borderRadius: 7, width: 30, height: 30, display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 },
  upBtn: { display: "inline-flex", alignItems: "center", gap: 7, fontFamily: arab, fontSize: 14, fontWeight: 600, background: "var(--surface)", borderWidth: 1, borderStyle: "solid", borderRadius: 9, padding: "9px 16px", cursor: "pointer" },
};

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=IBM+Plex+Mono:wght@400;600&family=Tajawal:wght@400;500;700;800&family=Cairo:wght@600;700;800&display=swap');
* { box-sizing: border-box; }

.pm-stripes { display: none; }

.shimmer { background: linear-gradient(90deg, ${"var(--accent)"}, #e8ff00, #0d9488, #e8ff00, ${"var(--accent)"}); background-size: 220% 100%; -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; filter: drop-shadow(0 2px 8px rgba(0,0,0,.45)); animation: nameGlow 5s ease-in-out infinite, pmGlow 2.6s ease-in-out infinite; }
@keyframes nameGlow { 0% { background-position: 0% 50% } 50% { background-position: 100% 50% } 100% { background-position: 0% 50% } }
@keyframes pmGlow { 0%, 100% { filter: drop-shadow(0 0 4px rgba(20,184,166,0.45)); } 50% { filter: drop-shadow(0 0 16px rgba(232,255,0,0.85)) drop-shadow(0 0 6px rgba(20,184,166,0.5)); } }

.fade-in { animation: fadeIn .45s ease both; }
@keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
@keyframes rise { from { opacity: 0; transform: translateY(14px) } to { opacity: 1; transform: translateY(0) } }
.modal-pop { animation: pop .3s cubic-bezier(.2,.8,.3,1.1) both }
@keyframes pop { from { opacity: 0; transform: scale(.94) translateY(10px) } to { opacity: 1; transform: scale(1) translateY(0) } }

.pm-enter:hover { transform: translateY(-2px); box-shadow: 0 0 34px rgba(242,92,184,0.55), 0 12px 32px rgba(0,0,0,0.55) }
.pm-card:hover { transform: translateY(-4px); }
.add-card:hover { background: color-mix(in srgb, var(--surface) 80%, transparent); }

/* إطار قوس قزح المضيء المتحرّك عند التمرير على أي بطاقة */
.pm-card::before, .pm-card::after {
  content: ''; position: absolute; border-radius: 14px; pointer-events: none;
  background: var(--card-glow);
  background-size: 300% 100%;
  opacity: 0; transition: opacity .35s ease;
  animation: rainbowMove 3s linear infinite; animation-play-state: paused;
}
.pm-card::before { inset: -4px; filter: blur(11px); z-index: -1; }      /* توهّج خلفي */
.pm-card::after {
  inset: -2px; padding: 2px; z-index: 1;
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor; mask-composite: exclude;
}                                                                        /* الإطار الحاد */
.pm-card:hover::before { opacity: .7; animation-play-state: running; }
.pm-card:hover::after  { opacity: 1;  animation-play-state: running; }
@keyframes rainbowMove { to { background-position: 300% 50%; } }
.ghost:hover { border-color: ${C.pink}; color: ${C.pinkSoft} }
.icon-opt:hover { border-color: ${"var(--lineHi)"} }
.swatch:hover { transform: scale(1.08) }
.save-btn:hover { filter: brightness(1.06) }
.btn-del:hover { color: ${C.pink} !important }
.opt-btn:hover { border-color: ${"var(--lineHi)"}; background: ${"var(--surfaceHi)"} }
.opt-danger:hover { border-color: rgba(255,107,107,0.5) !important; background: rgba(255,107,107,0.08) !important }
.mini-btn:hover { border-color: ${"var(--lineHi)"}; color: ${C.pinkSoft} }
.seg-btn { position: relative; overflow: hidden; -webkit-user-select: none; user-select: none; -webkit-tap-highlight-color: transparent; }
.seg-btn:hover { transform: translateY(-2px); border-color: var(--accent) !important; color: var(--text); box-shadow: 0 8px 20px color-mix(in srgb, var(--accent) 24%, transparent) }
.seg-btn:active { transform: translateY(0) scale(.97) }
.seg-btn::after { content: ""; position: absolute; top: 0; left: -70%; width: 45%; height: 100%; background: linear-gradient(110deg, transparent, color-mix(in srgb, var(--accent) 20%, transparent), transparent); transform: skewX(-18deg); pointer-events: none; transition: left .5s ease }
.seg-btn:hover::after { left: 130% }
.mk-banner:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(27,36,64,0.12) }
.toast-pop { animation: toastIn .35s cubic-bezier(.2,.8,.3,1.1) both }
@keyframes toastIn { from { opacity: 0; transform: translate(-50%, 14px) } to { opacity: 1; transform: translate(-50%, 0) } }

input::placeholder { color: ${"var(--faint)"} }
::-webkit-scrollbar { width: 8px }
::-webkit-scrollbar-thumb { background: ${"var(--line)"}; border-radius: 8px }
`;
